<script lang="ts" setup></script>
<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="fill-rule: evenodd; clip-rule: evenodd"
  >
    <rect
      x="341.3"
      y="0"
      width="170.7"
      height="512"
      style="fill: #575757; fill-rule: nonzero"
    />
    <rect
      x="170.7"
      y="0"
      width="170.6"
      height="512"
      style="fill: #fff; fill-rule: nonzero"
    />
    <rect
      x="0"
      y="0"
      width="170.7"
      height="512"
      style="fill: #3a3a3a; fill-rule: nonzero"
    />
    <path
      d="M284.6,295.6l0.2,3.5l1.4,-0.9l-1,-3l-0.6,0.4Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <circle
      cx="284.5"
      cy="294.6"
      r="1.1"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M289,301.1l-2.7,-2.5l-1.2,1l3.6,2l0.3,-0.5Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M288.7,302.6c-0.4,-0.667 -0.3,-1.233 0.3,-1.7c0.6,-0.467 1.133,-0.4 1.6,0.2c0.333,0.6 0.233,1.133 -0.3,1.6c-0.6,0.4 -1.133,0.333 -1.6,-0.2l0,0.1Zm20.3,-38.9l2.7,2.6l0.4,-1.3l-2.5,-1.7l-0.6,0.4Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <circle
      cx="308.7"
      cy="263"
      r="1.1"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M316.1,265.3l-4,1.1l0.3,-1.3l3.5,-0.4l0.2,0.6Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <circle
      cx="316.8"
      cy="264.7"
      r="1.1"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M302.3,285.5l-2.5,-4l0.4,-0.1l2.9,3.3l-0.8,0.8Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <circle
      cx="299.6"
      cy="280.7"
      r="1.2"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M302.5,285.6l3.2,0.6l0.1,-0.5l-2.7,-1l-0.6,0.9Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <circle
      cx="306.6"
      cy="286.2"
      r="1.1"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M227.7,294.4c-0.067,0.667 -0.333,1 -0.8,1c-0.667,-0.067 -0.933,-0.4 -0.8,-1c0.2,-0.8 0.467,-1.133 0.8,-1c0.533,0.2 0.8,0.533 0.8,1Zm-0,1.8l0.7,4l-1,-0.3l-0.3,-3.5l0.6,-0.2Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M228.6,294.9c0.4,0.6 -0.3,1.5 -1.2,1.7c-0.8,0.3 -1.9,-0.1 -1.9,-0.9c0,-0.8 1.3,-0.4 1.6,-0.5c0.5,-0.2 1,-1 1.5,-0.3Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <ellipse
      cx="221.6"
      cy="301"
      rx="1.3"
      ry="0.9"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M223.7,300.8l3.9,-0.2l-0.7,-0.8l-3.2,0.4l-0,0.6Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M224,300.4c0.4,1 0.4,2.3 -0.7,2.1c-1.1,-0.2 -0.9,-1.1 -1,-1.5c-0.1,-0.7 -0.8,-1.3 -0.1,-2c0.6,-0.6 1.5,0.4 1.8,1.4Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <ellipse
      cx="211.5"
      cy="279.4"
      rx="0.8"
      ry="1.1"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M211.5,281.9l0.1,3.7l-1,-0.9l0.1,-3l0.8,0.2Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M213,280.8c0.2,0.8 -1.1,1.3 -2,1.1c-0.933,-0.133 -1.367,-0.6 -1.3,-1.4c0,-0.7 1.2,-0.6 1.5,-0.4c0.4,0.3 1.5,-0.6 1.8,0.7Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <ellipse
      cx="204.9"
      cy="285.2"
      rx="1.3"
      ry="0.6"
      style="fill: #acacac; stroke: #777; stroke-width: 0.2px"
    />
    <path
      d="M207.3,285.2l2.9,-0.2l1.2,1l-4.2,-0.2l0.1,-0.6Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M206.2,283.6c0.8,0 1.3,0.9 1.2,1.8c-0,1 -0.8,1.7 -1.5,1.6c-0.8,-0.1 -0.7,-0.8 -0.7,-1l0.5,-0.8c-0,-0.3 -0.2,-1 -0.1,-1.2c-0,-0.267 0.2,-0.4 0.6,-0.4Zm-2.4,-22.7c-0.3,0.6 -1,1 -1.2,0.7c-0.267,-0.333 -0.233,-0.8 0.1,-1.4c0.333,-0.6 0.733,-0.8 1.2,-0.6c0.267,0.267 0.267,0.7 -0,1.3l-0.1,-0Zm-3.2,5.9l1.6,-3.9l-0.2,-0.2l-1.9,2.7l0.5,1.4Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M202,263c-0.8,-0.667 -1.067,-1.3 -0.8,-1.9c0.3,-0.5 0.9,-0.2 0.9,-0.2l0.7,0.7c0.2,0.1 0.7,-0.1 1,0.4c0.267,0.6 0.267,0.933 0,1c-0.592,0.32 -1.308,0.32 -1.9,0l0.1,0Zm-6.9,-0.6c0.667,0.467 0.9,0.9 0.7,1.3c-0.2,0.4 -0.667,0.4 -1.4,0c-1,-0.6 -0.9,-0.8 -0.7,-1.2c0.333,-0.4 0.8,-0.4 1.4,0l0,-0.1Zm1.7,1.7l3,1.8l0,1.5l-3.3,-2.8l0.3,-0.5Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M196.8,264.5c-0.667,0.667 -1.267,0.833 -1.8,0.5c-0.6,-0.3 -0.1,-0.9 -0.1,-0.9l0.6,-0.6c0.2,-0.3 0,-0.8 0.6,-1c0.6,-0.267 0.933,-0.2 1,0.2c0.1,0.3 0.3,1.2 -0.3,1.8Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M285.3,295.8l-0.4,0.4l-0.2,0.7l0,-1.1l0.4,-0.3l0.2,0.3Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M285.4,295c-0,0 -0.2,0.5 -0.9,0.5c-0.667,0 -1,-0.233 -1,-0.7l0.1,-0.9l-0.3,0.4l-0,0.7l0.5,0.6l0.4,0l0.4,0.1l0.5,-0.2l0.3,-0.2l-0,-0.3Zm3.4,6l-0.6,-0l-2.7,-1.4l3,2l0.3,-0.6Zm1.9,0.8c-0,-0 -0,0.6 -0.6,0.8c-0.6,0.267 -1,0.267 -1.2,-0c-0.279,-0.25 -0.396,-0.637 -0.3,-1l-0.1,0.5l0.3,0.6l0.6,0.3l0.5,-0l0.3,-0.2l0.4,-0.4l0.2,-0.4l-0.1,-0.2Zm19.4,-38l0,0.8l-0.7,-0.7l0.3,-0.4l0.4,0.3Zm-0.3,-1c0,0.5 -0.8,1.3 -1.3,1c-0.667,-0.267 -0.9,-0.733 -0.7,-1.4l-0.2,0.3l0.1,0.8l0.6,0.5l0.6,-0l0.6,-0.2l0.3,-0.6l-0,-0.4Zm8,1.4c-0,-0 -0.1,-0.3 -0,-0c-0,0.5 -0.5,1.4 -1.1,1.3c-0.667,-0.133 -0.967,-0.5 -0.9,-1.1l-0,0.8l0.3,0.3l0.5,0.3l0.5,-0l0.6,-0.4l0.2,-0.5l-0,-0.3l-0.1,-0.4Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M315,264.9c0,0 0,0.2 -0.3,0.4l-1,0.6l2.2,-0.6l-0.2,-0.6l-0.7,0.2Zm-13.6,17.9l-0.2,0.4l0,0.6l-1.2,-2l0.4,-0.2l1,1.2Zm-0.7,-2c-0.3,0.6 -1.2,1 -1.6,0.7c-0.4,-0.3 -0.8,-1.2 -0.3,-1.6l-0.3,0.2l-0.1,0.6l0.2,0.5l0.4,0.5l0.4,0.2l0.7,-0.2l0.5,-0.3c0,0 0.3,-1 0,-0.5l0.1,-0.1Zm4.4,4.7c0,0 0,0.2 -0.4,0.2l-1.2,0l2,0.4l0.2,-0.4l-0.6,-0.2Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M307.7,286c0.2,0.7 -0.4,1.4 -1.2,1.1c-0.8,-0.3 -1,-1 -0.8,-1.5l-0.2,0.6l0.2,0.6l0.5,0.4l0.5,0.2l0.5,-0.2l0.5,-0.5l0.1,-0.6l0,-0.1l-0.1,0Zm-79.2,8.9c0.2,0.2 -0.1,1.2 -1,1.5c-0.9,0.3 -1.4,0 -1.6,-0.3l-0.2,-0.6l-0.2,0.2l0.2,0.4l0.4,0.4l0.8,0.2l0.6,-0.1l0.6,-0.3l0.3,-0.3l0.3,-0.4l0,-0.5l-0.1,-0.2l-0.1,0Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M227.7,296.9l-0.3,0.3l-0.2,0.6l-0,-1l0.4,-0.3l0.1,0.4Zm-3,3.2c-0,-0 -0.1,0.2 0.1,0.4l0.8,0.2l-1.4,-0l-0.2,-0.5l0.7,-0.1Zm-0.5,1l-0.1,0.5c-0.133,0.467 -0.4,0.7 -0.8,0.7c-0.436,-0.088 -0.764,-0.456 -0.8,-0.9l-0.2,-0.5l-0,0.5l0.3,0.8l0.6,0.3l0.4,0l0.4,-0.2l0.2,-0.5l-0,-0.8l-0,0.1Zm-3.8,-0.2c-0,-0 0.2,0.7 1,0.7l1,-0.2l-0,0.3l-0.3,0.1l-0.6,0.1l-0.6,-0.1l-0.3,-0.2l-0.2,-0.4l-0,-0.3Zm-7.5,-20.3l-0,0.3c-0.1,0.3 -0.6,0.9 -1.5,0.9c-0.8,-0 -1.267,-0.2 -1.4,-0.6c-0.267,-0.4 -0.367,-0.633 -0.3,-0.7l-0,0.5l0.3,0.5l0.9,0.4l0.8,-0l0.8,-0.2l0.4,-0.4l-0,-0.7Zm-1.4,1.8l-0.5,0.2l-0.3,0.3l-0,-1l0.8,-0l-0,0.6l-0,-0.1Zm-3.8,2.8l0.4,0.3c0.4,0.2 2.5,0.4 2.5,0.4l-3.3,-0.1l0.2,-0.6l0.2,-0Zm-0.3,-0l-0.2,0.5c-0.2,0.3 -0.6,1.2 -1.3,1.1c-0.7,-0.1 -0.6,-0.6 -0.6,-0.7l-0,-0.2l-0.1,0.5l0.2,0.3l0.2,0.2l0.6,-0l0.4,-0.1l0.4,-0.4l0.2,-0.4l0.2,-0.5l0,-0.3Zm-1.8,0.1c0,-0 0,0.2 -0.6,0.2l-1.3,-0.2l0.3,0.3l0.4,0.1l1,-0l0.2,-0.4Zm-1.7,-23c0,-0 0.1,0.3 -0.2,0.5c-0.4,0.267 -0.867,0.3 -1.4,0.1c-0.4,-0.2 -1.2,-1 -1.2,-1l0.4,0.6l0.5,0.5l0.8,0.2l0.8,-0l0.3,-0.4l0.1,-0.2l-0.1,-0.3Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M201.6,263.3l0,0.4l-0.1,1l0.6,-1.6l-0.2,-0.2l-0.3,0.4Zm-4.3,1.2l0.1,0.3c0.2,0.5 2,2.1 2,2.1l-2.8,-2.2l0.3,-0.5l0.4,0.3Zm-0.9,0.2l-0.7,0.3c-0.2,0 -0.8,0 -0.8,-0.4l0,-0.5l-0.2,0.5l0.1,0.3l0.4,0.2l0.6,0l0.5,-0.2l0.1,-0.1l0,-0.1Zm-1,-1.1l-0.6,0c-0.5,0 -1,-0.6 -1,-0.6l0.3,0.6l0.9,0.4l0.4,-0.4Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M319.9,256.1c-0.3,3 -3.3,4.7 -4.9,5.8c-0.928,0.709 -1.709,1.592 -2.3,2.6l-0.6,1.8l-0.2,1.1l-0,0.4l0.2,1.7l-0.1,3.4l2.1,-1.5l1.6,-0.6l0.4,0c-0,0 -1.7,1.6 -2.3,3.4c-0.7,1.9 -2,5.8 -4.3,7c-2.3,1.2 -3.8,0.8 -4.6,1.5l-0.8,0.9l-1,1.3l-0.8,1l-0.7,0.6l-0.5,0.3l-0.2,1.4l-0.5,1.9l1,-0.4l1.1,0l-0.6,1c-0.1,0.5 0.1,3.7 -2.9,5.6c-3,1.9 -10.7,1.6 -10.7,1.6l-1.4,0.6l-1.4,1l-1.2,1.4l-0.1,0.3c-0,0 -1,1.2 -1.7,1.6l-2.2,1.5l1.8,0.1l2.8,1.2c-0,0 -1.8,0 -3,0.4c-1.2,0.4 -6.5,3.5 -9,3.4c-2.7,0 -6.4,-3.8 -6.4,-3.8l-1.6,-1.2l-2.8,-0.6l-3.5,-0.2l-0,-0.4l0.1,-0.6l3,0.1c1.7,0.2 2.2,0.8 3.6,1c0.944,0.124 1.904,0.021 2.8,-0.3l4.7,-3.8l4.7,-1.6l1.8,0.2l0.8,0.2l0.7,0.2l-0.8,1l-1.2,0.7l0.6,0.5l3,-0.5l1,0.3l0.2,0.1l0.4,-1c0.4,-0.5 2,-1.8 2.8,-2.3c0.667,-0.4 1,-0.667 1,-0.8c0.3,-0.2 1.3,-2.7 1.3,-2.7l0.1,-1.3l3.3,-3.1l2.2,-2.4l1,-2.7l-0.1,-0.5c-0,0 0.7,0.8 0.6,2.5c-0.2,1.6 -0.367,2.333 -0.5,2.2c-0.2,-0.2 2.2,-1.5 3.4,-2c1,-0.4 1.667,-0.533 2,-0.4c0.638,-0.375 1.184,-0.888 1.6,-1.5c0.7,-1 0.8,-1.2 0.8,-1.6l0.1,-2.2l-0.2,-5.7l2,-4.2l2.8,-2.5l0.5,-0.3l-0.3,1l-0,1c-0,0 1.4,-1.8 2.1,-2.2l0.5,-0.2l0.6,-1.6c0.2,-1 0.2,-2.5 0.2,-2.5l-0,-2.3l-0.4,-1.8l-1.3,-3.5l-0,-4.6l-1,-1.3c-0,0 0.9,-0.1 2,1.5c0.757,1.222 1.266,2.581 1.5,4l2.7,-8.1c-0,0 0.7,1 1.2,2.5l0.7,2.7l1,-2.2l0.1,0.8c0.2,0.7 1.8,1.7 1.6,4.7m-53.8,52c-0,0 -0.6,-1.2 -3.1,-2.5c-1.431,-0.686 -2.943,-1.19 -4.5,-1.5l-0,1l4,1.7l2,1.6l1.6,-0.3Z"
      style="fill: #8c8c8c; fill-rule: nonzero"
    />
    <path
      d="M284.3,300.5c1.052,-1.068 2.227,-2.008 3.5,-2.8c0.821,-0.379 1.7,-0.615 2.6,-0.7c1.5,-0.3 1.7,0 5.2,-2c3.5,-2 4.3,-4.1 5,-4.7c0.7,-0.5 1.9,-0.7 1.9,-0.7l-2.7,3.2c-1.3,1.4 -2.7,2.3 -4.7,3.6c-2,1.3 -6,1.4 -6,1.4c-1.252,0.204 -2.407,0.799 -3.3,1.7c-1,0.8 -1.6,1.7 -1.6,1.7c0,0 -0.2,-0.4 0,-0.7l0.1,0Zm9.7,-10.2c-3.3,3 -4.3,5.8 -4.3,5.8l4.3,-4c1.5,-1.4 3.6,-2 4.5,-3c1,-0.8 1,-1.5 1.6,-2l1,-0.9c0,0 -1.4,-1 -7.1,4.1m-6.9,6.9c0,0 1.4,-0.6 2,-1.9c0.3,-0.9 0.1,-1.1 0.7,-2.2c0,0 3.4,-3.2 4.6,-4.6c2.1,-2.5 1.2,-4.6 1.2,-4.6c0,0 0.2,1 -0.7,2.2c-0.9,1 -5.2,4 -5.8,5.8c-0.6,1.8 -0.2,1.7 -0.4,2.7c-0.6,2 -1.6,2.6 -1.6,2.6m-2.2,8.4c0,0 -1.7,-1.1 -3.6,-1c-3.9,0.3 -7.2,2.6 -9.7,2.7c-2.6,0 -3.6,-1.2 -5.6,-2.6c-2.1,-1.4 -7.3,-1.2 -7.3,-1.2l0,0.1l-0.1,0.2c0,0 3.6,0 5.1,0.4c3,0.9 4.5,4 7.9,3.7c4.3,-0.2 7.8,-2.9 9.6,-2.9c3,0 3.7,0.6 3.7,0.6m-19.3,-2c0,0 3,0.6 5.4,-1.1c2.3,-1.7 5.1,-4 6.6,-4.1c1.6,-0.1 3.2,0.3 3.2,0.3c0,0 -2,-1 -3.5,-0.9c-1.604,-0.05 -3.192,0.33 -4.6,1.1c-1.5,0.9 -2.2,2.5 -3.8,3.5c-1.6,1 -3.3,1.3 -3.3,1.3l0,-0.1Zm-0.5,4.1l-1,0.2c-0.2,0 -1,-1 -2.4,-1.6c-1.4,-0.6 -3.2,-1.1 -3.2,-1.1c0,0 -0.2,0 0.2,0.2l3,1.1c0.849,0.443 1.598,1.056 2.2,1.8c0,0.1 0.4,0.6 1.2,0.6c0.667,-0.133 1,-0.367 1,-0.7c-0.2,-0.333 -0.533,-0.5 -1,-0.5m2.1,-3c0,0 1.2,0.8 3.2,0.7c4.2,0 6.8,-3 9.6,-4c2.8,-1 4.2,-0.2 4.2,-0.2l0,-0.2c-0.921,-0.613 -1.994,-0.959 -3.1,-1c-4.6,0.1 -9,3 -10.9,3.8c-1.933,0.733 -2.933,1.067 -3,1l0,-0.1Zm44.8,-31.7c-1.5,1.5 -3.6,6.2 -4.5,7.4c-1,1.3 -2.1,1.7 -2.6,2.2l-2.5,3.3c-0.4,0.6 -0.5,0.4 -0.8,0.6c-0.333,0.267 -0.333,0.333 0,0.2c0.5,-0.1 0.6,-0.4 1.3,-1.2c0.7,-0.8 0.7,-1.2 1.8,-2.2c1.1,-1 3.1,-2.1 4.1,-3.3c1,-1.3 3,-6 4.2,-7.2c1.1,-1.2 3.1,-2 3.1,-2c0,-0 -1.6,-0.4 -4.1,2.2m-7.2,8.9c0,-0 0,-0.9 1,-2.1c1,-1.2 1.4,-1 2.2,-2.9l1.9,-5.5c0.6,-2 1.8,-3.8 1.8,-3.8c0,-0 -1.1,-0 -2.2,1.6c-1.594,2.14 -2.873,4.498 -3.8,7c-1,2.6 -1,5.7 -1,5.7l0.1,-0Zm-1.4,1.8c0,-0 0.4,-0.3 0.5,-2.6c0.1,-2.3 -0.1,-5.6 0.5,-7.3c0.7,-1.6 4.3,-5.5 4.3,-5.5c0,-0 -1.5,0.3 -3.6,2c-2,1.8 -2.933,3.567 -2.8,5.3c0,1.6 1,3.4 1,5l0.1,3l0,0.1Zm8.5,-16.2l1.2,-4c0.4,-0.7 0.4,-1.2 2.2,-3.2c1,-1.1 2,-1.9 2.5,-3.5c0.5,-1.6 0.4,-6.1 0.4,-6.1c0,-0 -0.5,0.4 -0.8,1.2c-0.3,0.8 -0.1,3.7 -0.8,5c-0.7,1.4 -2.2,4.6 -3,5.3c0,-0 -0.1,-2.3 0.1,-4.6c0.2,-2.3 1,-3 1.4,-4.5c0.4,-1.5 0.2,-5.4 0.2,-5.4c0,-0 -1.3,1.2 -1.9,2.7c-0.6,1.5 -1,4 -1,6c0,2 0.5,3.6 0.6,4.7c0.1,1.1 0.1,1.7 -0.3,2.9l-0.5,1.6l-0.6,2l0.3,-0.1Zm-2.8,-17.2c0,-0 1,1.3 0.9,2.9c-0.2,1.5 -0.8,3.6 -0.2,5.2c0.6,1.6 1.5,1.7 1.8,2.7c0.2,0.9 0.2,2.7 0.2,2.7c0,-0 0.5,-3.4 0.2,-4.4c-0.4,-1 -0.5,-0.5 -1,-1.5c-0.5,-1 0,-3.7 -0.4,-5.3c-0.213,-0.919 -0.744,-1.734 -1.5,-2.3"
      style="fill: #5e5e5e; fill-rule: nonzero"
    />
    <path
      d="M245.4,307.9c0,-0 0.3,-1 2.5,-2c2.2,-1 5.4,-2.5 5.7,-2.3c0.4,0.2 -0.1,1.3 -0.1,1.3l-2.1,0.7l-1.7,1l-2,1.3l-2.3,-0Z"
      style="fill: #8c8c8c; fill-rule: nonzero"
    />
    <path
      d="M251,302.1c-2.9,0.1 -4.4,0.8 -5,1l-0.9,0c-0.6,-0.2 -1.2,-1.1 -1.2,-1.1l-0.6,-0.5l-0.1,2l-4,-3.6l-0.5,2.4l-0.5,1l-4,-3.8l0.1,3l-1,0l-3,-2l-0.8,0.4l1,1.7l-3.7,0.3l-0.8,0.6l-0.7,0.9l0,0.3l1.4,0c0.3,-0.2 0.5,-0.7 0.6,-0.5c0.1,0.2 0.2,1 0.7,1c0.5,-0.2 2.2,-1.4 3.4,-0.9c1.3,0.7 -1.8,1.6 -1.4,2.5c0.3,1 2.5,0.6 3,0.3c0.5,-0.3 2.3,-2.4 3,-1.6c1,1 -2,2 -1.5,3c0.6,1.1 2.2,0.9 3,0.4c0.8,-0.5 2.7,-3.3 3.1,-2.7c0.7,1 -1.6,2.1 -1,3c0.6,0.9 1.9,0 2.7,-0.7c0.8,-0.7 1.2,-2 2.4,-2.7c1.1,-0.6 1,-0.3 1.4,-0.4c0.3,0 1.2,-0.9 1.2,-0.9l2.7,-1.1l1.4,0l0.7,0.4l1.4,0.2l0.1,-1.2c0,0 -1.6,-0.7 -2.7,-0.7l0.1,0Zm-22,0l0.5,-1l-0.3,-0.5c0,0 -1,-0.5 -1.9,-1.4l-1.6,-1.3l-1.7,-1.1l-0.6,-2.3l-0.4,-0.6l-1,0.4l-1.4,-4.9l-0.3,-0.9l-0.6,0l-1.1,3l-1.3,-1.9l-0.3,-4l-0.8,0.9l-1,1l-1.8,-3.7c0,0 -0.2,0 -0.3,0.3c-0.1,0.3 -0.2,1.4 0,2.1l-2.5,-1.8c-1.667,-1.6 -2.433,-2.4 -2.3,-2.4l-0.8,-2l0.8,-1.7l0.4,-2l-1.8,0.7l-0.3,-4.6l-0.3,-1.4l-2.1,3l-0.8,-1.2l0,-3l-0.6,-0.1l-0.9,1.6c0,0 -0.8,-1.7 -1.2,-2c0.1,-0.7 0.2,-2.3 -0.2,-3.6c-0.5,-1.6 -1,-2.5 -0.9,-3.8c0.2,-1.4 0.8,-1.5 0.7,-2c0,-0.7 -1,0.3 -0.6,-0.5c0.3,-0.7 3,-2.5 2.5,-3.4c-0.6,-1 -3.3,1.4 -2.7,-0.2c0.7,-1.6 3.2,-1.6 3.4,-3.9c0,-1.3 -2.5,1 -2.7,0.2c-0.2,-0.7 1.6,-2.1 1.6,-3c0,-1 0.3,-1 -0.2,-1.5c-0.5,-0.5 -2,1.9 -2,1.9l-1.7,-0.6l-1.1,4.4l-2.1,-1.2l0.5,2.5l0.5,2.4l-2.1,-0.6l1.1,2.1l1.5,1.5l1,1.3l0.6,0.3l1,1l0.2,1.2l0.5,1.5l0.1,1.5l0,2.3l-0.1,0.8c-0.4,0 -1,-0.6 -1.3,-0.2c-0.3,0.5 1.2,1.6 1,2c-0.3,0.2 -2.6,-0.5 -2.7,0.2c-0.1,0.7 0.2,1.7 1.5,2c1.3,0.3 4.2,1 3.7,1.6c-0.5,0.6 -3.7,-1.8 -3.5,0c0.053,1.221 0.847,2.294 2,2.7c0.9,0.3 4.1,0 4,0.7c-0.3,0.7 -2.7,-0.3 -3,0.8c-0.3,1.1 1.8,1.3 2.2,1.3c0.4,0 1.7,0 2.3,0.4l3.4,3.2c1,0.9 3.1,2.3 3.7,2.7c-0.6,0 -1.9,-0.2 -2.1,0.3c-0.2,0.5 4.9,2.4 3.4,3c-1.5,0.6 -3,-1.6 -3.5,-0.3c-0.5,1.3 1,2.4 1.8,3c0.8,0.4 5.3,0 4.5,1c-1,1 -4.2,-0.7 -4.3,0.6c-0.1,1.3 2.2,3.1 3.4,3c1.1,0 2.4,-1.8 2.9,-0.8c0.5,1 -0.9,1.4 0.2,1.6c1.1,0.2 1.9,-1 3.2,-0.8c1.2,0.2 3.2,1 4.4,2l2.2,2.3l0.1,-0.1Z"
      style="fill: #8c8c8c; fill-rule: nonzero"
    />
    <path
      d="M246.7,307.3c0.667,0.133 1,0.267 1,0.4c-0,0.133 1.4,-1.1 2.7,-1.8c1.2,-0.7 3,-1 3,-1l0.2,0c-0,0 -2.3,0.7 -3.3,1.4l-2.5,1.7c-0.067,0.267 -0.533,0.433 -1.4,0.5c-0.667,-0.067 -1,-0.267 -1,-0.6c-0,-0.333 0.433,-0.533 1.3,-0.6m6.8,-3.4c-0,0 -0.7,0 -1,-0.3c-0.631,-0.391 -1.358,-0.599 -2.1,-0.6c-1.2,0.067 -2.337,0.564 -3.2,1.4c-0.863,0.836 -0.2,0.5 -1.1,1c0.333,0 0.833,-0.267 1.5,-0.8c0.882,-0.631 1.919,-1.011 3,-1.1c0.8,0 1.367,0.2 1.7,0.6c0.4,0.3 1.2,0.2 1.2,0.2l-0,-0.4Zm-40.4,-16.5l-0,-0.6c-0,0 -0.6,-0.2 -1.7,-1c-1.3,-0.7 -4.1,-2.9 -4.1,-2.9l2.3,2.1l3.2,2.3l0.3,0.1Zm28.5,20.2l1.2,-1.8c0.867,-1.133 1.367,-1.7 1.5,-1.7c-0,-0.2 -0.167,-0.6 -0.5,-1.2l-0.2,-1c-0,0 0.3,0.8 0.8,1.2l1,0.7c-0,0 1,-0.1 1,-0.3c-0,-0.2 -0.067,-0.367 -0.2,-0.5l-0.9,0c-1,-0.5 -1.4,-2 -2,-2c-0.6,-0.1 -0.2,1.6 -0.5,1.6c-1,0 -1.6,-3.5 -4,-3.6c-1.5,-0.1 -1.8,0.2 -1.9,0.6c-0.1,0.4 2,2.4 1.3,2.7c-0.7,0.3 -2.8,-3.3 -4.4,-3.3c-1.6,0 -1.7,0.5 -1.6,0.9c0.1,0.3 1.8,0.6 1.4,1.7c-0.4,1.1 -2,-1.7 -3.4,-1.5c-1.4,0.2 -1.6,0.3 -1.7,0.7c-0.1,0.4 0.5,1 0.3,1.1c-0.2,0.1 -1,0.1 -1.8,0.6c-0.7,0.5 -1.7,1.9 -1.7,1.9c-0,0 0.9,-1.4 2.2,-1.5l4.4,0l-0.9,-0.7c-0.5,-0.4 -0.9,-1.3 -0.9,-1.3l1.4,1.3l1.5,1c-0,0 1.4,0 1.5,0.2c0.133,0.2 -0.067,0.567 -0.6,1.1l-1.4,1.3l1.6,-1.2l1.2,-1c-0,0 1,0.2 1.1,0.1c0.133,0.067 -0.067,-0.367 -0.6,-1.3l-1.3,-2c-0,0 0.8,0.7 1.6,1.8c0.9,1 0.7,1.6 1,1.6l1.2,0.2c0.333,0 0.233,0.433 -0.3,1.3l-1,2l1.3,-1.6c0.6,-0.6 1,-1.4 1.2,-1.4l1.2,0l-0.7,-1.3c-0.4,-1 -0.5,-2.2 -0.5,-2.2c-0,0 0.4,1.2 1,2l1.1,1.6l1.3,0c0.067,0.267 -0.1,0.733 -0.5,1.4l-0.8,1.8Zm-17.2,-10l1.3,0.3c-0,-0 -1.3,-0.8 -1.7,-2c-0.3,-1 -0,-3.4 -0.6,-3.4c-0.6,-0 -0.9,1.8 -1.4,1.4c-0.6,-0.3 0.2,-3.5 -0.5,-4.8c-0.6,-1.4 -2,-2.3 -2.4,-1.8c-0.4,0.5 -0.2,3.4 -1.1,2.8c-0.9,-0.6 -0,-3.2 -0.2,-4.3c-0.2,-1.1 -1,-2 -1.5,-1.7c-0.5,0.3 0.2,2.4 -0.6,2.5c-0.9,-0 -0.7,-1.5 -1,-1.7c-0.3,-0.2 -0.6,0.3 -0.7,-0c-0.2,-0.3 -0.1,-1.3 -0.6,-1.2c-0.4,-0 -0.3,1 -0.2,1.4l0.6,1.4c0.1,0.3 0.8,0.7 0.7,1c-0.067,0.267 -0.333,0.4 -0.8,0.4l-1.4,-0l1.4,0.3c0.4,-0 1.2,-0.1 1.4,0.2l1.1,1.7c-0,-0 0.3,-0.7 0.4,-1.9l-0,-2.1c-0,-0 0.3,1.3 0.3,2.1l-0.3,2.4c-0,-0 0.9,0.7 0.6,1l-2.3,-0c-1,-0 -2.6,-0.3 -2.6,-0.3c-0,-0 1.4,0.6 2.4,0.8c1,0.2 3,0.2 3,0.2l1.4,1.6c-0,-0 0.7,-1.1 0.8,-2.3l-0,-2.6l0.4,2.2c-0.013,1.02 -0.181,2.031 -0.5,3l-1.5,0.8c-1,0.3 -2.9,0.5 -2.9,0.5c-0,0 1.8,0.3 3,0c1.3,-0.3 1.4,-0.7 1.8,-0.5l0.7,0.6l1,0.8l-0.8,0.5l-1.2,0.6l2.7,-0.9l0.4,0.2l-0.1,-1l-0.3,-1.4c0,0 0.5,0.6 0.6,1.3l0.1,1.2c0,0 0.1,0.2 1,0.6l0.1,0.1Zm-24.9,-28.6c-0,0 0.3,-1.4 0.3,-3c-0,-1.5 -1,-3.9 -1.3,-4.1l-0.2,-0.5l0.7,-1l-1,0.7l-1,-0.4l-0.6,-0.7l1,0.5l0.5,0.1l-0.3,-1.5l-1.6,-0.8c-1,-0.6 -2,-1.5 -2,-1.5l2.2,1.2l1.3,0.3c-0,0 0.9,-0.2 1.3,-0.5l1.3,-0.9c-0,0 -0.8,0.5 -1.4,0.6l-1.2,0.2l-0.3,-1.9l-0.9,-0.9c-0.7,-1 -1.2,-2.2 -1.2,-2.2c-0,0 0.7,0.9 1.3,1.3c0.6,0.4 1.1,1.2 1.1,1.2l1.3,-0.8l2.3,-1.6l-2.2,1l-1.3,0.6l-0,-1.2l0.6,-1.3c-0.1,-0.4 -0.4,-0.2 -0.5,-0.5l0.4,-2.1l-0,1c-0,0.4 0.133,0.633 0.4,0.7c0.4,0.1 2.6,-2.1 2.8,-2.5c0.3,-0.4 0.7,-1.5 -0.4,-1c-1.1,0.5 -0.9,1.3 -1.8,1.3c-0.3,0 -0.6,-1.2 -1,-1c-0.3,0.3 -1,1 -1.2,2c-0.2,0.8 0.2,2 -0.3,2.4c-0.5,0.4 -1,-1.4 -1.8,-1.2c-1,0.3 -1.2,1.6 -1,2c0.1,0.6 2.1,3 1.5,3.2c-0.6,0.2 -2.2,-2 -3,-0.4c-1,1.5 2.6,3.1 3,3.5c0.5,0.4 -0,0.5 0.7,1.3c0.7,0.8 1.5,1 1.9,1.5c0.4,0.5 1.7,3 1.7,4.6l-0,2.3l-0.1,-0Zm9.4,13.6c-0,-0 -0.9,-1 -0.6,-2.6c0.3,-1.6 1.5,-4.6 1,-5c-0.3,-0.4 -1.6,1.8 -1.9,1.3c-0.3,-0.5 0.7,-3.4 0.2,-4.6c-0.5,-1.2 -0.6,-2 -1.6,-1.9c-1,0.1 -1.5,3.5 -2,3c-0.5,-0.7 0.3,-2.2 -0,-3c-0.267,-0.8 -0.6,-1.133 -1,-1c-0.6,0.1 -0.8,1.7 -1.2,1.7c-0.4,-0 -1,-2 -1.7,-1.6c-0.7,0.2 1.8,3.5 1.8,3.5c-0,-0 0.5,-0.4 0.7,-1l0.5,-1.1c-0,-0 0.2,1 -0,1.5l-0.3,1.4c-0.067,0.067 -0.633,0.067 -1.7,-0c-1,-0.1 -1.9,-0.5 -1.9,-0.5c-0,-0 0.7,0.4 1.8,0.7l2.2,0.6l0.7,1l0.9,1.1l0.6,-1.6l1,-2.8c-0,-0 -0.2,2 -0.5,3l-0.5,2.5c-0,-0 -1,-0 -2.1,-0.3l-3,-0.6l3,1l2.3,0.6l1,1.4l0.8,-1.1c0.5,-0.7 0.8,-1.5 0.8,-1.5c-0,-0 -0.2,1.1 -0.5,1.8l-0.6,1.1l-1.4,0.2l-2,-0c1.169,0.371 2.377,0.605 3.6,0.7c1.223,0.095 -0,0.4 0.5,1.1l1.1,1Z"
      style="fill: #5e5e5e; fill-rule: nonzero"
    />
    <path
      d="M251.6,312.7c0,0 -0.5,-0.6 -1.2,-1l-1,-0.2l-0.3,0l0.7,-1.6l4.4,-4.3l0.7,-4.3l2.7,0l0,5.9l0.8,0.3l5,3l0,1.3l-0.8,0.3l-0.6,0.3l-1.8,0.2l-3.3,-2.4l-1.4,-1.4l-2.4,3.1l-1.6,0.8l0.1,-0Z"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M255,301.3l0,1c0,0.6 0,4 -0.2,4.5c-0.1,0.5 -2.5,1.4 -4,2.6c-1.3,1.2 -1.3,2.1 -1.3,2.1l-1.3,0.4c-0.867,0.4 -1.3,0.667 -1.3,0.8c0,0.2 0.5,-2.2 2.8,-4.1c2.2,-2 3.3,-2.2 3.5,-2.5c0.2,-0.3 0,-4.1 0,-4.4c0.133,-0.267 0.333,-0.367 0.6,-0.3l1.3,0l-0.1,-0.1Zm5.7,12.6l0.6,-0.9l0.7,-0.6l-1,-0.6c-1.3,-0.5 -2,-0.4 -2.8,-1l-1.7,-1.7l-1.2,1l1.4,1.7c0.6,0.6 2.1,0.8 2.8,1.2l1.2,1l0,-0.1Z"
      style="fill: #3b3b3b; fill-rule: nonzero"
    />
    <path
      d="M257.2,301.3l1.5,0.1l0.2,0.5c0,0.1 0,3.2 -0.2,4.2c-0.14,0.898 -0.482,1.753 -1,2.5c-0.4,0.3 -2.4,2 -3.3,3c-1,0.9 -1.9,2.2 -1.9,2.2l-0.6,-0.8l-0.6,-0.7c0.656,-1.141 1.583,-2.103 2.7,-2.8c1.5,-1 2.9,-2.2 3.1,-3.9c0.2,-1.7 0.1,-4.3 0.1,-4.3"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M266,312c0,0 -0.3,-0.3 -1.4,-0.4c-1.2,0 -1.2,0.2 -1.2,0.2c0,0 -0.7,-0.8 -1.6,-1.4c-1,-0.7 -1.8,-0.6 -2.8,-1.3c-1,-0.7 -1.6,-1.7 -1.6,-1.7l0.8,-1.6c0,0 0.9,1.3 1.8,2c0.9,0.7 3,1.3 3.7,2c0.7,0.5 2.3,2.2 2.3,2.2"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M276,293c0,0 -3,-1 -2.7,-2c0.3,-1 6.6,-2.7 6.6,-2.7l0.1,-1.7c0,0 -1,0 -2.5,0.5c-2.257,0.76 -4.619,1.165 -7,1.2c-1.533,0 -2.533,-0.1 -3,-0.3l-23.2,-1.4l-1.2,0c-3,-0.3 -4.9,-4.8 -4.9,-4.8l-1.4,0.2c0,0 0.4,2.3 -0.3,2.5c-1.5,0.4 -11.1,-4.8 -11.1,-4.8l-0.6,2.1c0,0 6,3.2 5.8,4.3c-0.2,1.2 -2,1.1 -2,1.1l0.8,1.4c0.3,0 9.7,0.5 9.9,3.3c0,1.2 -2.3,1.9 -2.3,1.9l0.8,1l0,0.4c0,0 5.2,0 6.7,0.9c1.4,0.8 2.2,2 4,3c5.197,0.817 10.484,0.885 15.7,0.2c2.1,-0.6 3.4,-3 6.9,-4c3.5,-1.1 4.6,-1.2 4.6,-1.2l0.3,-1.1Z"
      style="
        fill: #9a9a9a;
        fill-rule: nonzero;
        stroke: #606060;
        stroke-width: 0.4px;
      "
    />
    <circle
      cx="227.6"
      cy="288.6"
      r="1.7"
      style="fill: #0f0f0f; stroke: #606060; stroke-width: 0.8px"
    />
    <circle
      cx="237.2"
      cy="280.8"
      r="1.7"
      style="fill: #0f0f0f; stroke: #606060; stroke-width: 0.8px"
    />
    <circle
      cx="277.2"
      cy="293.2"
      r="1.7"
      style="fill: #0f0f0f; stroke: #606060; stroke-width: 0.8px"
    />
    <path
      d="M220.1,278.3c-0.5,1.2 1.6,3.6 3.1,3.9c1.533,0.2 2.4,-0.1 2.6,-0.9c0.2,-0.8 0.1,-1.467 -0.3,-2c-1,-1.3 -4.8,-2.3 -5.4,-1"
      style="fill: #a9a9a9; fill-rule: nonzero"
    />
    <path
      d="M224.8,280.2c0,-0.8 -1.3,-1.5 -2,-1.5c-0.7,0 -1.7,0 -1.5,0.4c0.2,0.4 2.2,1 2.2,1.2c0,0.2 -0.6,0.5 -0.3,0.8c0.4,0.2 0.767,0.167 1.1,-0.1c0.4,-0.2 0.567,-0.467 0.5,-0.8"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M238.2,294.6c0.3,1.1 -0.6,1.7 -1.7,2.2c-1.1,0.5 -3.4,0.2 -4,-0.7c-0.4,-1 1,-2.4 2.3,-2.7c1.4,-0.3 3,0.2 3.4,1.2"
      style="fill: #a9a9a9; fill-rule: nonzero"
    />
    <path
      d="M235.8,295.3c0.5,-0.1 0.5,0.6 0.9,0.6c0.4,0 0.7,-0.7 0.6,-1.1c-0.2,-0.6 -0.7,-0.933 -1.5,-1c-0.6,0 -2.4,1.6 -2.2,2c0.2,0.4 0.533,0.467 1,0.2c0.3,-0.1 0.8,-0.7 1.2,-0.7"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M279.4,288.8c1,1.4 2.8,0.1 3.3,-0.4c0.5,-0.5 2,-1.4 1.4,-2.2c-0.6,-1 -1.7,-0.9 -2.4,-0.8c-0.7,0.1 -2,1 -2.3,1.5c-0.4,0.533 -0.4,1.2 -0,2l-0,-0.1Z"
      style="fill: #a9a9a9; fill-rule: nonzero"
    />
    <path
      d="M279.7,288c0,0 0.1,-1.5 1.5,-1.6c0.7,0 0.8,0.2 1.4,0.6c0.6,0.4 0.8,-0.5 0.8,-0.5c0,0 0,1 -1,1.1c-0.9,0 -0.5,-0.4 -1.5,-0.6c-0.8,0 -1.2,1 -1.2,1"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M257.5,285.1l-0.7,-0.4l-5,0l2.7,8l3.3,4.6l1.2,0.4l2.5,-0.1l0.5,-1.3l-1,-7.6l-3.5,-3.6Z"
      style="
        fill: #a6a6a6;
        fill-rule: nonzero;
        stroke: #4d4d4d;
        stroke-width: 0.4px;
        stroke-linecap: round;
        stroke-linejoin: round;
      "
    />
    <path
      d="M248.5,285.6l0.1,-0.9l1.5,-0.1l1.7,0.1c0.1,0 2,2.3 2.5,3.8c0.6,1.4 1.4,3.8 2.2,5.3l2.5,4l-3.2,0l-1.5,-0.5l-4.6,-7.2l-1.2,-4.5Z"
      style="
        fill: #a6a6a6;
        fill-rule: nonzero;
        stroke: #4d4d4d;
        stroke-width: 0.4px;
        stroke-linecap: round;
        stroke-linejoin: round;
      "
    />
    <path
      d="M246.6,284.6l2,0.1c0.2,0.1 2.3,2 3.1,4.2c0.8,2.2 0.4,2.6 1.5,5c1,2.3 2.6,4 2.6,4c0,0 -3.2,0 -5,-0.2c-1.8,-0.2 -2.3,-0.3 -2.7,-0.8l-1.4,-1l-1.8,0l0.5,-2.5l-0.5,-5.5l0,-2.9l1.7,-0.4Zm18.7,1.5l-3,-1.2l-5.5,-0.3l0.4,2.8c0.2,1.4 1.2,4.6 2,6.2c1,1.6 1.9,3.5 2.4,4c0.5,0.5 3.6,-0.9 3.6,-0.9l2.1,-0.3l-0.3,-2.3l-0.3,-0.7l0.5,-6.4l-0.4,-1l-1.5,0.1Z"
      style="
        fill: #a6a6a6;
        fill-rule: nonzero;
        stroke: #4d4d4d;
        stroke-width: 0.4px;
        stroke-linecap: round;
        stroke-linejoin: round;
      "
    />
    <path
      d="M245.7,286.1c-0,0.7 0.7,0.8 1,0.7c0.1,0 0.8,-0.3 0.8,-1.2c-0,-0.9 -0.6,-1.7 -1.8,-1.8c-1.1,0 -2,1.4 -2,2.4c-0,1 1,1.5 1,1.9c-0,0 -1,0.9 -1,2.5c-0,1.6 1.4,2.8 1.4,2.8c-0,0 -1.4,1.1 -1.4,2.2c-0,1.1 1,1.9 2,1.9c1,0 2.3,-0.7 2.3,-1.5c-0,-0.8 -0.8,-1.4 -1.4,-1.4c-0.6,0.067 -0.9,0.3 -0.9,0.7m20.5,-8.7c-0.067,0.6 -0.333,0.833 -0.8,0.7c-0.7,-0.2 -0.9,-0.2 -0.9,-1.1c-0,-0.9 1.1,-1.3 1.9,-1.3c0.8,0 2,1 2,2.2c-0,1.2 -1,2 -1,2c-0,0 0.6,0.3 0.6,1.8c-0,1.5 -1,2.6 -1,2.6c-0,0 1.3,0.5 1.3,2.1c-0,1.6 -1,2.1 -1.8,2.1c-0.8,0 -2.1,-0.5 -2.1,-1.5c-0,-1 0.7,-1.5 1.2,-1.5c0.5,0 1,0.6 1,1.2"
      style="
        fill: #a6a6a6;
        fill-rule: nonzero;
        stroke: #4d4d4d;
        stroke-width: 0.4px;
        stroke-linecap: round;
        stroke-linejoin: round;
      "
    />
    <path
      d="M247.6,295l0.3,0.4c0.133,0.4 0.333,0.733 0.6,1c0.7,0.7 5.8,0.9 7.4,0.9c1.6,0 6.2,0.2 7.1,-0.3c1,-0.6 1,-1.4 1.5,-1.8l0.7,-0.4l-0.6,0.6l0,1l0.3,0.7c0,0 0,0.3 -0.6,0.6c-0.467,0.333 -1.067,0.533 -1.8,0.6c-0.8,0 -10.6,0 -12.2,-0.2c-1.6,-0.2 -1.5,-0.3 -2,-0.6l-0.7,-0.7l0.3,-0.7l-0.3,-1.1Zm16,-9.5l0.8,0.4c0,0 -0.7,0.2 -1.3,1.8c-0.6,1.5 0,2 -0.5,2.2l-4.6,0l-0.7,-1.8l6.3,-2.6Z"
      style="fill: #4d4d4d; fill-rule: nonzero"
    />
    <path
      d="M277.1,284.9c0,-0 -0.7,-0.3 -1,-1c-0.4,-0.5 -0.7,-1.3 -0.4,-1.4c0.4,-0.067 0.667,0.2 0.8,0.8c0.267,1 0.467,1.533 0.6,1.6m8.4,-2.3l0.7,1l1,0.5c0,-0 -1.2,-0 -1.6,-0.3l-0.8,-1.2l0.7,-0Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M288,283.3c0,0 -0.7,0.4 -1.3,0.2c-0.667,-0.267 -0.967,-0.533 -0.9,-0.8c0.2,-0.267 0.433,-0.2 0.7,0.2c0.4,0.3 1.5,0.4 1.5,0.4m4.2,-3.6c0,0 -0.6,0.6 -1,0.6c-0.4,0 -1.2,-0.2 -1.2,-0.4c0,-0.2 1,-0.3 1.2,-0.3l1,0.1Zm-6.3,-8.3c0,-0 -1,0.2 -1.3,0.7c-0.267,0.6 -0.2,0.933 0.2,1c0.6,0.1 0.5,-0.6 0.5,-0.7c0,-0.2 0.6,-1 0.6,-1m-4.2,2.3c0,-0 -0.7,0.4 -0.9,0.8c-0.2,0.4 -0.3,1.2 0,1.3c0.5,-0 0.6,-0.7 0.7,-1l0.2,-1.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M274.2,278.7l-2.3,2.4c0,0 5.3,3 9.4,2.8c4,0 8.6,-3.3 9,-4c0.2,-0.6 0,-3.4 -0.5,-4.3c-0.5,-0.9 -3.4,-3 -4.4,-3c-1,0.1 -3,1.6 -4.7,3.2c-1.7,1.6 -1.6,3.2 -4,3l-2.5,-0.1Z"
      style="
        fill: #adadad;
        fill-rule: nonzero;
        stroke: #373737;
        stroke-width: 0.4px;
      "
    />
    <path
      d="M273.6,279.7c0,0 5.7,0.8 7.3,-0.6c1.6,-1.5 3.4,-4.3 4.5,-5c1.2,-0.533 1.767,-0.733 1.7,-0.6l1.2,1l1.5,1.1l0.4,2.7l0,1.5l-1.7,1.4l-3.3,1.5l-3,1l-2.7,-0.1l-5.3,-1.6l-1.4,-0.9l-0.3,-0.3l1.1,-1.1Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M282.2,276.4c0.067,-0.4 0.333,-0.533 0.8,-0.4c0.7,0.2 0.9,-0 0.9,0.5c0,0.5 -0.5,1.2 -1,1.2c-0.3,-0 -0.7,-0.8 -0.7,-1.3m2.3,1.4c0,-0.4 0.267,-0.6 0.8,-0.6c0.6,-0 1,0.6 1,1c0,0.4 -0.4,0.8 -0.9,0.8c-0.5,-0 -0.9,-0.7 -0.9,-1.2m-0.8,3.4c0,-0.467 0.3,-0.667 0.9,-0.6c0.9,0.1 0.8,0.2 0.8,0.7c0,0.5 -0.4,1 -1,1c-0.4,-0.067 -0.633,-0.4 -0.7,-1l0,-0.1Zm-3,-1c0,-0.6 0.6,-0.8 1,-0.8c0.533,0.067 0.833,0.4 0.9,1c-0.067,0.667 -0.333,1.033 -0.8,1.1c-0.6,-0.133 -0.933,-0.567 -1,-1.3l-0.1,0Zm-4.7,0.6c0,-0.631 0.519,-1.15 1.15,-1.15c0.631,0 1.15,0.519 1.15,1.15c0,0.631 -0.519,1.15 -1.15,1.15c-0.631,0 -1.15,-0.519 -1.15,-1.15"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M284.5,277.8c0.133,-0.4 0.4,-0.6 0.8,-0.6c0.4,0 0.6,0.233 0.6,0.7c0,0.467 -0.167,0.7 -0.5,0.7c-0.467,-0.067 -0.767,-0.333 -0.9,-0.8m-0.8,3.3c0.067,-0.467 0.4,-0.7 1,-0.7c0.467,0 0.733,0.233 0.8,0.7c0,0.667 -0.3,0.933 -0.9,0.8c-0.9,-0.2 -0.9,-0.4 -0.9,-0.8m-3,-1c0,-0.5 0.9,-0.7 1.2,-0.7c0.267,0 0.367,0.267 0.3,0.8c-0.133,0.667 -0.333,0.967 -0.6,0.9c-0.467,-0.067 -0.733,-0.4 -0.8,-1l-0.1,0Zm1.5,-3.7c0,-0.4 0.2,-0.567 0.6,-0.5c0.6,0.1 0.5,0.1 0.5,0.6c0,0.467 -0.167,0.733 -0.5,0.8c-0.467,0 -0.667,-0.333 -0.6,-1l0,0.1Zm-6.2,4c0.067,-0.6 0.433,-0.933 1.1,-1c0.8,-0 1.267,0.233 1.4,0.7c0,0.6 -0.8,1.5 -1.5,1.5c-0.7,-0 -1,-0.7 -1,-1.2"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M278.2,279.5c0,0 -0.8,0.1 -1.2,0.5c-0.4,0.467 -0.467,0.8 -0.2,1c0.267,0 0.433,-0.167 0.5,-0.5l0.9,-1Zm3.7,-0.8c0,0 -0.7,0.5 -0.8,1c0,0.6 0.067,0.867 0.2,0.8c0.2,-0.2 0.3,-0.533 0.3,-1c-0.1,-0.2 0.3,-0.8 0.3,-0.8"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M282.5,279.5c0,0 -0.4,0 -0.8,0.3c-0.4,0.4 -0.533,0.633 -0.4,0.7c0.267,0 0.467,-0.1 0.6,-0.3c0,-0.2 0.6,-0.7 0.6,-0.7m0.8,-4.4l-0.5,0.5c-0.333,0.333 -0.4,0.633 -0.2,0.9c0.2,0 0.4,-0.167 0.6,-0.5c0.2,-0.467 0.267,-0.767 0.2,-0.9l-0.1,0Zm2.9,1.8c0,0 -0.7,0.1 -1,0.5c-0.267,0.333 -0.267,0.533 0,0.6c0.267,0.067 0.433,-0.067 0.5,-0.4c0,-0.3 0.5,-0.7 0.5,-0.7m-0.5,3.4c0,0 -0.1,0.5 -0.6,0.7c-0.333,0.4 -0.567,0.467 -0.7,0.2c-0.133,-0.333 -0.033,-0.533 0.3,-0.6l1,-0.3Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M290.3,278c0,0 0.3,1.6 -1,2.3c-1.4,0.8 -5.2,3.5 -8.8,3.2c-3.6,-0.4 -7.7,-2.4 -7.7,-2.4l-0.5,0.3l0.9,0.4l2.8,1.1l3.1,1l2,0l1.7,-0.1l3.2,-1.1l2.7,-1.4l1.4,-1l0.3,-0.5l0,-1.6l-0.1,-0.2Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M219.9,257.8c0,0 0.8,0.7 0.8,1.3c-0.133,0.6 -0.333,0.833 -0.6,0.7c-0.2,0 -0.2,-0.7 -0.2,-1l-0,-1Zm6.2,5.7c-0,0 -0.3,1 -0.7,1.1c-0.467,0 -0.7,-0.167 -0.7,-0.5c0.1,-0.2 0.5,0 0.7,-0.2l0.7,-0.4Zm-13.4,0.8c-0,-0 0.3,0.6 0.8,0.7c0.6,-0 0.833,-0.167 0.7,-0.5l-0.6,-0l-0.9,-0.2Zm2.4,4.7c-0,-0 0.5,0.6 1.1,0.6c0.46,0.083 0.92,-0.168 1.1,-0.6c-0,-0.1 -0.8,-0.1 -1,0.1c-0.3,0.2 -1.2,-0.1 -1.2,-0.1m4.2,3.6c-0,-0 1,-0.2 1.3,-0.5c0.267,-0.4 0.333,-0.733 0.2,-1c-0.2,-0.4 -0.4,0.3 -0.5,0.6l-1,0.9Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M226.1,269.7c0,0 0.7,-4.9 -3.2,-8.3c-3.9,-3.4 -6.5,-2.6 -7.9,-1.3c-1.3,1.2 -2.5,5.4 1.7,9c4.2,3.6 9.3,2.5 9.3,2.5l0.1,-1.9Z"
      style="
        fill: #adadad;
        fill-rule: nonzero;
        stroke: #373737;
        stroke-width: 0.4px;
      "
    />
    <path
      d="M214,264.6c0,0 0,-2.7 1.3,-3.5c0.794,-0.422 1.68,-0.642 2.58,-0.642c2.08,-0 3.99,1.18 4.92,3.042c2,4 2,6 1.5,8l-2.2,0l-3.4,-1.4l-2.8,-2.1l-1.9,-3.4Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M225.6,270.4c0,0 -0.7,0.8 -2.1,0.7c-1.5,0 -8,-1.8 -9.7,-7.7l0,1.3l0.1,0.4l0.5,1.2l1.4,2l1.7,1.5l2.2,1.2l1.6,0.4l2,0.4l1.2,0l1,-1.4l0.1,0Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M222.1,268.7c0,-0.4 0.233,-0.567 0.7,-0.5c0.4,0 0.8,-0.2 0.8,0.3c0,0.5 -0.3,1.3 -0.7,1.3c-0.5,0 -0.8,-0.6 -0.8,-1l0,-0.1Zm0.3,-3.1c0,-0.4 0.267,-0.633 0.8,-0.7c0.8,-0.1 0.7,0.3 0.7,0.7c0,0.333 -0.233,0.533 -0.7,0.6c-0.667,0 -0.933,-0.2 -0.8,-0.6m-3,3.4c0,-0.333 0.3,-0.5 0.9,-0.5c0.467,0 0.733,0.167 0.8,0.5c0.1,0.5 -0.8,0.7 -1.3,0.7c-0.5,0 -0.4,-0.4 -0.4,-0.7m-0.3,-3.7c0,-0.333 0.233,-0.433 0.7,-0.3c0.467,0 0.767,0.2 0.9,0.6c0.2,0.6 -0.5,1.1 -1,1.1c-0.3,0 -0.6,-0.9 -0.6,-1.4m-2.7,0.7c0,-0.4 0.2,-1 0.7,-1c0.5,0 1,0.6 1,1c0,0.4 -0.3,0.633 -0.9,0.7c-0.9,0.1 -0.9,-0.4 -0.9,-0.7l0.1,0Zm0.5,-3.3c0,-0.333 0.233,-0.467 0.7,-0.4c0.667,0 1,0.2 1,0.6c-0.133,0.533 -0.5,0.867 -1.1,1c-0.6,0 -0.6,-0.8 -0.6,-1.2m3,-0.3c0,-0.267 0.267,-0.367 0.8,-0.3c0.667,0.067 0.933,0.3 0.8,0.7c0,0.4 -0.6,0.8 -1,0.8c-0.4,0 -0.6,-0.8 -0.6,-1.2"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M216.9,262.6c0,-0.333 0.2,-0.5 0.6,-0.5c0.533,-0.067 0.767,0.1 0.7,0.5c0,0.4 -0.233,0.633 -0.7,0.7c-0.467,0.067 -0.667,-0.167 -0.6,-0.7m-0.6,3.2c0,-0.467 0.2,-0.733 0.6,-0.8c0.4,-0.067 0.633,0.1 0.7,0.5c0,0.6 -0.233,0.867 -0.7,0.8c-0.4,0.067 -0.6,-0.1 -0.6,-0.5m3.5,-3.4c0,-0.267 0.233,-0.367 0.7,-0.3c0.4,-0.067 0.633,0.067 0.7,0.4c-0.067,0.333 -0.3,0.5 -0.7,0.5c-0.4,0 -0.6,-0.2 -0.6,-0.6l-0.1,0Zm-0.6,3.1c0,0.467 0.233,0.733 0.7,0.8c0.467,-0.067 0.733,-0.333 0.8,-0.8c0.1,-0.7 -0.5,-0.8 -0.8,-0.8c-0.467,0.067 -0.7,0.333 -0.7,0.8m3.3,-0.5c0.067,0.467 0.333,0.733 0.8,0.8c0.667,0 0.933,-0.267 0.8,-0.8c-0.067,-0.4 -0.333,-0.633 -0.8,-0.7c-0.7,-0.1 -0.8,0.4 -0.8,0.7m-3.2,4c0,-0.4 0.233,-0.633 0.7,-0.7c0.467,-0.067 0.7,0.133 0.7,0.6c-0.133,0.4 -0.467,0.667 -1,0.8c-0.267,-0.067 -0.4,-0.3 -0.4,-0.7m2.9,-0.5c0,-0.333 0.233,-0.5 0.7,-0.5c0.6,-0.067 0.833,0.1 0.7,0.5c-0.133,0.6 -0.4,0.867 -0.8,0.8c-0.4,-0.067 -0.633,-0.333 -0.7,-0.8l0.1,0Z"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M223,263.6c0,0 0.4,0.5 0.5,1l-0.1,0.9c-0.2,0 -0.367,-0.233 -0.5,-0.7l0,-1.3l0.1,0.1Zm-2.6,-2.7c0,0 0.3,0.4 0.3,0.8c0,0.4 0,0.8 -0.3,0.8c-0.133,-0.067 -0.2,-0.3 -0.2,-0.7l0.2,-0.9Zm-3,0.4c0,-0 0.3,0.4 0.3,0.8c0,0.4 0,0.8 -0.2,0.8c-0.2,-0 -0.2,-0.4 -0.2,-0.7l0.1,-0.9Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M216.4,261.8l0.7,0.4c0.4,0.333 0.533,0.567 0.4,0.7c-0.267,0.133 -0.433,0.067 -0.5,-0.2l-0.6,-0.9Zm2.3,3.1c0,0 0.5,0 0.9,0.3c0.333,0.333 0.433,0.6 0.3,0.8c-0.2,0.067 -0.467,-0.067 -0.8,-0.4l-0.4,-0.7Zm-2.8,-0l0.8,0.2c0.267,0.267 0.333,0.5 0.2,0.7c-0.133,-0 -0.3,-0.1 -0.5,-0.3l-0.5,-0.6Zm6.7,2l0.1,1c0.067,0.6 0.033,0.933 -0.1,1c-0.2,0.1 -0.3,-0.6 -0.3,-1l0.3,-1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M221.8,268l0.7,0.3c0.2,0.267 0.2,0.433 0,0.5l-0.3,-0.4l-0.4,-0.4Zm-3,0.1l0.8,0.2c0.2,0.333 0.267,0.667 0.2,1c-0.133,0.067 -0.3,-0.067 -0.5,-0.4l-0.5,-0.8Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M217.7,259c-0,0 -2.6,0.6 -3,2.3c-0.6,1.7 -0.6,3.6 -0.6,3.6l-0.4,-2.2l0.6,-1.3l0.7,-1.3l1.2,-0.7l1,-0.4l0.5,-0Zm8.2,10c0,-0 0.2,-0.6 -0.5,-2.6c-0.8,-2.1 -2.4,-4.8 -2.4,-4.8l1.2,1.4l1,1.6l0.5,1.4l0.4,1.3l0,1.3l-0.2,0.4Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M228.5,265.7c0,0 1,0.6 1,1l0,0.5c-0.4,-0.067 -0.667,-0.233 -0.8,-0.5l-0.2,-1Zm-3.8,10.3c0,0 0.4,-0.8 1,-1c0.667,-0.333 1.033,-0.4 1.1,-0.2c0.2,0.2 -0.3,0.7 -0.7,0.8l-1.4,0.4Zm6.4,2.5c0,0 0.7,-0.3 1,-0.8c0.4,-0.4 0.533,-0.7 0.4,-0.9c-0.267,-0.067 -0.6,0.1 -1,0.5l-0.4,1.2Zm-0.7,-0.6c0,0 0.2,-0.8 0.5,-1.1c0.2,-0.267 0.433,-0.367 0.7,-0.3c0.2,0.2 0.2,0.433 0,0.7l-1.2,0.7Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M241.2,273c-0,0 -4,-5.8 -10.3,-6.1c-5,-0.3 -6.5,4.2 -6.3,5.5c0.1,1.4 2,4.3 8.7,4.7c6.7,0.4 7.7,-3 8,-3.3c0.2,-0.1 -0.1,-0.8 -0.1,-0.8Z"
      style="
        fill: #adadad;
        fill-rule: nonzero;
        stroke: #373737;
        stroke-width: 0.4px;
      "
    />
    <path
      d="M236.5,269c0,0 1.6,1.3 2.3,2.3c0.7,1 0.9,1.7 0.5,1.8c-0.4,0.1 -4,-3.2 -7,-3.9c-3,-0.7 -5.5,0 -6.1,1.4c-0.6,1.4 -0.4,3.5 1,4.4c1.4,0.9 7.7,2 7.7,2l3,-0.5l1.8,-1l0.4,-1l0.4,-1.4l0.2,-0.5l-1.5,-1.7l-2.7,-1.9Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M231.4,269.8c-0.067,0.4 -0.333,0.6 -0.8,0.6c-0.6,0 -0.833,-0.2 -0.7,-0.6c0,-0.4 0.233,-0.633 0.7,-0.7c0.467,-0.067 0.733,0.167 0.8,0.7m-3.7,1.3c0,-0.267 0.3,-0.367 0.9,-0.3c0.9,0.1 0.7,0.3 0.7,0.6c0,0.4 -0.7,1 -1,0.8c-0.467,-0.333 -0.667,-0.667 -0.6,-1l0,-0.1Zm4,2.2c0,-0.533 0.267,-0.833 0.8,-0.9c0.733,0 1.067,0.3 1,0.9c-0.2,0.8 -0.6,1.133 -1.2,1c-0.9,-0.2 -0.7,-0.5 -0.7,-1l0.1,0Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M228.7,274.2c0.067,-0.4 0.333,-0.567 0.8,-0.5c0.4,0.067 0.667,0.333 0.8,0.8c0.2,0.7 -0.5,0.7 -0.8,0.7c-0.467,-0.133 -0.733,-0.467 -0.8,-1"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M234,275.6c0,-0.333 0.167,-0.533 0.5,-0.6c0.467,0 0.733,0.167 0.8,0.5c0,0.467 -0.233,0.7 -0.7,0.7l-0.6,-0.6Zm2.4,-1.8c-0,-0.333 0.2,-0.467 0.6,-0.4c0.533,0 0.833,0.233 0.9,0.7c-0.067,0.4 -0.4,0.6 -1,0.6c-0.4,-0.067 -0.567,-0.4 -0.5,-1l-0,0.1Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M231.1,269.5c0,0.333 -0.133,0.5 -0.4,0.5c-0.467,0 -0.733,-0.167 -0.8,-0.5c0,-0.333 0.167,-0.5 0.5,-0.5c0.467,0 0.7,0.167 0.7,0.5m-1.9,1.5c-0.067,0.4 -0.367,0.6 -0.9,0.6c-0.8,0 -0.5,-0.2 -0.5,-0.6c0,-0.267 0.2,-0.4 0.6,-0.4c0.4,-0.067 0.667,0.067 0.8,0.4m0.9,3.1c0,0.333 -0.167,0.533 -0.5,0.6c-0.533,0 -0.833,-0.2 -0.9,-0.6c-0.1,-0.6 0.2,-0.5 0.5,-0.5c0.533,0 0.833,0.167 0.9,0.5m3.1,-1c-0.133,0.4 -0.467,0.633 -1,0.7c-0.8,0.1 -0.5,-0.6 -0.5,-1c0,-0.333 0.233,-0.533 0.7,-0.6c0.4,0.067 0.667,0.367 0.8,0.9m4.7,1c-0.133,0.267 -0.467,0.367 -1,0.3c-0.267,-0.067 -0.433,-0.333 -0.5,-0.8c0,-0.3 0,-0.6 0.9,-0.5c0.333,0.133 0.533,0.467 0.6,1m-2.8,1.3c0,0.4 -0.2,0.633 -0.6,0.7l-0.6,-0.6c0,-0.4 0.2,-0.567 0.6,-0.5c0.4,0.067 0.6,0.233 0.6,0.5l0,-0.1Z"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M235.6,273.5c0,0 0.6,-0.2 1,-0.1c0.467,0 0.667,0.1 0.6,0.3l-0.6,0.2l-1,-0.4Zm-2.7,2.3l0.9,-0.4c0.467,0 0.667,0.1 0.6,0.3c0,0.267 -0.167,0.367 -0.5,0.3l-1,-0.2Zm-1.8,-4c0,-0 1.1,0.5 1.4,1c0.267,0.333 0.267,0.533 0,0.6c-0.2,0.133 -0.4,0.033 -0.6,-0.3l-0.8,-1.3Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M230.8,273.3l1.3,-0.3c0.4,0 0.567,0.067 0.5,0.2c-0.067,0.133 -0.2,0.233 -0.4,0.3l-1.4,-0.3l0,0.1Zm-2.7,0c0,0 1,0.1 1.2,0.4c0.2,0.2 0.233,0.4 0.1,0.6c-0.2,0.067 -0.433,0.033 -0.7,-0.1c-0.4,-0.2 -0.6,-0.9 -0.6,-0.9"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M228,274.6c0,0 0.3,-0.5 0.7,-0.6l0.8,0c0,0.333 -0.2,0.533 -0.6,0.6l-0.9,0Zm-0.7,-4l0.9,0.2c0.333,0.267 0.433,0.467 0.3,0.6l-0.7,0c-0.4,-0.4 -0.6,-0.667 -0.6,-0.8l0.1,0Zm2,-2.4c-0,0 1,0.3 1.2,0.7c0.267,0.4 0.333,0.667 0.2,0.8l-0.8,-0.4l-0.6,-1.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M240,275c0,0 -1.9,1.6 -6.2,1.5c-4.3,-0.1 -8.3,-2 -9.2,-4l0.4,1l1,1.2l3,1.6l3.4,0.7l2.7,0.2l2.5,-0.4l2,-1l0.3,-0.5l0.2,-0.3l-0.1,0Zm0.6,-2l-1.7,-2l-5,-3.4l3.2,1.4l2.1,1.8l1.5,1.6l-0.1,0.6Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M240.8,269c0,0 1.1,0.5 1.3,0.8l0.4,0.5c0,0 -0.3,0.7 -0.5,0.4l-0.6,-0.7l-0.6,-1Zm3.3,-1.7c-0,0 1,0.5 1.3,1c0.333,0.533 0.4,0.867 0.2,1c-0.2,0 -0.9,-0.6 -1,-0.8l-0.5,-1.2Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M245,267.1c0,0 1,0.7 1.2,1c0.333,0.4 0.4,0.733 0.2,1c-0.4,-0.133 -0.733,-0.4 -1,-0.8l-0.4,-1.2Zm5.6,1.3c0,0 0.7,0.3 0.8,1l0,1l-0.6,-0.6l0,-0.5l-0.2,-0.9Zm1.4,0.5c0,0 0.6,0.6 0.7,1c0.067,0.4 0,0.633 -0.2,0.7c-0.333,0 -0.5,-0.2 -0.5,-0.6l0,-1.1Zm-9.8,12c0,0 0.5,0.2 0.9,0c0.533,-0.2 0.767,-0.467 0.7,-0.8c0,-0.333 -0.2,-0.367 -0.6,-0.1l-0.4,0.6l-0.6,0.3Zm5.4,1.5c0,0 0.7,-0.1 1.2,-0.7c0.533,-0.533 0.667,-0.867 0.4,-1c-0.4,-0.133 -0.7,0 -0.9,0.4l-0.7,1.3Zm4.4,0.1l1,-0.7c0.467,-0.333 0.6,-0.667 0.4,-1c-0.267,-0.133 -0.5,-0.1 -0.7,0.1l-0.1,0.6l-0.6,1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M253.4,282.5c0,0 0.6,-0.7 0.7,-1.1c0.133,-0.533 0.133,-0.8 0,-0.8c-0.333,0.067 -0.567,0.267 -0.7,0.6l0,1.3Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M239.9,275.3c0,-2 2.8,-6.5 6,-6.4c1.3,0 4,0.7 6,1.7c1.8,0.8 2.4,1.6 3.5,2c1.2,0.2 3,0 3,0l4,-0.5l-3.2,4.6l-1,1c0,0 -1,2 -4,3c-2.7,1.1 -7.5,0.3 -9.7,-0.2c-2.2,-0.5 -4.7,-2.6 -4.6,-5.2Z"
      style="
        fill: #adadad;
        fill-rule: nonzero;
        stroke: #373737;
        stroke-width: 0.4px;
      "
    />
    <path
      d="M239.7,275.3l0.4,0c-0,-0.4 0.167,-0.967 0.5,-1.7c0.509,-1.121 1.221,-2.138 2.1,-3c1,-0.933 2.033,-1.433 3.1,-1.5c2.061,0.271 4.078,0.809 6,1.6l2,1.2c0.92,0.692 2.05,1.045 3.2,1l1.4,-0.1l3.5,-0.4l-2.8,4.2l-1.2,1c-0.845,1.401 -2.154,2.463 -3.7,3c-1,0.333 -2.167,0.5 -3.5,0.5c-2.3,0 -4.8,-0.5 -6.1,-0.8c-1.126,-0.308 -2.157,-0.892 -3,-1.7c-0.873,-0.848 -1.406,-1.987 -1.5,-3.2l0,-0.1l-0.4,0c0.018,1.368 0.597,2.67 1.6,3.6c0.887,0.874 1.992,1.495 3.2,1.8c1.4,0.3 3.8,0.8 6.2,0.8c1.259,0.013 2.51,-0.19 3.7,-0.6c2.9,-1.1 3.9,-3 3.9,-3.1l-0.2,-0.1l0.1,0.2l1.2,-1l3.4,-5l-4.5,0.5l-1.3,0l-1.5,-0.1c-0.533,-0.133 -1.033,-0.367 -1.5,-0.7c-0.4,-0.4 -1.067,-0.8 -2,-1.2l-3.3,-1.2c-1.133,-0.333 -2.067,-0.5 -2.8,-0.5c-0.933,0 -1.767,0.267 -2.5,0.8c-1.057,0.736 -1.944,1.691 -2.6,2.8c-0.593,0.902 -0.97,1.929 -1.1,3Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M259.2,275.9c-0.333,0.267 -0.7,0.367 -1.1,0.3c-0.5,-0 -9.3,-5.4 -12,-5.2c-2.8,0.2 -5.4,1.4 -5.5,4.2c-0.1,2.8 0.6,2.9 1.2,3.7c0.6,0.8 6,2 6,2l3.2,-0l2.7,-0.4l2.3,-1.3l1.3,-1l0.9,-1l1,-1.3Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M245.2,274.5c-0,0.6 -0.267,0.933 -0.8,1c-0.533,0.067 -0.833,-0.233 -0.9,-0.9c-0,-0.467 0.267,-0.7 0.8,-0.7c0.667,-0.133 0.967,0.067 0.9,0.6m1,-2.5c-0,-0.4 0.3,-0.6 0.9,-0.6c0.9,0 0.9,0.1 0.9,0.6c-0,0.5 -0.4,0.8 -1,0.8c-0.6,0 -0.9,-0.3 -0.9,-0.8l0.1,0Zm5.2,1.5c0.067,-0.467 0.333,-0.733 0.8,-0.8c0.667,0 0.933,0.267 0.8,0.8c-0.2,0.8 -0.4,0.7 -0.8,0.7c-0.378,-0.06 -0.69,-0.333 -0.8,-0.7m1,3.2c-0,-0.6 0.333,-0.933 1,-1c0.467,0 0.733,0.267 0.8,0.8c-0,0.733 -0.2,1.067 -0.6,1c-0.667,0 -1.033,-0.267 -1.1,-0.8l-0.1,0Zm-2.5,2c-0,-0.4 0.3,-0.633 0.9,-0.7c0.9,-0.1 0.8,0.3 0.8,0.8c-0,0.4 -0.267,0.633 -0.8,0.7c-0.467,0 -0.767,-0.233 -0.9,-0.7l-0,-0.1Zm-4.9,-0.8c0.067,-0.4 0.333,-0.633 0.8,-0.7c0.089,-0.033 0.183,-0.05 0.278,-0.05c0.439,0 0.8,0.361 0.8,0.8c0,0.439 -0.361,0.8 -0.8,0.8c-0.095,0 -0.189,-0.017 -0.278,-0.05c-0.405,-0.076 -0.724,-0.395 -0.8,-0.8"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M245.2,274.4c-0,0.467 -0.3,0.733 -0.9,0.8c-0.405,-0.076 -0.724,-0.395 -0.8,-0.8c0.067,-0.467 0.333,-0.667 0.8,-0.6c0.467,0.067 0.767,0.233 0.9,0.5l-0,0.1Zm2.5,-2.5c-0,0.4 -0.167,0.633 -0.5,0.7c-0.6,-0 -0.933,-0.267 -1,-0.8c-0,-0.4 0.233,-0.633 0.7,-0.7c0.533,-0 0.8,0.267 0.8,0.8m5.2,1.3c-0.067,0.4 -0.333,0.633 -0.8,0.7c-0.6,-0 -0.833,-0.233 -0.7,-0.7c-0,-0.333 0.233,-0.533 0.7,-0.6c0.667,-0 0.933,0.2 0.8,0.6"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M250.1,275.4c0,0.667 -0.233,1 -0.7,1c-0.667,-0 -1,-0.3 -1,-0.9c0,-0.467 0.3,-0.7 0.9,-0.7c0.9,-0 0.8,-0 0.8,0.6"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M246.4,277.8c0,0.4 -0.267,0.633 -0.8,0.7c-0.378,-0.06 -0.69,-0.333 -0.8,-0.7c0.067,-0.467 0.4,-0.7 1,-0.7c0.4,0 0.6,0.2 0.6,0.6l0,0.1Zm3.6,-2.5c-0.076,0.405 -0.395,0.724 -0.8,0.8c-0.405,-0.076 -0.724,-0.395 -0.8,-0.8c0.076,-0.405 0.395,-0.724 0.8,-0.8c0.405,0.076 0.724,0.395 0.8,0.8m4.2,1c0,0.667 -0.267,1 -0.8,1c-0.549,-0 -1,-0.451 -1,-1c0,-0.4 0.233,-0.6 0.7,-0.6c0.667,-0 1,0.233 1,0.7l0.1,-0.1Zm-2.7,2.3c0,0.4 -0.267,0.633 -0.8,0.7c-0.667,0 -0.967,-0.233 -0.9,-0.7c0.067,-0.467 0.367,-0.7 0.9,-0.7c0.467,0 0.733,0.233 0.8,0.7"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M251.8,276c0,0 1.3,-0.2 1.6,0c0.2,0.333 0.2,0.6 0,0.8l-0.7,-0.1l-0.9,-0.7Zm-1.3,-4.3c0,0 1,0.3 1.4,0.7c0.333,0.467 0.433,0.767 0.3,0.9c-0.133,0.133 -0.367,0.067 -0.7,-0.2l-1,-1.4Zm-3,2c-0,0 1.2,0.7 1.4,1c0.333,0.4 0.4,0.7 0.2,0.9c-0,0.1 -0.7,0 -0.8,-0.3l-0.8,-1.6Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M247,274.6c0,0 1.3,0.2 1.6,0.5c0.4,0.133 0.6,0.267 0.6,0.4c0,0.133 -0.133,0.267 -0.4,0.4l-1,-0.4c0,-0.2 -0.8,-0.8 -0.8,-0.8l0,-0.1Zm-1.6,-3.8c0,0 1.4,0.2 1.7,0.4c0.333,0.333 0.333,0.667 0,1c-0.333,0.067 -0.6,-0.067 -0.8,-0.4c0,-0.3 -0.9,-1 -0.9,-1m-2.9,2c0,0 1.3,0.6 1.7,1.2c0.333,0.333 0.333,0.533 0,0.6c-0.4,0.2 -0.8,-0.5 -0.8,-0.6l-0.9,-1.2Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M242.3,274.4l1.1,-0.1c0.533,-0.133 0.867,-0.1 1,0.1c-0.133,0.267 -0.4,0.367 -0.8,0.3l-1.3,-0.3Zm6.8,4.5c0,-0 1,-0.6 1.3,-0.5c0.467,-0 0.667,0.1 0.6,0.3c-0.2,0.2 -0.4,0.267 -0.6,0.2l-1.3,-0Zm-4.8,-0.7c0,-0 0.4,-0.5 0.7,-0.6l0.6,0.1c-0.067,0.267 -0.233,0.433 -0.5,0.5l-0.8,-0Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M258,277.3c0,0 -1.2,1.6 -3,2.4c-2,0.8 -3.3,1 -5.9,0.9c-1.961,-0.035 -3.884,-0.55 -5.6,-1.5c-1.3,-0.623 -2.432,-1.549 -3.3,-2.7c-0.3,-0.6 0.3,1 0.3,1l1.5,2l2,0.8l2.7,0.7l2.6,0.3l2,0l2.4,-0.4l1.6,-0.5l1,-0.7l0.8,-0.6l0.9,-1.7Zm-2.4,-4.7c0,0 -0.7,0.2 -2.3,-0.7c-1.6,-1 -3.5,-2.3 -7,-2.3c-3.6,0 -4.8,2.4 -5,2.6l1.6,-2.1l1.6,-1l1.3,-0.1l1.2,0l1.6,0.5l1.4,0.4l1.7,0.6l1.5,0.8l1.7,0.9l0.7,0.4Zm4.8,1l-2.7,0c-0.467,0.067 -0.7,0.2 -0.7,0.4l-0.2,0.4l-0.7,-1.4l2.9,-0.4l1.6,0.6l-0.2,0.5l0,-0.1Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M256.6,288.3c0.133,0.467 0.4,0.733 0.8,0.8l1.4,0l2.8,-0.2l1,-1.1l0.6,-2.6l0.8,-1l2.6,-1.5l2.3,-0.6l1.5,-0.2l2,-0.7l1.5,-0.7l0.6,-1l0.7,-1.5l-0.7,-2l-1.6,-2l-2.6,-1.1l-2.3,0l-2.5,0.9l-4.3,1c-0,0 -2.5,1 -3.5,3c-1,1.8 -1,2.3 -1.1,4.8c-0.1,2.5 -0,5.7 -0,5.7Z"
      style="
        fill: #5d5d5d;
        fill-rule: nonzero;
        stroke: #373737;
        stroke-width: 0.4px;
      "
    />
    <path
      d="M257.7,287.4c0.9,-0 0.2,-1.4 1.2,-3c1,-1.6 2,-3.7 2.4,-3.7c0.2,0.133 0.433,0.2 0.7,0.2c0.3,-0.1 1,-0.7 1,-0.8c-0.133,-0.333 0.1,-0.9 0.7,-1.7c0.7,-0.6 1.8,-1.4 2.2,-1.5c0.467,-0.133 0.733,-0.133 0.8,-0c0.1,0.2 -0.2,0.5 0.1,0.7c0.467,0.067 0.9,-0.1 1.3,-0.5l0.1,-0.7c-0.1,-0 0.5,-0.5 1.5,-0.3c1,0.2 1,0.2 1.1,0.5c0.1,0.4 -0.4,0.4 -0.3,0.7l0,0.4c0.1,0.2 0.3,0.8 1,0.8c0.6,-0.133 0.867,-0.267 0.8,-0.4l0.2,-0.3c0,-0 0.2,-0.4 0,-0.6c-0.267,-0.267 -0.267,-0.333 0,-0.2c0.3,-0 1.2,1.4 1.6,0.9c0.267,-0.733 0.333,-1.267 0.2,-1.6l-1.6,-2.2l-2.4,-0.9l-3.2,0.3l-3.2,1.8l-2.9,1.5c0,-0 -0.1,2.4 -0.6,2c-0.6,-0.5 -1.3,-1.6 -1.5,-1.3l-1,3c-0.3,0.9 -1.2,3.5 -1,4.5c0,1 0.5,2.4 0.8,2.4"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M260.6,283.6l-0.6,0.3l-0.2,0.8c0.1,0.3 0.6,0.6 0.6,0.6l0.4,0l0.7,-0.2c0,0 0.3,-0.3 0.3,-0.7c0,-0.333 -0.1,-0.5 -0.3,-0.5l-0.9,-0.3Zm5,-4.1c-0.467,-0.067 -0.7,-0 -0.7,0.2l0,0.5c0,-0 0,0.6 0.3,0.7c0.3,0.1 0.8,0.3 1,0.1c0.2,-0.133 0.333,-0.367 0.4,-0.7c0,-0.4 -0.6,-0.6 -0.6,-0.6l-0.4,-0.2Zm4,1c-0.067,-0.2 -0.3,-0.3 -0.7,-0.3c-0.4,-0 -0.567,0.3 -0.5,0.9c0.2,0.467 0.533,0.6 1,0.4c0.4,-0 0.3,-0.6 0.3,-0.7l-0.1,-0.4l0,0.1Zm-11.6,0.7c0.067,0.4 0.4,0.633 1,0.7c0.481,0.01 0.904,-0.329 1,-0.8c0,-0.3 -0.3,0.3 -0.7,0.4l-0.9,-0l-0.3,-0.3l-0.1,0Z"
      style="fill: #adadad; fill-rule: nonzero"
    />
    <path
      d="M261.8,284.4c0,-0 0,0.5 -0.3,0.8l-0.8,0.2c-0.267,-0 -0.467,-0.067 -0.6,-0.2l-0.3,-0.6c0,-0 0.4,0.7 1,0.5c0.6,-0.2 1,-0.7 1,-0.7m10.7,-6.6c0,-0 0,0.5 -0.4,0.7c-0.4,0.2 -0.667,0.267 -0.8,0.2c-0.267,-0 -0.467,-0.1 -0.6,-0.3c-0.5,-0.7 -0.2,-1.2 -0.2,-1.2c0,-0 0.3,1.3 1,1.2c0.7,-0.1 1,-0.6 1,-0.6m-9.5,2.2c0,0 -0.4,1 -1,1c-0.6,0 -0.6,-0.1 -0.6,-0.3l0.6,0c0.3,0 1,-0.6 1,-0.6l0,-0.1Zm1.8,-0.1c0,0 0,0.7 0.2,1c0.2,0.2 0.467,0.3 0.8,0.3c0.333,0 0.567,-0.1 0.7,-0.3l0,-0.6l-0.1,0.3l-0.6,0.3c-0.267,0 -0.5,-0.1 -0.7,-0.3l-0.3,-0.7Zm3.4,-3.5c0,0 0.2,0.5 -0.2,1c-0.4,0.5 -1.2,0.2 -1.2,0.2c0,0 0.6,0.1 1,-0.2c0.3,-0.4 0.4,-1 0.4,-1"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M257.4,288.9c0,-0 4.2,-0 4.5,-0.7c0.4,-0.5 -0.3,-2.8 2.2,-4.6c2.5,-1.8 4.5,-1.8 5.9,-1.9c1.3,-0 4.2,-1 4.8,-3.6c0.3,-1.6 -1.9,-1.7 -2.7,-3.2c-0.8,-1.5 -2.9,-0.9 -3,-0.9c0,-0 -2.4,-0 -3.5,1c-0.6,0.7 -0.5,1.5 -0.9,1.8c-0.2,0.4 -3,-0 -3.3,0.5c-0.3,0.5 0,1.4 -0.2,1.6c-0.2,0.2 -0.8,-0.6 -0.8,-0.6l0.2,-2.3l3.5,-2l4,-2.3l2.8,-0l2.8,1.5l1.4,1.6c0,-0 0.3,0.6 0.4,1.8l-0.1,1.6c-0.813,2.306 -2.957,3.895 -5.4,4c-2.4,0.1 -4.6,1.2 -5.6,2c-1.1,0.8 -1.7,4.3 -1.7,4.7c0,0.4 -5.2,0.2 -5.2,0.2l-0.1,-0.2Z"
      style="fill: #373737; fill-rule: nonzero"
    />
    <path
      d="M259.1,280.7c-0.267,0.2 -0.467,0.167 -0.6,-0.1c-0.2,-0.7 0.3,-1.7 0.3,-1.7l0,1.2l0.4,0.3l-0.1,0.3Zm2.7,-0.6c-0.2,0 -0.2,-0.7 0,-1l1.3,-1.1l-0.5,1.2c-0.1,0.3 -0.5,1 -0.8,1l0,-0.1Zm-1,4.3c-0.2,0 -0.3,-0.267 -0.3,-0.8c0,-0.8 0.8,-1.3 0.8,-1.3l-0.2,1l0,0.7c0,0.267 -0.1,0.4 -0.3,0.4"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M262.7,283.2l-0.8,0.7c-0.467,0.333 -0.833,0.5 -1.1,0.5c-0.3,0 0.1,-0.6 0.3,-0.7l1.6,-0.5Zm3.6,-5.1l-0.7,1c-0.267,0.6 -0.267,0.933 0,1c0.2,0.2 0.5,-0.6 0.5,-0.8l0.2,-1.2Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M267.6,279.9c0,-0 -0.3,-0.3 -0.9,-0.5c-0.6,-0.067 -0.933,-0 -1,0.2c0,0.2 -0.4,0.4 -0.2,0.6l0.7,-0.3l0.7,-0.1l0.8,-0l-0.1,0.1Zm-0.7,-3.5c0.2,-0 0.467,-0.167 0.8,-0.5l0.5,-1l-0.8,0.5c-0.4,0.333 -0.567,0.667 -0.5,1m5.5,-0.2l-1,0.7c-0.267,0.333 -0.367,0.6 -0.3,0.8c0.267,0.067 0.5,-0.067 0.7,-0.4l0.6,-1l0,-0.1Zm-1.6,3.7c0,-0 -0.2,0.5 -0.7,0.8c-0.5,0.3 -1,0.4 -1,0.3c-0.133,-0.267 -0.067,-0.467 0.2,-0.6l0.7,-0.2l0.8,-0.3Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M235.408,264.451c1.254,0.192 2.043,1.854 1.759,3.709c-0.284,1.854 -1.533,3.205 -2.788,3.013c-1.255,-0.193 -2.043,-1.854 -1.759,-3.709c0.284,-1.855 1.533,-3.205 2.788,-3.013Z"
      style="fill: url(#_Radial1)"
    />
    <path
      d="M236.3,261.5l-1.4,3.5l1.1,-0.2l0.7,-3l-0.4,-0.3Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M237,260c-0.667,0 -1,0.333 -1,1c-0.067,0.467 0.167,0.8 0.7,1c0.6,0 0.933,-0.3 1,-0.9c0.067,-0.6 -0.2,-0.933 -0.8,-1l0.1,-0.1Zm58.8,8.6l-3.4,3.2l1.4,0.3l2.3,-3l-0.3,-0.5Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M297.3,267.3c-0.667,-0.2 -1.233,-0.033 -1.7,0.5c-0.124,0.171 -0.191,0.377 -0.191,0.588c0,0.393 0.232,0.751 0.591,0.912c0.5,0.3 1.3,0 1.6,-0.5c0.124,-0.171 0.191,-0.377 0.191,-0.588c-0,-0.393 -0.232,-0.751 -0.591,-0.912l0.1,0Zm-87.1,-16.9l1.8,3.9l0.8,-1l-2,-3l-0.6,0.1Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M209.5,248.7c-0.247,0.189 -0.392,0.483 -0.392,0.794c0,0.265 0.105,0.519 0.292,0.706c0.467,0.533 0.967,0.6 1.5,0.2c0.247,-0.189 0.392,-0.483 0.392,-0.794c-0,-0.265 -0.105,-0.519 -0.292,-0.706c-0.185,-0.282 -0.5,-0.452 -0.836,-0.452c-0.245,0 -0.481,0.09 -0.664,0.252Z"
      style="
        fill: #acacac;
        fill-rule: nonzero;
        stroke: #777;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M237.3,260.2c0,0 0.2,0.2 0,0c-0.4,0 -1.2,0.3 -1.2,0.9c0.067,0.533 0.333,0.8 0.8,0.8l-0.6,0l-0.4,-0.8l0.1,-0.5l0.3,-0.4l0.4,-0.1l0.3,0l0.3,0.1Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M236.5,262.5c0,0 -0.2,0 -0.4,0.3l-0.6,0.8l0.7,-1.9l0.5,0.2l-0.2,0.6Zm61,5.1c0,-0 0.3,0.3 0,-0c-0.3,-0.3 -1.4,-0.2 -1.7,0.4c-0.2,0.667 -0.033,1.1 0.5,1.3c0.5,0.2 -0.2,-0 -0.2,-0l-0.5,-0.4l-0.1,-0.4l0,-0.6l0.4,-0.4l0.6,-0.3l0.5,-0l0.6,0.4l-0.1,-0Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M295.5,269.8l-0.6,0l-1.2,0.7l1.9,-1.7l0.4,0.5l-0.5,0.5Zm-85.6,-21.3c0,0 0.3,-0.1 0,0c-0.3,0.3 -0.6,1.2 -0.2,1.6c0.373,0.319 0.927,0.319 1.3,0c0.4,-0.3 0,0.2 0,0.2l-0.6,0.3l-0.4,0l-0.5,-0.2l-0.3,-0.5l0,-0.6l0.1,-0.5l0.3,-0.2l0.3,-0.1Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M211.2,251c-0,0 -0.2,0.2 -0.1,0.6l0.2,1.2l-1,-2.2l0.5,-0.2l0.4,0.6Z"
      style="fill: #777; fill-rule: nonzero"
    />
    <path
      d="M216.487,256.658c0.93,1.818 0.688,3.804 -0.54,4.433c-1.228,0.629 -2.981,-0.337 -3.911,-2.155c-0.93,-1.818 -0.688,-3.804 0.54,-4.433c1.228,-0.628 2.981,0.337 3.911,2.155Z"
      style="fill: url(#_Radial2)"
    />
    <path
      d="M210,257c0,0 0.8,0.2 1.2,0c0.4,-0.333 0.6,-0.567 0.6,-0.7l0.2,-0.7l-0.8,-1.2l-0.8,0c0,-0.2 -0.067,-0.367 -0.2,-0.5c-0.2,0 -1.3,1.3 -1.1,1.5c0.2,0.2 0.3,-0.1 0.4,0l0,1l0.5,0.6Z"
      style="fill: #6c6c6c; fill-rule: nonzero"
    />
    <path
      d="M211.2,254.5c-0,0.2 0.5,0.8 0.7,0.8l0.9,0c0.1,0 0.7,-0.5 0.7,-0.8l-0.1,-0.6c-0.1,-0.2 -0,-0.8 -0.3,-0.9c-0.133,0 -0.233,-0.067 -0.3,-0.2l-0.2,-0.5c-0.1,-0.3 -2,0.8 -1.8,1l0.4,0.2l0,1Z"
      style="fill: #6c6c6c; fill-rule: nonzero"
    />
    <path
      d="M215.4,254l-0.1,-1.4c-0.267,0 -0.467,-0.1 -0.6,-0.3c0.133,-0.067 0.233,-0.2 0.3,-0.4c0.1,-0.3 -2,0.1 -2,0.3c0.2,0.3 0.5,0.1 0.5,0.3l-0.4,0.5l0.2,0.9l0.2,0.4l0.5,0.1l1.1,0l0.3,-0.4Zm17.5,10.3c0,0 0.3,0.6 0.7,0.7l0.7,0c0.2,0 0.4,-0.1 0.6,-0.3l0.3,-1.1l-0.5,-0.6l0.2,-0.4c0,-0.2 -1.6,0 -1.6,0.2c0,0.2 0.2,0.1 0.2,0.3l-0.6,0.5l0,0.7Z"
      style="fill: #6c6c6c; fill-rule: nonzero"
    />
    <path
      d="M235,263.6l0,1l0.5,0.5l0.9,0l0.3,-0.5l0.4,-0.6l-0.1,-0.4c0.133,-0.067 0.233,-0.2 0.3,-0.4c0.1,-0.3 -1.7,-0.8 -1.7,-0.6l0.1,0.4c0,0 -0.6,0.4 -0.6,0.6l-0.1,0Z"
      style="fill: #6c6c6c; fill-rule: nonzero"
    />
    <path
      d="M237.8,266c0.2,-0.1 0.8,-0.7 0.8,-1l-0.1,-0.4l0.4,-0.1c0,-0.1 -1.3,-1.3 -1.3,-1c-0.1,0.2 0.2,0.3 0,0.4l-0.4,0l-0.5,0.7l-0.1,0.3l0.1,0.4l0.7,0.7l0.4,0Zm52.9,4.4c0,0 0,0.6 0.3,1l0.6,0.3l0.6,0c0.2,0 0.7,-0.7 0.7,-0.9l0,-0.7l0.2,-0.2c0.1,-0.2 -1.3,-0.9 -1.4,-0.6l0,0.3l-0.7,0.2l-0.3,0.6Z"
      style="fill: #6c6c6c; fill-rule: nonzero"
    />
    <path
      d="M292.7,270.8l-0.5,0.6l0,0.7l0.9,0.4l0.4,-0.2c0.333,0 0.567,-0.1 0.7,-0.3l0,-0.3l0.5,-0.2c0.1,-0.1 -1,-1.3 -1.1,-1.2l0,0.3l-0.9,0.2Z"
      style="fill: #6c6c6c; fill-rule: nonzero"
    />
    <path
      d="M293.2,273.8l1,0l0.3,-0.4l0.3,0.1c0.2,0 0,-1.5 -0.1,-1.4c-0.133,0.067 -0.2,0.167 -0.2,0.3c-0.2,0 -0.333,-0.1 -0.4,-0.3l-0.7,0.1c-0.2,0 -0.333,0.067 -0.4,0.2l-0.1,0.3l0,0.9l0.3,0.2Z"
      style="fill: #6c6c6c; fill-rule: nonzero"
    />
    <path
      d="M211.3,255.3c0.2,0.2 0,0.8 -0.2,1c-0.1,0.2 -1,0 -1,-0.2l0,-0.7c0.133,-0.2 0.367,-0.367 0.7,-0.5c0.267,0.067 0.433,0.2 0.5,0.4m0.3,-1.2c-0.067,0.333 0,0.533 0.2,0.6c0,0.2 0.7,0.3 1,0.2c0,0 0.4,-1.1 0.2,-1.3c-0.133,-0.133 -0.333,-0.167 -0.6,-0.1l-0.8,0.6Zm2.2,-1l0,0.6c0,0 0.5,0.4 0.8,0.4c0.2,0 0.3,-0.8 0.3,-1c0,-0.2 0,-0.1 -0.2,-0.2l-0.9,0.2Zm20.9,11c0,0.3 -0.6,0.5 -0.8,0.5c-0.2,0 -0.5,-0.7 -0.4,-0.8c0,-0.133 0.133,-0.233 0.4,-0.3l0.7,0l0.1,0.6Zm0.8,-0.5c-0.133,0.067 -0.2,0.233 -0.2,0.5c0,0.1 0.2,0.6 0.4,0.7c0.2,0.1 1,-0.4 1,-0.6l-0.3,-0.4l-0.9,-0.2Zm2,0.8c-0.2,0.067 -0.333,0.2 -0.4,0.4l0.2,0.7c0.333,0 0.6,-0.1 0.8,-0.3l0,-0.3l-0.6,-0.5Zm54.8,6.6l-0.8,0c-0.2,0 -0.2,-0.9 0,-0.9l0.4,-0.1c0.2,0 0.367,0.133 0.5,0.4l-0.1,0.6Zm0.8,0l-0.5,0.2l0,0.8c0.1,0.1 1,0.2 1,0c0.2,0 0.1,-0.4 0.1,-0.4l-0.6,-0.6Zm0.9,1.6l-0.5,0l-0.3,0.6c0,0.2 0.5,0.3 0.6,0.3c0.133,0 0.233,-0.067 0.3,-0.2l-0.1,-0.7Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M293,272.064c0.666,0.737 0.01,2.417 -1.464,3.749c-1.474,1.332 -3.212,1.815 -3.878,1.078c-0.666,-0.737 -0.01,-2.417 1.464,-3.749c1.474,-1.332 3.212,-1.815 3.878,-1.078Z"
      style="fill: url(#_Radial3)"
    />
    <path
      d="M228.6,223.4c0,0 -3,0.3 -5.2,0c-2,-0.4 -1.6,-5.9 -1.7,-6c0,-0.2 -1.3,-1.5 -1,-2.7c0.2,-1.2 4,-4.4 4.6,-4.6c0.4,-0.1 1.2,0.2 1.2,0.2c0,0 1,-1 1.3,-1c0.3,0 0.7,0.6 0.6,0.8c-0.2,0.3 -1.5,1 -1.6,1.7c0,0.6 -0.133,1.2 -0.4,1.8c-0.4,0.6 -1.1,1.4 -1.2,1.9c-0.2,0.6 -0.2,0.967 0,1.1c0.4,0.2 1.7,0 2.8,-0.5l1.7,-1c0.2,0 -0.6,1.3 -1.8,1.8c-1.2,0.5 -2,1.1 -2.7,1c0,0 -0.6,1.6 1.4,1.7c2.1,0.1 3.3,-0.4 3.3,-0.4l-1.3,4.2Zm-12,12.8c-0,0 1.7,0.6 1.7,2.4c-0,1.8 -1.8,3.3 -1.7,6.5c-0,3.2 0.5,3.2 4.7,6.6c0.1,0 1,1 1.2,2c0.3,1 1,7 5,7c4,0 4.6,-2.5 4.6,-2.5l-1.7,-2.5c-0,0 -1.4,0.4 -2.2,0.2c-0.816,-0.281 -1.473,-0.901 -1.8,-1.7c-0.5,-1 -0.6,-3.3 -1.3,-4.3c-1.7,-2.5 -4.7,-3 -4.7,-5.6c-0,-2.7 1.9,-3 1.3,-6.1c-0.6,-3.1 -4.3,-4.7 -4.3,-4.7l-1.5,-0.6l-0.5,3.1l1.2,0.2Z"
      style="fill: #979797; fill-rule: nonzero"
    />
    <path
      d="M227.8,214.1c1.3,-0.3 0.5,-3.8 0.5,-3.8l-0.9,0.7c0,0 0.6,0.8 0.6,1.6c0,0.8 -0.2,1.5 -0.2,1.5"
      style="fill: #929292; fill-rule: nonzero"
    />
    <path
      d="M230.2,249.2l-0.7,-0.6c-0.4,-0.3 -2.6,-2 -2.2,-7c0.4,-5.8 8.7,-8.8 9.2,-11.1c0.7,-2.6 2.6,-3.7 -4.1,-8.9l-1.6,1.9l2.8,2c-0,-0 0.6,-0.3 0.6,0.5c-0,0.7 -0.7,1.4 -1,2c-0,0.5 -4.2,3.4 -4.5,3.7l-2.4,2c-0,-0 -1.1,1 -2.1,3.2c-1,2.2 -0.5,5 -0.5,5c-0,-0 -0,6.2 6.5,7.3"
      style="fill: #979797; fill-rule: nonzero"
    />
    <path
      d="M226.2,252.4l0.4,2.2l-1.3,0.5l-0.6,0l-0.4,0.1l-1,1l-0.3,0l-0.2,-0.7l-0.1,-1.1l1.2,0.5l0.5,0l0.3,-0.1l0.5,-1.2l1,-1.2Zm-4,0.4l-0.5,-0.8l-0.8,-0.7l1,-0.5l1,-0l-0.2,1.2l-0.5,0.8Zm2.3,-3.5c-0,-0 0.6,0.3 0.8,0.8l0.5,1l-1.6,-0.1l-1.1,-0.4l0.7,-1l0.7,-0.3Zm-0.6,9.6c-0,0 -0.3,-0.2 -0.5,-0.7l-0.3,-1.3l1,-0.2l1.2,0.5l0.3,0l-0.3,0.6l-1.1,1l-0.3,0.1Zm4,-3.3c0,-0 -0.8,-0.3 -1,-0.7l-0.2,-0.4l-0.3,1.2l-0.4,1.2l0.1,0.2l1,-0.3l0.6,-0.7l0.2,-0.5Zm-3.7,3.8l1,0.6l1,0.4l0.6,-0.5l0.4,-1l0.1,-0.1l-2.5,0.2l-0.6,0.4Zm3.5,-1l2.1,-1.2l0.1,-1.1l-0.4,-0.3l-1.2,0l-0.3,1.4l-0.3,1.3l0,-0.1Zm-1.5,2c0,0 1.5,0.7 4,-0.2c1.067,-0.6 1.533,-0.933 1.4,-1l-1,-0.4l-1,0.8l-3.4,0.8Zm-2,-16.2l-0.3,-1l-0.1,-1l0.7,0.4l1.1,0.8l-0.7,0.6l-0.7,0.2Zm1.8,3l-0.7,-0.8l-0.5,-1l0.8,0.2l0.9,0.5l-0.4,1.1l-0.1,0Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M221.3,213.7c-0.2,0.5 -0.4,1.4 0.3,1.6c0.4,-0 2,-0 3.7,-2c0.8,-1 0.8,-2 0.8,-2l0.4,-1c0,-0 -0.7,-0.5 -1.8,0.2l-3.4,3.2Z"
      style="fill: #bbb; fill-rule: nonzero"
    />
    <circle cx="226" cy="210.9" r="0.3" style="fill: #252525" />
    <path
      d="M223.8,211.2c-0.8,0.6 -1.4,1.3 -1.4,1.3c0,-0 1.1,-0.3 2,-1.1c0.626,-0.482 1.417,-0.697 2.2,-0.6c0.133,-0.067 0.133,-0.2 0,-0.4c-0.3,-0.2 -1.1,-0.3 -1.3,-0.2c0,-0 -0.8,0.4 -1.5,1"
      style="fill: #979797; fill-rule: nonzero"
    />
    <path
      d="M227.3,243.6l0,-1.8l-0.7,0.6l-0.7,1l1,0.3l0.4,-0.1Zm-3.6,-2l-0,-1.9c-0,-0.9 0.4,-2.5 0.4,-2.5l0.4,1.1l1.3,2l0.4,0.3l-1,0.7l-1.2,0.4l-0.3,-0.1Zm3.6,-0.6l0.2,-0.8l0.4,-1l-1.1,1l-0.5,0.4l0.6,0.5l0.4,-0.1Zm-3,-4.7c-0,0 0.2,-0.6 0.7,-1.3l1.1,-1.5l0.5,2l0.3,1.6l-0,0.3l-0.5,0.2c-0.1,0 -1.3,0 -1.5,-0.3l-0.6,-1Zm3.8,2.2l1.5,-1.5l-2.6,0.5l0.4,0.8l0.7,0.2Zm-1.5,-5.3l0.9,-0.8c0.7,-0.7 1,-0.6 1,-0.6l0.3,2.8l-1.3,-0.4l-0.9,-1Zm3.2,3.8l1.6,-1.6l-2.6,-0.8l0.5,1.8l0.5,0.6Zm1.1,-4.2l0.2,-2.7l-1.2,0.8l-1,0.8l0.3,0.4l1,0.6l0.7,0.1Zm2.3,-2.6l-0,-2l-1.5,1.5l0.7,0.4l0.8,0.1Zm1,2.8l1.2,-1l1.2,-1.3l-3.3,-0.3l0.1,1.4l0.8,1.2Zm-7.8,-11l-0,1.5l2.7,0l-0.7,-1l-0.8,-0.5l-0.8,-0.8l-0.4,0.8Zm5.4,13l1.2,-1l1,-0.8l-2.7,-0.3l0.1,1.8l0.4,0.3Zm5,-4.8c0,0 0.3,-1 0.3,-2l-0.2,-1.5l-2,1.3l0.3,1l0.8,0.9l0.8,0.3Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M233.4,227.8c0,0 0.6,-0.7 0.7,-1.1l0,-0.3l1.6,0l0.9,0.1l0.1,0.1l-0.7,0.8l-1,0.6l-1.2,0.1l-0.4,-0.3Zm3.2,-1.5l-1,-1.7l-0.6,-0.8l-0.8,2.2l0,0.3l2.4,0Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M217.3,241.8l-0.3,0.6c0,0 1,-0.6 1.9,-0.5c0.9,0.1 1.7,1 1.7,1l0.2,-0.7c0,0 -1.1,-1 -1.8,-1.1c-0.7,0 -1.7,0.7 -1.7,0.7m0.5,-4.7l0.3,0.3c0,0.1 0,-0.7 1.1,-1.2c1,-0.4 1.7,0 1.7,0c0,0 -0.2,-0.7 -0.7,-0.8c-0.533,-0.133 -1.033,0 -1.5,0.4c-0.6,0.4 -0.9,1.3 -0.9,1.3m3.6,3.5c0,0 -0.5,-1 -1.4,-1.3c-0.8,-0.2 -1.9,0.5 -1.9,0.5l-0.2,0.5c0,0 1.2,-0.6 2,-0.3c0.9,0.4 1.3,1.4 1.3,1.4l0.2,-0.8Zm-4,-4l0.3,0.3c0,0 -0.2,-1 0.4,-1.7l0.9,-0.8l-0.5,-0.2c0,0 -0.7,0.5 -1,1c-0.2,0.6 -0.233,1.033 -0.1,1.3l-0,0.1Zm-0.5,-2c0.3,-0.5 1,-0.7 1,-0.7l-0.3,-0.2l-0.3,0c-0,0 -0.4,0.2 -0.7,0.8c-0.3,0.6 -0.3,1.6 -0.3,1.6l0.5,0.2c-0,0 -0.1,-1 0.1,-1.6l0,-0.1Zm6.3,-15.2c0.733,-0.267 1.133,-0.367 1.2,-0.3c0.1,0.1 -1,1 -0.5,2.3c-0.6,1 -0.8,1.9 -0.8,1.9l0.6,-0l0.3,-1.5c0.363,0.674 0.876,1.256 1.5,1.7l0.8,-0c0,-0 0,-1 0.5,-2c0.423,0.529 0.974,0.942 1.6,1.2l0,-0.3c0,-0 -0.9,-0.5 -1.4,-1.2l0,-0.1c0.6,-1 1.4,-1.3 1.4,-1.3l0.6,0.4l0.1,-0.1l-0.4,-0.6l-0.5,-0l-1.4,1.4l-0.6,-1.3l-0.4,-0c0,-0 -0.8,-0 -1.6,1.3c-0.1,-1 1,-2 1,-2l-0.1,-0.3l-2,0.4c-0.7,0.3 -1.2,1 -1.2,1l0,0.6c0,-0 0.7,-0.8 1.3,-1.2m1.2,1.7c0.5,-0.7 1.5,-1.2 1.5,-1.2c0,-0 0,0.6 0.7,1.3c-0.4,0.8 -0.6,1.9 -0.6,1.9c0,-0 -0.9,-0.6 -1.6,-1.6l-0.1,-0.3l0,-0.1l0.1,-0Zm-6,16.9l0,0.6c0,-0 0.6,-0.7 1.5,-0.7c0.9,-0 1.8,0.7 1.8,0.7l0,-0.9c-0.2,-0 -1,-0.5 -1.7,-0.5c-0.8,-0 -1.7,0.8 -1.7,0.8l0.1,-0Zm17,-9l-0.3,-0.8l0.4,-0.2l1.4,-1.3l-0.3,-0.4l-1.3,-0l-1.1,-0.1l0.4,-1.4l0.4,-1.1l-0.4,-0.4c-0,-0 0.1,0.4 -0.7,0.5l-2.2,-0.7l-0,0.4l2,0.5l1,-0.2l-0.5,1l-0.2,0.8l0.2,0.1l-0.1,0.7l1.1,0.1l1.4,0.1c-0,-0 -0.7,0.8 -1.4,1.1l-0.3,0.1l-0.8,-1.2l-0,0.4l0.5,1l-1.2,-0.2l-0.3,0.3l-0,2l-1.4,-0.4l-0.6,0.4c-0,-0 -0.3,1.2 -0.3,2.6c-1.2,-0.3 -1.9,-1 -1.9,-1l-0.3,0.2c-0,-0 -0.2,1.2 0.1,2.6c-0.752,-0.237 -1.437,-0.648 -2,-1.2l-0.4,0.4l0.4,3.5l0.1,0.3l-0.6,-0c-1,-0 -1.8,-1.1 -1.8,-1.1l-0.3,0.8c-0,-0 0.4,2.2 1.6,3.2l0.3,0.2c-1,0.8 -2.3,1 -2.3,1l0.1,0.6l1.7,1.3l-1.3,0.7l0.2,0.4l1.4,-1l1.5,0.4l-0,-0.4l-1.2,-0.2l-0,-0.1c0.5,-0.4 1.2,-1.5 1.2,-1.5l-0,-0.8c-0,-0 -0.4,-0 -0.9,-0.4c1.5,-1 1.5,-1.5 1.5,-1.5l0.3,-0.5c-0,-0 -0.5,-0.2 -0.9,-1l2.4,-0.5l0.2,-0.2c-0,-0 -0.6,-0.9 -0.9,-2l2.4,0.5l0.4,-0.4c-0,-0 -0.3,-0.9 -0.4,-2l2.5,0.3l0.3,-0.3c-0,-0 -0.8,-1.5 -0.8,-2.3l-0,-0.1l3.2,-0l0.2,-0.4c-0,-0 -1,-0.7 -1.4,-1.2m-8.4,12.4c-0,-0 -0.3,0.8 -1,1.6l-0.3,0.2l-0.4,-0.2c-0.733,-0.6 -1.067,-0.933 -1,-1l2,-1.3l0.7,0.7Zm0.7,-2.5l-1.5,1.5l-0.3,-0.4c-0.7,-0.9 -1.6,-1.6 -1.5,-3c-0,-0 0.5,1 1.7,0.9l0.8,-0.2c0.4,0.8 0.667,1.2 0.8,1.2m1.6,-2l-2,0.5l-0.2,-0.3c-0.4,-1.3 -0.4,-3.2 -0.4,-3.2c-0,-0 0.9,0.6 2,0.9l0.6,2.1Zm-0.3,-2.4c-0.2,-1.1 -0,-2.3 -0,-2.3c-0,-0 0.7,0.6 1.9,0.8l0.2,1.7l-2.1,-0.2Zm4.6,-1.8c-0,-0 -0.7,0.3 -2.2,0.1l-0,-2.8l1.8,0.5l-0,0.1l0.4,2.1Zm-0,-2.5l-0.2,-0l-0,-2.1c-0,-0 0.8,0.2 1.4,0.1c-0,0.267 0.133,0.6 0.4,1c0.3,0.6 0.9,1 0.9,1c-0,-0 -1.9,0.2 -2.6,-0l0.1,-0Zm-6,15l-0.2,-0.5c-0,-0 -0.7,0.5 -1,1.1l-0.2,-0l-1.6,-0.7l0.2,0.3l1.5,0.6l-0.3,1.2l0.2,0.3c-0,-0 -0,-0.8 0.4,-1.4l1,-0l-0.2,0.7l-0.3,1.2l0.3,0.2l1.7,-0l-0.3,-0.3l-1.5,-0l0.3,-1l0.2,-0.6l-0.2,-0.6l-0.9,0.1l0.8,-0.7l0.1,0.1Zm-9.1,-1.1c0.661,0.029 1.294,0.275 1.8,0.7l-0,-0.5c-0,0 -0.8,-1 -1.7,-1c-1,0 -2,0.9 -2,0.9l-0,1c-0,0 0.9,-1.1 1.9,-1.1m10.6,15.5c-1,0.5 -2.2,0.5 -2.2,0.5l0.7,-1.3c2,-0.5 2.4,-1.9 2.4,-1.9l-0.1,-0.5c-0,0 -0.5,1.3 -2.2,2l0.6,-2.6l-0.5,-0.2c-0,0 -0.8,1 -1.6,1.3c0.339,-0.688 0.542,-1.435 0.6,-2.2l-0.2,-0.4c-0,0 -0.6,0.5 -1.4,0.6l-0.5,0c0.5,-0.6 1.4,-2.5 1.4,-2.5l-0.1,-0.4c-0,0 -0.7,1.7 -1.4,2.5l-0.3,0.3l-1.7,-0.8l-0,0.3c-0,0 0.7,0.5 1.5,0.8l-1,1l-0,0.8l2.4,0.3c-0.417,0.666 -0.961,1.244 -1.6,1.7l0.3,0.5c-0,0 1.1,0 3,-0.5l-1,1.5c-0.1,0 1.8,0.1 3,-0.5c1.2,-0.6 1.6,-1.2 1.6,-1.2l-0.4,-0.4c-0,0 -0.2,0.9 -1.3,1.3m-5.5,-3.3l1,-1.1c1.2,0.3 1.6,-0.1 1.6,-0.1c-0,0 0.2,0.7 -0.5,1.8l-2.1,-0.6Zm1.1,2.5l1,-1.3l0.3,-0.3c1.2,0 1.9,-1 1.9,-1c-0,0 0.1,1 -0.4,2.2c-1.6,0.6 -2.8,0.4 -2.8,0.4m-1.5,-7.9c1.2,0.1 2.6,0.6 2.6,0.6l-0.1,-0.6l-2.3,-0.4c0.4,-0.9 1.2,-1.3 1.2,-1.3l-0.4,-0.2c-0,0 -0.4,0 -1,1.2l-0.2,0.2l-0.3,0c-1,0 -1.9,0.6 -1.9,0.6l0.2,0.3c-0,0 0.9,-0.4 1.8,-0.4l-0.6,2l0.2,0.5l0.8,-2.5Zm-2.4,-4.9l-0.2,-0.6c-0,0 -1.3,-0.4 -2.2,0c-0.9,0.4 -1.6,1.5 -1.6,1.5l0.4,0.8c-0,0 0.6,-1.2 1.5,-1.5c0.9,-0.3 2.1,-0.2 2.1,-0.2m2.4,1.9l-0.8,-0.4c-0,0 -1.3,0.3 -1.8,0.8c-0.5,0.5 -0.9,1.7 -0.7,2c0.2,0.4 0.367,0.6 0.5,0.6c0.2,0 0.2,-1.3 0.9,-1.9c0.7,-0.6 1.9,-1.1 1.9,-1.1m-3,-0.4c0.4,-0.5 1.4,-0.7 1.4,-0.7l-0.5,-0.5c-0,0 -1.2,0.2 -1.8,0.7l-1.4,1.7l0.7,0.7l1.5,-1.9l0.1,0Zm4,-35.8c0.7,-0.8 1.3,-0.8 1.5,-0.8l0.6,0l-0.7,2c-0.2,0.8 -0.5,1 -0.8,1.5c-0.467,0.667 -0.8,1.433 -1,2.3c-0,0.8 0.167,1.233 0.5,1.3c0.267,-0.133 0.433,-0.3 0.5,-0.5c-0,-0.3 -0.2,0 -0.4,0c-0.2,0 -0,-0.3 -0.2,-0.8c-0,-0.5 0.6,-1.8 0.8,-2.2c0.4,-0.4 0.7,-0.933 0.9,-1.6c-0,-0.7 0.5,-2 0.5,-2c-0,-0.133 -0.333,-0.2 -1,-0.2c-0.611,0.054 -1.165,0.386 -1.5,0.9c-0.4,0.5 -1.4,0.9 -1.4,0.9c-0,0 1.1,0 1.7,-0.8"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M228.2,219.6l-2,0l0.5,1.5l1.5,-1.5Zm-2.4,0l-0.7,-0.7l-0.7,0.5l-0.4,1.5l0.2,0.2l1.6,-1.6l-0,0.1Zm-0.3,4l-1.4,-2.2l-0.8,1.7l0.4,0.2l1,0.1l0.8,0.1l-0,0.1Zm6,35.7l-0.1,0c-1.124,0.76 -2.444,1.177 -3.8,1.2c-0.867,0 -1.767,-0.233 -2.7,-0.7c-0.553,-0.355 -0.975,-0.882 -1.2,-1.5c-0.4,-0.933 -0.667,-1.967 -0.8,-3.1c-0.154,-1.051 -0.492,-2.067 -1,-3c-0.667,-0.933 -1.667,-1.8 -3,-2.6c-1.278,-1.038 -2.074,-2.558 -2.2,-4.2l-0,-0.6c0.047,-1.249 0.353,-2.476 0.9,-3.6c0.533,-1.067 0.833,-2 0.9,-2.8l-0,-0.4c-0.267,-0.6 -0.667,-1.1 -1.2,-1.5l-1,-0.6l-0.8,-0.3l-0,0.3l0.7,0.2l-0,-0.1l-0,0.1l1,0.7c0.533,0.4 0.867,0.833 1,1.3l-0,0.3c-0,0.667 -0.3,1.567 -0.9,2.7c-0.56,1.155 -0.867,2.417 -0.9,3.7c-0.064,1.957 0.833,3.826 2.4,5c1.2,1 2.4,1.6 3,2.6c0.467,1.067 0.8,2.4 1,4l0.6,2c0.267,0.667 0.733,1.2 1.4,1.6c0.853,0.493 1.815,0.767 2.8,0.8c2.3,0 4,-1.3 4,-1.3l-0.1,-0.2Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M229.7,255.4l-1,0.2c-0.527,-0.008 -1.031,-0.223 -1.4,-0.6c-0.533,-0.533 -0.833,-1.133 -0.9,-1.8c-0.067,-0.667 -0.3,-1.567 -0.7,-2.7c-0.667,-1.067 -1.633,-2.033 -2.9,-2.9c-1,-0.9 -2.1,-1.8 -2.3,-2.7l-0,-0.5c-0,-0.8 0.2,-1.667 0.6,-2.6c0.4,-0.933 0.667,-2 0.8,-3.2l-0,-0.6c-0.2,-1.6 -1.5,-2.8 -2.6,-3.6l-2.3,-1.1l-0,0.2l0.1,0c0.4,0.2 1.5,0.7 2.5,1.5c1.067,0.667 1.733,1.667 2,3l-0,0.6c-0,1.2 -0.233,2.233 -0.7,3.1c-0.467,0.867 -0.7,1.767 -0.7,2.7l-0,0.5c0.467,1.067 1.3,2.033 2.5,2.9c1.1,0.9 2.3,1.8 2.7,2.8c0.4,1.133 0.633,2 0.7,2.6c0.136,0.748 0.483,1.442 1,2c0.6,0.467 1.133,0.7 1.6,0.7l1.2,-0.3l-0.2,-0.2Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M237,249.3c0,0 1.5,0.3 1.4,1.4c0,1.2 -0.6,2.7 -0.6,2.7l-2,-1.7l1.1,-1l0.4,-0.5l-0.2,-1l-0.1,0.1Z"
      style="fill: #979797; fill-rule: nonzero"
    />
    <path
      d="M213.1,235.6c0,0 -1.4,0.5 -1.7,-0.1c-0.133,-0.6 -0.167,-1 -0.1,-1.2c0,-0.1 -0.9,-0.2 -0.8,-1c0.1,-0.8 1,-0.7 1.3,-0.7c0.2,0 0.3,-1.2 1,-1.2c0.7,0 1,0.9 1,0.9l-0.7,3.3Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M214.6,236c0,0 -1.1,0.6 -1.5,0c-0.4,-0.6 0,-1.3 -0.1,-1.4c-0.2,-0.1 -0.9,-0.4 -0.7,-1c0,-0.8 0.8,-0.5 1,-0.7c0.3,-0.1 0.5,-1.1 1.3,-1c0.7,0.2 0.8,0.8 0.8,0.8l-0.8,3.3Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M216.6,236.3c0,0 -0.3,0.7 -1.2,0.5c-0.9,-0.2 -0.5,-1.3 -0.7,-1.5c-0.2,-0.2 -0.7,-0.4 -0.6,-1.2c0.1,-0.8 0.9,-0.6 1.2,-0.7c0.3,-0.1 0.5,-1.3 1,-1.1c0.5,0.2 1.2,0.8 1,1.1c0,0 -1.1,0.4 -1.3,1.2c-0.2,0.8 0.6,1.7 0.6,1.7Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M235,249l-1.8,-2.1l-1.8,-2.2l-1.8,-0.9l-1.2,-1.9l0,-2.2l0.4,-1.3l0.7,-1c0,0 -3.7,1.4 -1.8,8.5c0.8,3 2.8,3.4 2.8,3.4l3.4,-0.2l1,-0.1l0.1,-0Z"
      style="fill: #6d6d6d; fill-rule: nonzero"
    />
    <path
      d="M233.3,225.4c0.333,0 0.533,0.067 0.6,0.2l0.1,0.6l0,0.2l0.1,0.1c-1.3,2.7 -3.9,4 -6.2,5.6c-1.195,0.825 -2.214,1.879 -3,3.1c-0.988,1.659 -1.474,3.57 -1.4,5.5c0.1,4 1.6,6.3 3.3,7.4c1.251,0.817 2.706,1.267 4.2,1.3l0.3,0l3.6,-0.3l1.4,0.1c0.4,0 0.633,0.1 0.7,0.3l0.2,0.4c0,0.333 -0.167,0.667 -0.5,1l-0.7,0.5l0,0.3l0.9,-0.6c0.333,-0.333 0.5,-0.733 0.5,-1.2l-0.2,-0.5c-0.2,-0.2 -0.5,-0.333 -0.9,-0.4l-1.4,-0.1l-3.6,0.2l0,0.2l0,-0.2l-0.2,0c-0.7,0 -2.5,0 -4.1,-1.2c-1.6,-1 -3.1,-3.2 -3.2,-7.2l0,-0.3c0,-2.133 0.4,-3.8 1.2,-5c1.2,-2 3,-3 4.8,-4.3c1.8,-1.3 3.5,-2.4 4.4,-4.5c0.9,-2.1 0,-0.2 0,-0.4l-0.1,-0.7c-0.133,-0.2 -0.4,-0.333 -0.8,-0.4l-0,0.3Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M238.3,250.1c0,0 -1,1.6 -1.2,1.7c-0.2,0.1 0.8,0.2 1,0.6l-0.2,0.4c0,0 -1,-0.7 -1.5,-0.7l-0.1,-0.6c0,0 0.5,-0.2 0.9,-0.6c0.3,-0.3 0.7,-1.1 0.7,-1.3l0.4,0.5Z"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M241.7,251.2l-2.2,0.6l-1.1,-0.7c-0,-0 -0,-0.9 -0.4,-1.3c-0.467,-0.333 -0.9,-0.567 -1.3,-0.7c-0.4,-0.2 -2,-0.2 -2,-0.2l-4,-4.3l1.5,0.2l2.4,-0.3l2.1,-0.2l1.2,0.2l1.2,0.3l0.6,0.6l0.7,0.6l0.7,1l0.4,1.3l0.2,1.3l0,1.6Z"
      style="fill: #ababab; fill-rule: nonzero"
    />
    <path
      d="M241.8,251c0,0 -0.8,0.3 -1.8,0.3c-1,0 -1.6,-0.2 -1.6,-0.2l-0.2,0.7l-0.4,1l0,2.6l2.1,0.4l1.1,-0.4l0.6,-2.8l0.1,-1.5l0.1,-0.1Z"
      style="fill: #6d6d6d; fill-rule: nonzero"
    />
    <path
      d="M241.2,250l-0,1l0.5,0l-0,-0.8l-0.5,-0.2Zm-2,-24l-0.2,-1.7l-0.7,-1.2l-0.9,-1.2l-0.9,-1l-0.5,-0.5l-0.2,-0.3l-2.3,0.1l-1.2,1.4c-0,0 3,2.2 4.3,4.6c1.067,0.4 1.8,0.867 2.2,1.4l0.1,-0.2l0.3,-1.4Z"
      style="fill: #ababab; fill-rule: nonzero"
    />
    <path
      d="M237,228c0,1.667 -0.2,2.667 -0.6,3l1.4,-1.6l1,-1.8c-0.622,-0.622 -1.373,-1.1 -2.2,-1.4c0.267,0.6 0.4,1.2 0.4,1.8"
      style="fill: #6d6d6d; fill-rule: nonzero"
    />
    <path
      d="M240.2,254.3l-1.1,-1.3l-1,-0.7l-0.2,0.2l0.1,0l1,0.7l1,1.3l0.2,-0.2Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M241.6,252.4c0,0 -0.2,0.8 -1,1.5c-0.8,0.7 -1.8,1.1 -1.8,1.1l2.2,0.9l1.5,-1.4l-1,-2.1l0.1,0Z"
      style="fill: #4f4f4f; fill-rule: nonzero"
    />
    <path
      d="M241.9,254.3l-0.6,0.6l-0.3,0.4l0.6,-2.4l0.4,0.7l0,0.4l-0.1,0.3Z"
      style="fill: #333; fill-rule: nonzero"
    />
    <path
      d="M228.6,223.4c0,0 -3,0.3 -5.2,0c-2,-0.4 -1.6,-5.9 -1.7,-6c0,-0.2 -1.3,-1.5 -1,-2.7c0.2,-1.2 4,-4.4 4.6,-4.6c0.4,-0.1 1.2,0.2 1.2,0.2c0,0 1,-1 1.3,-1c0.3,0 0.7,0.6 0.6,0.8c-0.2,0.3 -1.5,1 -1.6,1.7c0,0.6 -0.133,1.2 -0.4,1.8c-0.4,0.6 -1.1,1.4 -1.2,1.9c-0.2,0.6 -0.2,0.967 0,1.1c0.4,0.2 1.7,0 2.8,-0.5l1.7,-1c0.2,0 -0.6,1.3 -1.8,1.8c-1.2,0.5 -2,1.1 -2.7,1c0,0 -0.6,1.6 1.4,1.7c2.1,0.1 3.3,-0.4 3.3,-0.4l-1.3,4.2Z"
      style="
        fill: none;
        fill-rule: nonzero;
        stroke: #5d5d5d;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M255,200.5c0,0 -5.7,-1 -5.6,3.6c0,1.333 0.5,2.1 1.5,2.3c1.2,0.3 3.6,0.5 5.6,2.3c2,1.8 2.2,3.1 2.2,4.2c0,1 -0.5,2 -0.5,2l1.3,6.2l1.2,4.6l3.8,-2.2l2.3,-6.8l-2.9,-12.2l-8.9,-4Z"
      style="
        fill: #6b6b6b;
        fill-rule: nonzero;
        stroke: #2e2e2e;
        stroke-width: 0.3px;
      "
    />
    <path
      d="M260.5,224c0,0 2,-0.8 2.5,-2.4c0,-0.4 -2,-2.3 -2,-2.3l1.5,1c0.6,0.533 0.933,0.733 1,0.6c0.3,0 1.2,-2.1 0.8,-2.6c-0.4,-0.5 -0.9,-1.5 -1.7,-2c-0.8,-0.5 -1.9,-0.5 -1.9,-0.5c0,0 1.5,-0.5 2.3,0c0.7,0.3 0.8,0.8 0.9,0.6c0.005,-1.021 -0.164,-2.036 -0.5,-3c-0.267,-0.667 -0.8,-1.033 -1.6,-1.1c-1,-0.2 -1.9,-0.1 -1.9,-0.1c0,0 1.3,-0.8 2.3,-0.5c1,0.2 1,0.7 1,0.6l-0.7,-2.3c-0.444,-0.624 -1.026,-1.137 -1.7,-1.5l-1.4,-0.2l-0.5,0c0,0 0.7,-0.5 1.7,-0.4c1,0.1 1,0.4 1.1,0.4c0.2,0 -0.033,-0.2 -0.7,-0.6l-3.4,-1.6l-2.5,0c0,0 0,-0.7 0.7,-0.8c0.667,0 0.967,-0.033 0.9,-0.1c0,-0.2 -2.2,-0.7 -2.2,-0.7l-1.7,0l-2.4,0.3l0.5,-0.7c0.4,-0.267 0.767,-0.433 1.1,-0.5c0.9,-0.2 -0.4,-0.9 -0.4,-0.9l0.6,-1l3.2,0.2l6.5,3.9l3.1,2.6l2,5l-0.6,8.6l-4.4,3.6l-2,0.2l0.5,-1.8Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M254.8,202.7c0,-0 -0.2,-0.6 -0.2,-1.4l0,-0.7c0,-0 -2,-0.3 -3.5,0.9c-1.6,1.2 -0.7,3.3 -0.7,3.3c0,-0 0.7,-0.6 1.5,-1c0.9,-0.3 2.4,-0.2 2.4,-0.2c0.2,-0.2 -0.3,-0.8 -0.9,-0.9l-1.7,-0.1c0,-0 0.7,-0.5 1.8,-0.4c1,0.2 1.433,0.367 1.3,0.5"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M261.3,224.7l-1.4,0.5l0.9,6l5.7,9.7l3,-0.5l1,-1.8l0.7,0.3c0.4,0.4 1.5,2.3 2.4,2.7c1,0.3 1.4,0.2 2.3,0.9c0.9,0.7 3.9,5.2 4,5.3c0.2,0.2 -0.2,-1.9 -0.2,-1.9l-0.9,-2.7l-1.1,-1.9l-0.2,-0.5l1.5,-0l1,0.6l1.5,1.3l0.8,0.9l0.4,1l0.2,0.8l0.4,1.3l0.8,1.7l1,1.7l0.3,-0.6l-0.5,-2l-1.5,-4.9l-1,-1.6l1.6,1c0.4,-0 1.5,1.8 1.5,1.8l0.7,1.7l0.5,1.6l0.4,1.4l0.5,1.5l0.9,-0.5l-0.2,-1.1l-0.8,-3.4l-0.3,-3.6c0,-0 0.4,-0 1,0.6c0.6,0.6 1,1.9 1,1.9l0.3,3.2l0.5,3l1,3l1,2l0.7,1l0,-1.5l-1.2,-12.8l0.1,-0.5c0,0 0.2,-0.1 0.6,0.5l0.9,1.5l0.3,2l0.2,1.4l0.3,2.6l0.3,2.8l1.3,3l0.7,1.7l0.4,-2l-0.6,-13.6l0.3,-0.4l1,1l0.6,0.8l0.5,3l0.3,8.7l0.3,2.2l2.6,-22.6l1.5,-0.3l0.2,-0.5l-1.1,-0.8l-2.6,-4l-1.7,-3.9l-3,-5.6l-5.3,-6.4l-4.1,-3.4l-1.5,-1l0.2,-0.9l0.9,-1.4l-0.8,0l-1.8,0.3l-1.8,-0.6l-3.5,-2.4l-3.7,-1.8l-2.2,-0.8l-5.3,-1.3l-5.3,-0.7l-2.3,0l-2.2,0.3c0,0 -1,0.5 -1.4,1.2c-0.333,0.467 -0.433,1.167 -0.3,2.1c0,0.867 0.733,1.567 2.2,2.1c1.5,0.6 5,3 5,3l1.6,1.6l0.6,0.8l0.1,0.6l1.2,9l-2.3,4.8l-1.6,0.8Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M267,238.6c0,0 1,1.6 2.3,0.3c1.4,-1.2 -0.6,-4.8 -0.5,-5c0.1,-0.2 0.6,-0.3 0.6,-0.3l1,1.9c0,0 0.6,1 0.3,2.5c-0.2,1.6 -1.7,3 -1.7,3l-1.7,-0.5l-0.3,-1.9Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M300.2,259.4l-1.2,-3.6l-0.4,-2.8l-0.3,-7.5c-0.1,-1 0,-2.3 -0.2,-2.5l-1.3,-1.8l-0.5,-0.5l0.3,-0.3c0,0 0.5,0.5 0.6,0.3c0.133,-0.333 -0.033,-1.533 -0.5,-3.6c-0.7,-3.1 -3,-6.7 -3,-6.7l0.2,0.3l0.7,0.7l1.5,1.2l3.3,1.2l1.7,0.3l1.2,2.3c0,0 0.8,3.9 0.7,5.9c0,2 -0.1,3.6 -0.9,5.6c-0.8,2 -1,8.2 -1,9.2l-0.5,2l-0.4,0.3Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M300.2,249c0,0 0.7,-0.9 1,-2c0.3,-1 0.4,-9.9 -0.6,-11c-0.941,-0.854 -2.073,-1.471 -3.3,-1.8l0.8,2.9l0.7,1l0.5,1.5c0,0.7 0.7,2.5 0.8,4.8l0.1,4.6Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M295.4,254.4c-0,0 0.5,-4.1 0.3,-7.1c-0.2,-3 -0.5,-3.4 -0.8,-4c-0.838,-1.593 -1.508,-3.269 -2,-5c-0.667,-2.667 -1.2,-4.333 -1.6,-5c-0.5,-0.5 -1.4,-1.6 -1.6,-1.3c-0.2,0.3 -0.2,0.9 -0.2,0.9l-1.3,-0.3l-0.3,-0.8l0.4,-1.3l-0,-0.6l-0.2,-0.9l1.6,1.3l3.3,2.2l1.7,7l1.5,4.2l0.2,7.2l-0.1,6.4l-0.9,-2.9Zm2,-19.7l1.3,1c0.5,0.4 1.5,1 1.3,1l-1.6,-0.6l-1,-0.7l0,-0.7Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M291,252.8c0,0 0.6,-1.4 0.5,-3.3c-0.1,-1.9 -1,-6.3 -1.3,-6.8c-0.3,-0.5 -1.6,-1.4 -2.7,-4c-1.2,-2.4 -1.1,-3 -1.9,-3.8l-1.6,-2l0.3,-2.7l2.8,1.5l1.3,0.6l1.4,7l1.3,2l0.6,2.7l0.7,6.5l0.3,5.2l-0.2,0.5l-1.5,-3.4Zm-3.4,-3c-0,0 -0,-2 -0.4,-3.8c-0.467,-1.933 -0.967,-3.2 -1.5,-3.8c-1.221,-1.228 -2.326,-2.567 -3.3,-4l-3.1,-4l-0,-2.7l1.7,1.2l1.8,1l0.8,3l1,2.1l1.4,2l1,0.8l0.5,3.2l0.3,1.8l0.8,2.6l-0.3,1.3l-0.7,-0.7Zm-2.4,0l-0.8,-0.7c-0,0 0.5,-0.5 0.3,-1.5l-1,-3c-0.6,-1.5 -0.6,-1.6 -0.9,-1.9l-3.5,-3.2l-3,-2.6c-0.867,-0.467 -1.333,-0.667 -1.4,-0.6l-0.4,-3.2c-0,0 1,1.4 1.7,1.6l1.6,0.6l2.3,4l0.8,1l2,1.7l0.9,1.7l0.6,2l0.8,2.7l0.2,1.7l-0.2,-0.3Zm-4.4,-0.8c-0,0 -1.3,-1.5 -1.6,-2.5c-0.2,-1 0.2,-1 -0.2,-2.1c-0.687,-1.457 -1.717,-2.726 -3,-3.7c-1.1,-1 -2.7,-2.3 -2.6,-3c0.067,-0.667 0.167,-0.933 0.3,-0.8l0.7,0.6l3.5,3.8l1.1,2l0.9,2.5l0.5,1.1l0.5,1.5l-0.1,0.6Zm12.8,-18.6c-0,0 2.5,3 3.1,0.2c0.3,-1.2 -0.8,-3.6 -0.8,-3.6l-3,-5l-4.7,-5.8l-2.8,-1.3l1,1.6c-0,0 2,2 4.7,6.7c2.7,4.6 2.1,7 2.1,7l0.4,0.2Zm-14.2,-18.4c-0,0 4.9,4.2 8,8.7c3.1,4.5 4.4,7.5 3.7,8c-0.7,0.7 -2.7,-0.3 -3.5,-1.5c-0.8,-1.3 -1.5,-3.5 -4.4,-6.9c-2.9,-3.4 -4.4,-3.9 -4.4,-3.9l-2.2,-3.4l2.8,-1Zm-2.6,10c-0,0 3,2.4 4.7,4.3l2.8,3.4l1.1,1.1c-0,0 -0.6,-1.2 -0.2,-1.6c0.4,-0.4 0.8,-0.2 0.8,-0.2l-9.2,-9.7l-0,2.7Zm-0.6,0.2c-0,0 1,1.8 2.5,3.3l3.2,3.1l0.7,2.4c-0,0 -4.2,-3.2 -4.2,-2.4c0.181,0.855 0.52,1.669 1,2.4l-1.3,-0.7l-1.8,-2.5l-1,-2.3l-1.2,-3l2.1,-0.3Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M263.6,232.2c0,-0 2.2,2 3.4,-0c1.2,-1.9 0.2,-4 0.2,-4c0,-0 3.1,4.5 4,0.2c0.1,-0.8 -1.9,-3.7 -1.9,-3.7l0.7,-0.7l1.6,2.6c0,-0 1.5,-0.6 1.5,-2.4c0,-1.8 -1.6,-4.2 -1.6,-4.2l1.5,1.6c0,-0 2.8,-0 2.9,-1.7c0,-1.7 -2.4,-3.5 -2.4,-3.5c0,-0 2,0.1 2,-1c-0.1,-1.2 -2.7,-2 -2.8,-2.7c-0.1,-0.7 0.8,-1.9 2,-1.2c1.2,0.7 2.8,1.2 3.5,-0.1c0.7,-1.3 0,-1.6 0,-1.6l-1.7,-0.4l-2.8,-1.4l-2.1,-0.8l-2.2,-0.3l0.8,1.7l0.6,4.5l0,2.1l0.4,4.6l-1,3.8l-0.7,0.7l-0.4,0.5l-1,2l-1.2,1.5l-1.7,2.2l-1.6,1.7Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M279,240.7c0,-0 -0.5,-1.3 -1.7,-2.3c-1.2,-1 -3,-1 -3,-1l3.2,3.4l1.5,-0.1Zm4.5,0.8c0,-0 -1,-2 -2.2,-3.3c-1.2,-1.3 -2,-3 -2.4,-3l-0.5,0.1l0.3,2.6l2.2,2.2c0,-0 2,1.5 2.6,1.4m3.7,-0.2c0,-0 -0.5,-2.4 -1.7,-4.7c-1.2,-2.3 -2.6,-3.3 -2.6,-3.3l0.3,2.5l1,2.4l1.7,2.4l1.3,0.7Zm3,-1.3c0,-0 0.9,-5 0.1,-6.3c-0.506,-0.811 -1.287,-1.415 -2.2,-1.7l-0.5,0.7l0.5,3.6l1.1,2.7l1,1Zm3,-8.3c-0,0 0.7,0.4 1.6,2c0.9,1.6 2.1,6.7 2.1,7c-0,0.3 -0.5,0.1 -0.6,0l-3,-4.7l-0.6,-4.3l0.5,0Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M272.3,237.5c0,0 1.6,-0.4 1.6,-1c0,-0.6 -2,-1.6 -1.8,-2.5c0.1,-0.4 1.6,0.1 1.7,-0.2c0.2,-0.3 -1.5,-3 -1,-3.6c0.5,-0.6 2,2.9 2,2.9c0,0 0.8,1.6 0.5,2.5c-1,3 -3,1.9 -3,1.9m3.7,-3.6c0,-0.2 2.5,0.3 2.5,0.1c0.1,-0.5 -2.2,-2.3 -2.2,-2.3c0,0 -0.5,-1 -0.3,-1.1c0.1,-0.2 1.6,0.1 1.7,0c0,-0.3 -1.7,-2.6 -1.7,-3c0,-0.4 0.5,0 0.5,0c0,0 1.3,1.4 2,2.5c0.8,1.2 1.5,2.1 1.2,4c-0.2,2 -4,0.4 -3.7,-0.2m11,-3.6c0,0 -0.5,-1.7 -0.2,-1.9l0.8,-0.4c0,0 -1.3,-0.8 -1.9,-0.8c-0.533,-0.133 -0.8,-0.133 -0.8,0c-0.2,0.3 1,2 1,2l1.1,1.1Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M279.6,231.5c0,0 3.7,1 3.8,0.7c0.2,-0.3 -3,-3.2 -3,-3.2l0,-0.7c0,-0.2 1.3,-0.2 1.7,0.1c0.4,0.3 0,1 0,1.2c0.2,0.2 1.4,2 1.6,1.7c0.2,-0.3 -0.2,-2.5 -0.1,-2.6c0,-0.2 1.4,1.2 1.7,1.5c0.4,0.2 2.5,1.8 2.7,1c0.2,-0.7 0.3,-0.8 0.3,-1.3c-0.1,-0.4 0.6,2.1 -0.3,2.4c-1,0.4 -2.1,-0.3 -2.1,-0.3l-0.9,-0.7l-0.5,-0.5c0,0 0.6,2 0,2.2c-0.6,0.2 -1.5,0.1 -1.5,0.1l-1.5,-0.2l-2,-1.4l0.1,0Zm8.5,-2.5c0,0 4,2.4 4.3,2c0.4,-0.5 -1,-6 -0.8,-6.6c0.2,-0.6 3.2,6.3 1.8,7.2c-1.2,0.7 -1.7,0.2 -1.7,0.2l-2,-1l-1.6,-1.8Zm11,10l0.9,0.4l0.5,0.2l-1.1,0.2l-0.3,-0.8Zm-3.8,-13.1l0.6,0.3l0.5,0.2l-0.5,0.2l-0.3,-0.1l-0.3,-0.6Zm-1.2,-2c0,0 0.4,0.2 1,-0.1c0.6,-0.3 0.5,-0.7 0.5,-0.8l-1.2,-0.4l-0.2,-0.5l-1.2,0l1.1,1.8Zm3.5,11.6l1.6,0.7c0.3,0 0.9,0.4 0.8,0.5c-0.1,0.1 -1,0.2 -1.4,0l-0.6,-0.2l-0.4,-1Zm-6.5,-18.1l1,0c0.2,0.2 -0,1 -0.3,1.3l-0.8,0.4l-1.3,-1.8l1.4,0.1Zm-5.7,-5l1.2,-0.1c0.467,0.067 0.867,0.233 1.2,0.5c0.4,0.2 0.7,2.6 0.5,3c-0.2,0.5 -2.8,-1.5 -2.9,-1.7c0,-0.2 -1.2,-2 -1.2,-2l1.2,0.3Zm-2.5,-1.2c0,0 2,0.2 1.8,-1c-0.087,-0.735 -0.444,-1.412 -1,-1.9l-2.4,1.7l1.6,1.2Zm-5.2,-2.2c-0,0 0.5,0.2 1.1,0c0.6,-0.2 2.1,-2.2 3.2,-2.4c1,-0.267 1.533,-0.267 1.6,0c0.2,0.2 -0,1.4 -0.2,1.7c-0.2,0.3 -3.5,1.7 -3.5,1.7l-1.2,-0.2l-1,-0.3l-0,-0.5Zm-0.6,-3.6c-0.5,-1.2 -1.4,-1.6 -1.7,-1.6c-0.3,0.1 1.1,1.3 1.3,2.8l0.2,2.8l0.7,0l-0,-0.5l0.2,-0.5l-0,-0.4l-0.1,-0.8l-0.2,-0.6l-0.1,-0.5l-0.3,-0.7Zm-4.6,-1.7c-1.223,-1.317 -2.727,-2.342 -4.4,-3c-0.2,0 3.2,2 4,3.4c0.7,1.2 0.7,3 1,3.2c0.3,0.2 0.7,0 0.7,-0.1c0.133,-0.133 0.2,-0.3 0.2,-0.5l-0.2,-0.9l-0.5,-0.8l-0.3,-0.6l-0.5,-0.7Zm-4.4,-1.8c-2.317,-1.693 -5.131,-2.573 -8,-2.5c-2.9,0 -4.3,0.2 -3.9,1.8c0.4,1.467 1.733,2.167 4,2.1c2.4,0 3,-0.2 4.2,0.2c1.333,0.467 2.3,1 2.9,1.6c0.4,0.4 -1,-1.2 -2.1,-2l-2,-1.5c-0,0 -0.2,-0.5 1.4,-0.2c1.6,0.3 3.8,1.2 4.3,2.6c0.6,1.3 0.5,2 0.5,2.4c-0,0.2 0.6,-0.2 0.6,-0.2l0.2,-0.7c-0,0 0.1,-0.5 -0.2,-1c-0.3,-0.7 -0.4,-0.9 -1.1,-1.7l-0.8,-0.9Zm-7.7,22.8c1.2,0 3.8,-2.2 4.2,-5.4c-0.013,-3.464 -0.692,-6.893 -2,-10.1c-0.5,-0.7 0.7,-0.3 1.4,0.3c0.7,0.6 2,5.2 2,8.5c0,3.3 -0.8,4.3 -2.5,6c-1.8,1.6 -3.2,1.5 -3.2,1.5l0.1,-0.8Zm4.1,9.3c0,0 0.6,0.7 1.2,0.5c1.2,-0.5 3.1,-1.4 3.1,-3c0,-1.2 -1.4,-2.2 -1.5,-2.6l0,-0.8l1.3,0.3l0.3,1.8c0,0 0.5,0.5 1,0.3c0.5,-0.2 2,-1.3 1.9,-2.4c-0.1,-1.1 -1.7,-2.3 -1.8,-2.8l0,-1l1.2,0.2l0.4,1.5c0,0 0.3,0.6 1,0.4c0.7,-0.2 2,-1.4 1.7,-2l-1.3,-2.1l0,-0.7l0.5,0.3c0,0 0.4,0.2 1.4,-0.1c1,-0.3 1.8,-1 1.8,-1.6c0,-0.6 -0.7,-1.2 -0.8,-1.6l0,-0.5l0.6,0.1l0.8,1l0.2,1l-0.3,1l-1.1,1.3l-1.2,0.4l-0.3,0l0.7,1.2l-0.2,1.6l-1,1l-1.4,0.7l0,1.5l-0.8,1.6l-1.7,1l-0.5,0l-0.2,1l-1,1.5l-2,1.3l-1.3,0.2l-0.8,-1.1l0.1,-0.4Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M274.7,217.1c0,0 3.1,1 3,-1c0,-1.2 -3,-3.7 -3.2,-4.1c-0.133,-0.6 -0.167,-0.933 -0.1,-1l1.5,1.4c0,0 2,0.5 2.6,-0.7c0.5,-1.1 0,-1.8 0,-1.9l0.4,0l1,0.1l-0.2,1.8l-1,4.4c0,0 0.3,1.7 -1,1.9c-1.4,0 -3,-0.9 -3,-0.9m3,23.6c0,0 0,-0.9 -0.7,-1.5c-0.7,-0.6 -2,-1.2 -2.2,-1.4l2.2,2.8l0.7,0.1Zm4.5,0.1l-2,-2.5c-0.2,-0.7 -1,-2.1 -1.7,-2.2c-0.6,0 0.6,2.4 0.6,2.4l2.5,2.3l0.6,-0Zm4.3,-0l-1.7,-3.3c-0.3,-0.7 -1,-2.7 -1.8,-3.3c-0.8,-0.6 -0,1 -0,1l1,2.6l1.4,2.3l1,0.7l0.1,0Zm3.1,-1.8c-0,0 -0.1,-2.2 -0.4,-3.7c-0.202,-1.036 -0.728,-1.981 -1.5,-2.7l0.1,2.7l1.8,3.7Zm6.5,1.6l-1.5,-3.8l-1.7,-3.3l0.3,2.3l1.4,3.8l1.5,1Zm5.6,-6.8c-0,0 -1,-1 -3.1,-1.9c-1.381,-0.509 -2.83,-0.813 -4.3,-0.9l0.2,0.3l1,0.8l2.2,1.2l3,0.7l1,-0.2Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M278.6,235c0,0 0,2 1,3.1l3.7,3.7c0.4,0.4 0.8,2.7 1.5,4.6l1.1,4c0.3,0.6 0.9,1.5 0.5,1.4c-0.533,-0.067 -0.933,-0.5 -1.2,-1.3c-0.3,-0.7 -0.2,-0.7 -0.1,-1.7c0,-1 -1.5,-5.9 -2.2,-6.4c-0.7,-0.5 -3.9,-3.2 -5.1,-5c-1.2,-1.9 -1,-2.3 -1,-2.3l1.8,-0.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M283.7,247.5c-0.6,-1.467 -0.933,-2.633 -1,-3.5c-0.921,-1.361 -2.113,-2.518 -3.5,-3.4c-0.5,-0.2 -1.5,0.1 -2,-0.2l-2.9,-3.2c0,0 -0.3,0.4 -0.2,0.5c0.1,0.1 2.7,3 3.7,3.8c1,1 1.5,3 2.2,4.6c0.6,1.6 0.4,1.2 0.4,2c0.2,0.8 0.533,1.2 1,1.2c0.667,0 0.833,-0.1 0.5,-0.3c-0.754,-0.806 -1.333,-1.759 -1.7,-2.8c-0.6,-1.4 -1.2,-4 -2,-4.9l-0.3,-0.2l1,-0.1c0.7,0 3.4,2.4 3.6,3.1c0.2,0.7 0,1 1,3.4c1.2,2.4 1.7,3 1.7,3l0.2,0l-1.7,-3Zm-4.1,-16l2.4,1.4l1,0.2c0,0 0.3,3.5 1.7,5.5c1.4,2 2.6,2.7 2.6,2.7c0,0 0,3.8 1,6.4c0.814,1.995 1.156,4.151 1,6.3c-0.2,0.5 -1,-1.5 -1.6,-3.3l-1.5,-5c-0.41,-1.326 -1.091,-2.552 -2,-3.6c-0.7,-0.5 -0.2,-0.4 0.2,0c0.923,1 1.607,2.197 2,3.5c0.6,2 0.9,4 1.2,4c0.4,0 0.6,-0.233 0.6,-0.7l-0.7,-3.3c-0.4,-2 -0.733,-3.233 -1,-3.7c-0.3,-0.6 -0.8,-0.6 -2,-2.8c-0.868,-1.295 -1.542,-2.71 -2,-4.2l0,-1c-0.3,-0.2 -0.4,0 -1.4,-0.5c-1,-0.5 -1.5,-1.9 -1.5,-1.9"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M284.5,230.8c0,0 1.2,1 1.9,1.2c0.6,0.3 1.6,0.3 1.6,0.3c0,0 -0.3,3.4 1,5.5c1.3,2.2 2.7,3.4 2.7,3.4c0,0 0.2,0.8 0.6,5.5l0.6,6.6c0,1.8 0.1,8.4 -0.1,8.2c-1,-0.8 -0.2,-4.3 -0.7,-5.8c-0.5,-1.5 -1.3,-1.7 -2.3,-6c-1,-4 -0.3,-5 -1,-6.6c-0.7,-1.6 -1.6,-1.7 -1.6,-1.7c0,0 1.3,0.2 1.8,1.6c0.5,1.3 0.6,4.8 1,6.5c1,4 2.4,6 2.4,6c0,0 -0.3,-5 -0.7,-7.8c-0.4,-2.8 -0.3,-5.1 -0.9,-6.2c-0.5,-1 -1.6,-2 -2.3,-3.3c-0.7,-1.5 -0.9,-4.3 -1.2,-5c-0.3,-0.7 -0.5,-0.5 -1,-0.7c-1.5,-0.6 -1.8,-1.7 -1.8,-1.7"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M288,229c0,0 1.1,1.2 2.6,2c1.4,0.9 2.2,0.6 2.4,0.8c0.2,0.2 -0.3,3.1 1.2,5.8c1.5,2.8 2,2.8 2.1,3.2l0.5,11c0.2,2.8 0.4,12 -0.7,12c-1.1,0 -0.1,-6.8 -0.7,-8.4l-1,-2.4c-0.5,-1.3 -0.6,-6.2 -1.4,-9.2c-0.7,-2.2 -1.3,-2.6 -1.3,-2.6c0,0 1,0.6 1.6,2.5c0.5,1.8 0.6,8 1.2,8.9c0.733,1.133 1.267,2.133 1.6,3c0.2,1 0,-11.5 -0.4,-12.3c-0.2,-0.8 -2.7,-5.3 -3,-7.8c-0.1,-2.5 -0.2,-2.8 -0.4,-3c-0.2,-0.2 -1,0 -2.2,-1.1c-1.2,-1.1 -2,-2.4 -2,-2.4l-0.1,0Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M293.8,230.4c0,-0.2 0.8,1.4 3,2.3c2.2,0.9 4.5,0.7 4.8,1c1.188,2.531 1.77,5.305 1.7,8.1c0,4.5 -0.8,4.1 -1.5,8c-0.7,3.9 -0.7,11.8 -1.1,13c-0.2,0.5 -0.5,0.7 -0.7,1.5c-0.3,0.7 0.2,2.2 -0.5,2.2c-0.7,0 -0.8,-1.1 -0.8,-1.7c0,-0.6 0.7,-2.8 0.7,-5c0,-2.2 -0.4,-2.4 -0.8,-5c-0.3,-2.5 -0.3,-10.7 -0.6,-11.5c-0.3,-0.8 -1.7,-2.5 -1.7,-2.5c0,0 1.5,1 1.9,2c0.4,1.2 0.4,10.3 0.8,12.1c0.4,1.9 0.3,-0.4 0.4,-1.5c0.2,-1 0.7,-5.5 0.7,-7.9c-0.1,-2.4 -1.1,-7.6 -2,-8.4l1,1.6l0.6,0.5l0.8,0.4l-0.8,-0.2l-0.5,-0.3c0.697,2.06 1.035,4.225 1,6.4c0.1,4 -0.5,13 0.1,13.2c0.7,0 0.5,-5 1.2,-9c0.7,-4 1.6,-4.6 1.3,-8c-0.3,-3.2 -1.2,-6.8 -1.9,-7.3c-0.7,-0.5 -2.6,-0.3 -4.4,-1.4c-1.8,-1.1 -2.8,-2.3 -2.7,-2.6m-28.6,4.6c0,0 0.6,0.3 1.4,0c0.7,-0.4 2.7,-2 2.7,-2.7l0,-1.3c0,0 0,0.3 0.7,0.4c0.5,0 2.2,-1.2 2.3,-2l0,-2.4c-0.3,-0.2 0.4,0.3 0.8,0c0.3,-0.3 1.9,-1.3 1.9,-2.4c0,-1.1 -1,-2 -1,-2l1.3,0c0.5,-0.1 2,-1 2,-2c0,-1 -0.6,-2.4 -1.8,-2.5c0,0 0.9,0.2 1.8,0c0.867,-0.4 1.267,-1.067 1.2,-2c-0.1,-1.4 -1.8,-3 -2.1,-3.2c-0.3,-0.2 1.9,0.6 2.5,-0.3c0.467,-0.933 0.6,-1.6 0.4,-2c-0.1,-0.5 -0.6,-0.7 -0.6,-0.7c0,0 1,0.3 2.3,-0.4c1.3,-0.7 2.4,-1.5 3,-1.5c0.6,0 -1.9,1.4 -2,2.1c0,0.267 0.6,0.833 1.8,1.7l0.2,0.1c0.5,0.3 2.5,0.4 2.6,0.5c0.1,0.1 -1.9,0 -1.7,0.2c1.696,1.249 3.24,2.692 4.6,4.3c1.36,1.608 0.3,0.3 0.7,0.4l1,0.2l-1.2,0l2.6,3.8c0,0 0.4,0.5 0.7,0.6l1,0.2c0,0.2 -1.2,0 -1,0.2l2.6,4.8c0,0 -2.5,-4.3 -5.5,-7.6c-3,-3.4 -3.6,-3.8 -3.8,-3.5c-0.2,0.3 2.2,3.3 3.5,5.3c1.3,2.1 2.4,4.7 2.4,4.7c0,0 -3,-6.2 -7.2,-10c-4.2,-3.9 -4.6,-4.5 -5,-4.3c-0.6,0.1 -1,3 -0.6,3.5c0.3,0.6 3.3,3 6,6c2.6,3 5.9,8.4 5.9,8.4c0,0 -2.4,-3.8 -6.4,-8c-4,-4.2 -5.5,-5.3 -5.8,-5.3c-0.3,0 -0.4,0.8 -0.8,1.5c-0.4,0.7 -1.5,0.5 -1.5,0.8c0,0.3 3.4,3.4 4,3.8c0.6,0.4 1.1,0.2 1.6,0.5l1.1,0.7l-1.2,-0.4c-0.6,-0.2 -0.933,-0.2 -1,0c-0.1,0.3 2.7,3.5 3.2,3.7l1.3,0.4c0.6,0.2 1.5,0.8 1.5,0.8l-1.6,-0.7c-0.667,0 -1,0.067 -1,0.2c0,0.2 2.1,2.9 2,3c0,0 -3.2,-3.8 -5.8,-6.1c-2.7,-2.4 -3.9,-2.9 -4,-2.8c-0.1,0.1 0,0.8 -0.7,1c-0.667,0.2 -1.067,0.4 -1.2,0.6c0,0.2 2.3,2.5 4,4.3l3.2,3.7l-3.6,-3.5c-1.867,-1.733 -2.867,-2.533 -3,-2.4c-0.2,0.1 -0.2,1 0,1.3c0.1,0.2 3.6,4.3 3.5,4.4c-0.1,0.1 -4.1,-4.9 -4.4,-4.9c-0.2,0.133 -0.4,0.467 -0.6,1c-0.3,0.2 -1.4,0.2 -1.4,0.6c0,0.4 5.6,6 5.4,6c0,0 -4.6,-4 -4.8,-3.7c-0.1,0.2 2,4 1.9,4.1c-0.1,0.1 -2.8,-4 -3,-4c-0.2,0 -0.2,0.5 -0.9,1.1c-0.7,0.6 -1.5,0.4 -1.5,0.6c0,0.3 3.8,4.6 3.7,4.7c0,0 -4,-4.1 -4,-3.9c-0.133,0 -0.2,0.2 -0.2,0.6c0.3,1 1.2,2.9 1,3c0,0 -1.2,-2.5 -1.5,-2.4c-0.3,0 -0.3,0.6 -1,1c-0.5,0.3 -1,0.2 -1,0.5c0,0.3 0.7,0.7 1,1.3c0.3,0.6 0.6,2 0.6,2c0,0 -0.4,-1.2 -1,-1.9c-0.533,-0.733 -1,-1.133 -1.4,-1.2c-0.4,0.133 -0.633,0.267 -0.7,0.4l-0.4,-1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M301.6,233.7c0,-0 1.2,-0.1 1.4,-0.4c0.2,-0.3 -0.5,-0 -1.6,-1.3c-1.2,-1.2 -4,-9.7 -7.3,-14c-5.2,-6.9 -10,-10 -10,-10c0,-0 5.7,3.3 10.2,9.9c4.6,6.6 5.7,11.9 7,13.2c1.3,1.4 2.5,1.6 2.4,2c0,0.4 -0.233,0.667 -0.7,0.8l-1.7,0.1l0.2,-0.3l0.1,0Zm-38.4,-1.9l0.2,0.1c0.3,0 1.9,-1.5 1.8,-2c-0.133,0 -0.567,-0.267 -1.3,-0.8c-0.6,-0.6 -0.7,-1.5 -0.7,-1.5c0,0 0.5,1 1,1.3c0.533,0.333 1,0.433 1.4,0.3c0.2,-0.3 2.5,-2 2.4,-2.6c-0.133,0.067 -0.6,-0.1 -1.4,-0.5c-1.2,-0.6 -0.8,-1.6 -0.8,-1.6c0,0 0.4,0.9 1.1,1.2c0.8,0.267 1.333,0.267 1.6,0c0.2,-0.3 1.7,-2.4 1.5,-3c-0.133,0.067 -0.6,-0.067 -1.4,-0.4c-0.7,-0.5 -1.1,-1.7 -1.1,-1.7c0,0 0.5,1 1.4,1.2c0.933,0.067 1.5,-0.267 1.7,-1c0.2,-0.6 0.7,-3 0,-3.6c0,0 -1.2,0.4 -2,0c-0.8,-0.4 -1.1,-1.5 -1.1,-1.5c0,0 0.6,1 1.6,1c0.9,0.2 1.3,-0.3 1.4,-0.7c0.2,-0.3 0.2,-1.7 0,-2.4c-0.2,-0.7 -0.9,-0.7 -1,-1.8c0.067,0.133 -0.433,0.267 -1.5,0.4c-1.6,0.2 -1.8,-1.3 -1.8,-1.3c0,0 1,0.9 1.9,0.8c0.9,-0.1 1.2,-0.8 1.3,-1.4c-0.133,-0.6 -0.4,-1.2 -0.8,-1.8c-0.2,-0.6 -0.3,-1.3 -0.4,-1.2c-0.2,0 -0.4,0.6 -1.6,0.4c-1.2,-0.2 -1.5,-1 -1.5,-1c0,0 0.9,0.6 1.5,0.6c0.733,0 1.133,-0.3 1.2,-0.9c0,-0.4 -0.3,-1.3 -1.8,-2.6l-2.8,-2.2c0,0 2,1.1 3.3,2.2c1.3,1 2,2.1 2,2.1c0,0 1.4,0.5 1.5,0c0.267,-0.4 0.167,-1.067 -0.3,-2c-0.4,-0.7 -1.6,-2 -1.6,-2c0,0 1.2,1 1.8,2.1c0.6,1.1 0.4,1.9 0.4,2.1c0,0.2 2.7,1.3 3.3,1c0.467,-0.467 0.4,-1.133 -0.2,-2l-1,-1.4c0,0 0.7,0.7 1.2,1.5c0.533,0.8 0.733,1.367 0.6,1.7l-0.5,0.7l1.8,1c0.9,0.5 1.9,1 2,0.7c0.2,-0.267 0.267,-0.867 0.2,-1.8c-0.1,-0.8 -0.6,-2.1 -0.6,-2.1c0,0 0.6,1.2 0.7,2.1l0,2c0.3,0.2 1,0.3 1,0.3c0,0 -0.6,0.4 -1.7,0c-1.2,-0.3 -6.2,-2.8 -6.4,-2.6c-0.2,0.3 2.3,1.8 3.5,3c1.2,1 1.7,2.2 1.7,2.2c0,0 -0.9,-0.8 -1.8,-1.3c-0.9,-0.5 -3.5,-1.8 -3.7,-1.6c-0.1,0.2 1,0.4 1.1,0.6c0.1,0.2 -0.8,1 -0.8,1.4c0,0.4 3.8,3 3.7,3.2c-0.2,0.3 -1,1 -1.2,1c-0.2,0 -2,-1.5 -2,-1.3c0,0.3 1,1.2 1,1.4c0,0.2 -0.6,0.6 -0.5,1c0.1,0.4 2.1,2.1 2,2.7c0,0.5 -1,1 -0.8,1.4l1.2,1.6l-1.5,-1.1c-0.3,-0.4 -1,-1.2 -1.1,-1.1l-0.8,2c0,0.4 1,0.9 1.1,1.8c0.1,0.9 -0.1,2 -0.2,2c0,0 -1.3,-1.7 -1.5,-1.7c-0.333,-0.067 -0.6,0.1 -0.8,0.5c-0.2,0.4 -1,1.7 -0.8,2c0,0.1 1.3,0.4 1.3,1.4c0,1 -0.8,1.9 -0.9,1.9l-1.6,-2c-0.2,0 -1.8,1.9 -1.8,2c0,0.3 1,1.1 0.9,1.4c-0.2,0.4 -1,0 -1.5,0.2l-1.3,0.5c-0.2,0 -0.4,-0.5 -0.4,-0.5"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M284,208c0,0 0.1,-0.5 0.4,-0.8c0.2,-0.2 1.2,-1.3 0.8,-1.6c-0.3,-0.2 -1.6,0.2 -2.4,0.2c-0.8,-0.1 -1.3,0 -3.7,-1.9c0,0 -7.4,-5.1 -18.9,-5.8c-3.6,-0.2 -5.2,1 -5.4,1.8c0,0.1 1,-1.5 4.6,-1.5c6.779,0.241 13.387,2.203 19.2,5.7c0.3,0.3 2.3,2.2 4.1,2c1.9,-0.3 2.3,-0.5 2.2,-0.2l-0.7,1.2l-0.2,0.9Zm-20,1.5c-0.579,-0.986 -1.323,-1.866 -2.2,-2.6c-1.988,-1.388 -4.137,-2.529 -6.4,-3.4c-0.2,0 4.8,2.3 6.2,3.7l2.4,2.3Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M264,217.8c0,0 -0.4,-0.5 -1.4,-1.2l-2,-0.9l2.4,0.6c0.6,0.6 1,1.5 1,1.5m-0.7,-4.3c0,0 -0.3,-0.5 -1.7,-1c-1.267,-0.333 -1.833,-0.433 -1.7,-0.3c0.2,0.2 1.3,-0.6 2.3,0c0.58,0.223 1.024,0.704 1.2,1.3l-0.1,0Zm-0.8,-3.6c0,0 -0.3,-0.6 -1.5,-1c-1.333,-0.467 -2.033,-0.667 -2.1,-0.6c-0.1,0.1 1.3,-0.3 2.5,0.2c1.3,0.5 1.1,1.4 1.1,1.4m-1.5,-2.2c0,0 -0.3,-0.5 -2.7,-1l-3.2,-0.6c0.1,0.1 3.3,-0.3 4.2,0c0.9,0.4 1.7,1.6 1.7,1.6m-4.3,-2.5c0,0 -1.4,-0.4 -2.8,-0.5l-3.5,0.1c0,0 4,-0.6 5,-0.4c1,0.4 1.433,0.667 1.3,0.8"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M243.6,254.7c0,-0 0.7,1.3 2,1.3c1.5,0 2.6,2 2.6,2l-1.5,1.6l-3.7,0.2l-1.2,-2l1.8,-3l-0,-0.1Zm-0,-1.2c0.2,-0.3 -1,-2.7 -1.9,-3c-0.8,-0.5 0.3,0.7 0.1,1.2c-0.2,0.533 -0.267,0.933 -0.2,1.2c0.067,0.267 0.7,1 0.3,1.5c-0.4,0.5 1.8,-1 1.8,-1l-0.1,0.1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M243,257.1c0,0 0.7,0.3 1.2,0.2c0.6,-0.333 0.933,-0.567 1,-0.7m-2.9,-0.4c0,0 2.1,-1.5 2,-2.3c-0.267,-0.667 -0.6,-0.9 -1,-0.7l-1.6,1.3l0.6,1.7Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M240.9,257.2c0,0 0.3,1 1,1c0.7,0 1.7,-0.5 1.7,-1c0,-0.3 -0.7,-1 -1.1,-1.3c-0.5,-0.2 -1.5,0.3 -1.5,0.3l-0.1,1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M242.8,255.8c-0.2,0.3 -1.5,1 -1.9,1c-0.4,0 -1.3,-1 -1,-1.2l1.2,-0.3c0.3,-0.2 0.4,-0.7 0.6,-0.7c0.267,0 0.567,0.167 0.9,0.5c0.5,0.5 0.3,0.4 0.2,0.7Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M241.4,256.7c0,0 -2,2.8 -2.9,2.6c-0.9,-0.2 0.4,-3.9 0.4,-3.9l1,0.4c0.667,0.2 1.167,0.533 1.5,1l0,-0.1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M237.8,254.8c0,0 2.6,0.4 2.7,0.8c0.1,0.4 -1.2,1 -2,1c-0.7,0 -0.7,-1.9 -0.7,-1.9l0,0.1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M231.2,258.7c-0,0 0.4,1.3 1.5,1.4c1.1,0.1 2.2,-1.2 2.2,-1.2l-2.7,-1l-1,0.8Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M231.2,258.7l0.3,0.7c0.267,0.4 0.667,0.633 1.2,0.7l0.1,0c1.1,0 2.2,-1.2 2.2,-1.2l-2.8,-1.2l-1,1Zm0,0l1,-0.8l2.7,1l-0.2,0.1c-0.3,0.4 -1.1,1 -1.9,1c-0.6,0 -1,-0.233 -1.2,-0.7l-0.2,-0.4l-0.2,-0.2Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M232,258.4c0,0 0.4,1 2,1c1.4,0 2.6,-1.2 2.6,-1.2l-2.4,-1.9l-2.2,2.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M232,258.4c0,0 0.4,1 2,1c0.985,-0.065 1.911,-0.493 2.6,-1.2l-2.4,-2l-2.3,2.2l0.1,0Zm0,0l2.2,-2l2.4,1.8l-0.1,0c-0.678,0.648 -1.564,1.038 -2.5,1.1c-0.58,0.076 -1.166,-0.107 -1.6,-0.5l-0.4,-0.4Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M232.2,258.6c-0,0 0.6,0.5 1.4,0.6l1.8,-0.2l-1,0.3l-1.2,0l-0.5,-0.2l-0.4,-0.3l-0.1,-0.2Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M234,257.3c0,0 0.6,1.6 2,1.4c1.3,-0.1 1.4,-1 1.4,-1l-1.6,-2.2l-1.8,1.8Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M234,257.3l0.4,0.8c0.333,0.4 0.833,0.633 1.5,0.7l0.2,0c0.667,-0.133 1.067,-0.333 1.2,-0.6l0.2,-0.4l-1.6,-2.4l-2,1.9l0.1,0Zm0,0l2,-1.7l1.4,2.2c0,0.1 -0.1,0.7 -1.3,0.9l-0.2,0c-0.533,-0.067 -1,-0.3 -1.4,-0.7l-0.3,-0.5l0,-0.2l-0.2,0Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M234.1,257.6c0,0 0.9,1 1.6,1c0.733,-0.067 1.133,-0.167 1.2,-0.3l0,0.1l-0.4,0.2l-0.6,0.1l-0.7,0l-0.6,-0.4l-0.5,-0.7Zm-2.6,1.6c0,-0 0.6,0.7 1.2,0.7c0.6,-0 1.5,-0.5 1.5,-0.5l0.1,-0l-0.1,0.1l-0.6,0.4l-0.8,0.2l-0.6,-0.1l-0.4,-0.3l-0.3,-0.3l0,-0.2Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M237.6,254.6c0.6,0 2,1.7 2,2.6c0,0.9 -0.4,2.2 -1,2.1c-0.7,0 -2.2,-1.3 -2.5,-2c-0.467,-0.667 -0.6,-1.133 -0.4,-1.4c0.2,-0.4 2,-1.3 2,-1.3l-0.1,0Zm-6.4,0.2c0,0 -1,-0.8 -1.5,-0.4c-0.5,0.4 -0.3,1.8 0,2c0.3,0.4 1.5,-0.6 1.5,-0.6l0,-1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M231,255.8c0,0 -1.4,0 -1.4,0.7c0,0.7 0.7,1.3 0.8,1.5c0.1,0.2 1.4,-0.6 1.4,-0.6l-0.8,-1.6Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M231.6,256.9c0,0 -1.5,0.4 -1.5,1c0,0.4 0.7,1.3 1.1,1.3c0.4,0 0.8,-0.9 1,-1c0.2,-0.2 -0.6,-1.3 -0.6,-1.3Zm0.7,-4.1c0,0 -0.3,-0.4 -0.9,-0.2c-0.6,0.2 -1.3,0.9 -1.1,1.8c0.133,1.067 0.267,1.6 0.4,1.6l2.1,-0.7l-0.5,-2.5Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M232.4,254.4c0,0 -1.8,0.6 -1.9,1.3c0,0.867 0.333,1.4 1,1.6c0.4,0.1 2,-1.4 2,-1.4l-1.1,-1.5Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M234,257.4c0,0 -1.8,1.2 -2,1.2c-0.3,0 -1,-1 -0.8,-1.6c0.2,-0.6 1.4,-1.1 1.9,-1.3c0.5,-0.2 1,1.7 1,1.7l-0.1,0Zm1.6,-6.6c0,0 -0.6,-0.4 -1.7,-0.4c-1,0.1 -1.9,1.5 -2,2.3c-0.1,0.8 0,2 0.4,2.2c0.4,0.2 2.7,-1.6 2.7,-1.6l0.6,-2.5Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M233.4,256.2c-0.8,0 -1.4,-1.1 -1.3,-1.8c0.1,-0.7 1.6,-1.8 2.4,-1.6c0.8,0 0.6,2 0.6,2c0,0 -1,1.5 -1.7,1.4Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M235.8,256c0,0 -0.4,1 -1.1,1.3c-0.8,0.333 -1.367,0.167 -1.7,-0.5c-0.5,-0.7 0.2,-1 0.5,-1.3c0.4,-0.3 1.4,-0.5 1.4,-0.5l0.9,1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M234.6,253.8c0,0 -0.9,0.6 -0.4,1.4c0.467,0.667 0.967,1.067 1.5,1.2c0.533,0.133 1.033,-0.1 1.5,-0.7c0.7,-0.9 1.2,-0.9 1.1,-1.6c0,-0.733 -0.267,-1.233 -0.8,-1.5c-0.4,-0.2 -1.7,0 -3,1.1l0.1,0.1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M237,250.4c0,0 -0.9,-0.4 -1.6,0c-0.667,0.467 -1.033,1.133 -1.1,2l0.1,1.7c0,0 1,-0.2 1.5,-0.7c0.5,-0.5 0.8,-0.7 0.7,-1c-0.133,0 -0.233,-0.3 -0.3,-0.9c0,-1 0.7,-1.1 0.7,-1.1"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M237,250.4c0,0 -1,-0.2 -1.5,0.1c-0.533,0.333 -0.9,0.833 -1.1,1.5c-0.067,0.667 -0.067,0.933 0,0.8c0.1,-0.2 -0.2,-0.5 0,-1.1c0.267,-0.667 0.667,-1.133 1.2,-1.4l1.4,0.1Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M263,269.6l1.3,-0.6l1.6,-1l0.3,1.8l-1.4,1l-1.2,0l-0.7,-0.5l0.2,-0.7l-0.1,0Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M261.1,269.7l0.9,0l1,-0.1c0.2,0 0.5,1 0.5,1l-0.4,0.5l-1.2,0.7l-1,-0.6l-0.1,-1.4l0.3,-0.1Zm9.7,-0.5l-0.7,-0.9l-1.7,-1.5l0,4l1.8,0l0.8,-1.3l-0.2,-0.3Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M261.1,269.7c0,0 -0.3,-0.4 -1,-0.3c-0.933,0.2 -1.5,0.633 -1.7,1.3c0,0.5 0,2 0.4,2.3c0.4,0.333 1,0.433 1.8,0.3c0.8,-0.3 5,-2.9 5,-2.9l-1,0.3l-1.2,-0.2c0,0 -0.5,0.7 -1.2,0.8c-0.6,0 -0.933,-0.2 -1,-0.6l-0.1,-1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M264,271.1l-1,0.4l-1,0.5l0.3,1.3l1.8,0.4l1.1,-1l0,-1.2l-1.2,-0.4Zm8.3,-0.9l-0.6,-0.6c-0.4,-0.4 -0.7,-0.533 -0.9,-0.4l-1,1.1l-0,0.9l1,0.5l0.7,0.1l1,-0.6l-0.2,-1Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M266.1,269.6l-1.2,0.7l-1,0.8l1,1l0.9,0.2l2,-1.4l-0.2,-1.3l-1.5,0Zm7.6,1.6l-0.4,-0.6c-0.4,-0.267 -0.733,-0.4 -1,-0.4c-0.2,0 -1,1.2 -1,1.2l-0.1,0.3l0.7,0.8l1.3,0.3l0.9,-0.8l-0.4,-0.8Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M270.4,272.6l1,0.2c0,0 -0.1,0.2 0.2,0.4l0.3,0c0,-0.1 0,1 1,1.7c0,0 1.2,0.4 1.7,0c0.6,-0.3 0.5,0.1 0.5,0.1l1.6,-2c0,0 0,-0.4 -0.4,-0.4c0,0 0.3,-1.2 -0.7,-1.5c-1,-0.3 -1.9,0.1 -1.9,0.1c0,0 -0.8,1.5 -1.2,1.3l-0.6,-0.4l-0.6,-0.7l-0.7,-0.2c-0.4,-0.2 -0.7,-0.9 -0.7,-0.9c0,0 -0.6,0 -0.8,-0.3l-0.5,-0.6l-1.5,1c0,0 0,0.5 -0.9,1.1c-0.867,0.6 -1.333,0.833 -1.4,0.7c-0.1,-0.2 -0.2,1.3 -1.2,1c-1,-0.1 -1.6,-1.2 -1.6,-1.2c0,0 -0.7,-0.1 -1.1,0.5c-0.4,0.6 -0.7,0.8 -0.7,1.4c0.067,0.667 0.3,1.233 0.7,1.7c0.3,0.3 1.3,1 2.4,0.4c1.2,-0.6 0.8,-1.5 0.8,-1.5l0.6,-0.4c0.733,-0.667 1.4,-1.133 2,-1.4"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
        stroke-linecap: round;
        stroke-linejoin: round;
      "
    />
    <path
      d="M268.6,264.6l0,2.6c0,-0 0.4,2.3 -0.1,3c-0.5,0.7 -2.3,0.6 -2.6,-0c-0.2,-0.7 -0.1,-2.6 -0.1,-2.6l2.8,-3Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
      "
    />
    <path
      d="M266.6,272.4c0,0 -0.4,0.7 0.8,0.8l0.7,-0.3c0.267,-0.333 0.367,-0.533 0.3,-0.6c-0.1,-0.1 -0.1,0.9 1,1c1.1,0.1 1,-1.1 1,-1.1"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #6b6b6b;
        stroke-width: 0.2px;
        stroke-linecap: round;
        stroke-linejoin: round;
      "
    />
    <path
      d="M257,274.5c0,0 -0.7,-1.1 0,-1.5c0.8,-0.4 1.3,0 1.7,0c0.5,0 0.3,-1.2 0.2,-1.4c-0.067,-0.4 -0.233,-0.733 -0.5,-1c-0.2,0 -2.8,0.2 -2.7,1.9c0.1,1.7 1.3,2 1.3,2m4,4.1c0,0 -0.8,-1.2 -0.4,-1.9c0.4,-0.7 0.8,-0.2 1,-0.3c0.267,0 0.267,-0.433 0,-1.3c-0.4,-1.3 -0.9,-1.1 -1.2,-1.2c-0.3,-0.1 -1.8,1.1 -1.5,2.6c0.4,1.8 2,2.1 2,2.1l0.1,-0Zm14.5,-1.4c-0,-0 2.8,1.2 3,-1.7c0.1,-1.5 -1.3,-2.5 -1.7,-2.5c-0.2,-0 -0.533,0.267 -1,0.8c-0.6,0.6 -0.833,1 -0.7,1.2c0.2,0.3 1,-0.2 1.4,0.7c0.6,1.5 -1,1.5 -1,1.5"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M261,278.6c0,0 -2.2,-0.5 -2.2,-2.6c0,-1.4 1.6,-2 1.6,-2c0,0 -1.4,0.7 -1.5,2c0,2.1 2,2.6 2,2.6l0.1,0Zm-4,-4.1c-0,0 -1.3,-0.3 -1.4,-2.1c-0.2,-1.8 2.8,-1.7 2.8,-1.7c-0,0 -2.8,0 -2.7,1.8c0.2,1.8 1.3,2 1.3,2m18.5,2.7c-0,0 0.6,0.3 1.2,0.2c0.8,0.067 1.367,-0.333 1.7,-1.2c0.3,-1.1 0.1,-1.6 -0.6,-2.5c-0.6,-0.6 -0.933,-0.833 -1,-0.7c-0.1,0.2 0.6,0.1 1,0.7c0.4,0.6 0.9,1.3 0.5,2.5c-0.4,1.2 -1.5,1.2 -2,1.2l-0.8,-0.2Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M242.1,217.9l-0.5,-0.1l0.4,-0.9l1.4,-0.5l1.5,-0.1l1.5,0l0.7,0.4l0.8,1.9l-2.9,1.7l-0.5,0.2l-0.1,-0.8l-0.5,-1.1l-1.8,-0.7Z"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M269.5,260.4l-0.1,-4.4l-12,3.6l4.8,4.4l7.3,-3.6Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M247.6,252.7l-1,-0.8l-1.1,-0.6l-1,-0l-0.1,0.2l0.1,0.4l1.1,1.3l1.8,1l0.7,0.5l0.4,0.2l-0.9,-2.2Zm-0.6,1.9l1,-0l0.6,0.9l0.5,0.8l0.5,1l0.2,0.7l-1.3,-0.3l-3.9,-1.2l0.4,-0.9l0.6,-0.6l0.6,-0.2l0.8,-0.2Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M249.8,257.8l0.6,-0.1l0.4,-0.4l-0.2,-1.4l0.3,-4.6l-3.1,-3.7l-0.7,2.1l1,3.8l0.6,2.2l1.1,2.1Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M247.5,249.3c0,0 -0.2,0.4 0.1,1.6c0.3,1.2 0.7,4 1.8,5.8c1,1.8 -1,-1.5 -1,-1.5c0,0 -1.7,-3.7 -1.5,-6.5c0.3,-2.9 0.6,0.6 0.6,0.6"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M249.8,251.7c0,-0 -0.7,0.8 -0.8,1.5l0,1.7c0,-0 0,-0.8 0.7,-1c0.7,-0.2 0.6,1.9 0.6,2.1l0.4,-3.8l-0.9,-0.5Zm0.4,7.7l-3.5,-0.8c-1.867,-0.8 -2.8,-1.467 -2.8,-2c0,-0.4 3.2,0.2 3.7,0.3c0.5,0.1 1.9,0.8 1.9,0.8l0.8,0l1.5,-0.6l0.2,1.6l-1.8,0.7Zm-6,-0.7c0,0 1,0.6 0.5,0.9c-0.5,0.3 -1.5,0.3 -1.8,0.2l3.4,0.8l0.6,-0.6l-2.6,-1.3l-0.1,0Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M243.4,257.8c0,-0.2 0.2,0.5 1.4,0.6c1.2,0.2 1.8,-0.2 1.8,-0.2l0.5,0.4l0.6,0.1l-0.5,0.9l-2.3,-0.7l-1.2,-0.6l-0.3,-0.5Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M251.3,256.2l0.6,0.9l0.4,-2l0,-2l-1.3,-0.8l0.3,3.9Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M247.8,253l-1,-1.8l-1.4,-2.5l0.8,-1.4l1,1.4c0,0 -0.3,1 0,2c0,1 0.6,2.2 0.6,2.2l0,0.1Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M240.6,259.2c0,0 0.5,-0.7 1.5,-0.8l2,0.1l2,1.2l0.5,0.7l-4,-0.6l-2,-0.6Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M251.2,252l0.1,3.3c0.1,0.7 0.6,1.5 0.5,1.8c-0,0.267 -0.267,0.467 -0.8,0.6c-0.5,0.2 -1.5,0 -1.5,0c-0,0 1,-0.1 1,-0.3l-0.3,-2c-0,-0.8 -0,-1.7 -0.2,-1.7c-0.333,0.067 -0.567,0.2 -0.7,0.4c-0,0.1 0.3,-3 0.6,-3.3c0.4,-0.4 1.3,1.3 1.3,1.3l-0,-0.1Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M243.8,258.4c0,0 -0.4,-0.3 -0.4,-0.6c0,-0.3 0.4,1.3 2.7,1.2c2.2,-0.1 2,-0.2 2,-0.2l1.1,0c0,0 -0.2,1 -0.4,1.1c-0.2,0 -1.7,1.1 -1.8,1.2l-0.5,0.3l0,-0.2l-0.3,-1.7l-1.9,-0.7l-0.5,-0.4Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M247.8,253c0,0 -2.6,-2.8 -3.5,-4.5c-0.9,-1.7 -0.3,-4.2 -0.3,-4.2l2.4,3.2c0,0 -0.3,0.6 -0.2,1.6c0.1,1 1.6,3.8 1.6,3.8l0,0.1Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M246.1,262.6c0,-0.2 -0.2,-0.8 0.3,-1.4c1.545,-1.471 3.386,-2.597 5.4,-3.3l0,2.4l-5,2.4l-0.7,-0.1Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M246.4,260.8l1.1,-1c0,-0.267 -0.567,-0.467 -1.7,-0.6l-2,-0.8c0,0 1.3,1.1 1.9,1.3c0.4,0.2 0.533,0.4 0.4,0.6l0.3,0.5Zm6.6,0.6l-1,-1.7l-0.2,-1.8l-0.8,0.6l-1.5,0.5c-0,0 1.6,0 1.6,0.5c-0,0.5 -2.4,0.8 -2.4,0.9c-0,0.1 1.9,-0.4 1.8,0c-0.2,0.5 -1,0.5 -2,1l-2.4,1.2c-0,0 0.4,0.3 1.2,0.2l2.3,-0.4l3,-1.2l0.4,0.2Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M253,261.4c0,0 -0.8,-0.3 -1.4,-3.9c-0.6,-3.6 -0.5,-4.5 -0.5,-4.5l1.5,1l1.3,2.3l-0.9,5.1Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M253.5,255.4c0,0 -0.7,2 -0.7,3.2c0,1.133 0.067,2.067 0.2,2.8l1.5,1.8l0.5,-0.5l0.3,-1.6l0,-2.7l-1.8,-3Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M255.5,258.2c0,0 0.4,5 -1,5.1c-0.5,0.1 -1.4,-1.9 -1.5,-2c0,0 1.1,2 1.6,1.7c0.8,-0.3 0.5,-5.2 0.5,-5.2l0.4,0.4Zm-2.5,3.2l-0.5,-0.7c-0.4,-0.6 0,0.5 -2.8,1.5c-2.8,1 -3.6,0.4 -3.6,0.4c0,0 0.9,0.7 3.6,-0.1c2.7,-0.8 2.5,-1 2.8,-1l0.5,-0.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M248,255c0,0 0.5,0.3 1,1.3l0.8,1.7l0.1,-0.1l-0.8,-1.7l-1.7,-2.6l0.6,1.4Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M246.4,261.2c0,0 0.3,-1 0,-1.1l-2.4,-0.2l-3.4,-0.7c0,0 1.3,0.8 2.5,1.1l2.7,0.7l0.5,0l0.1,0.2Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M246.4,261.2l-0.2,-0.4c-0.2,-0.2 -0.5,0 -2.8,-0.5l-2.8,-1c0,0 0.8,0.6 2.8,1.1l3,0.8Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M247.4,254.6c0,0 -1.7,0 -2.2,0.5l-1.3,1.6l1.1,0.1c0,0 -0.1,-1 0.4,-1.5c0.5,-0.5 1.3,-0.6 2,-0.7"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M244.2,251.4c-0,0 0.7,0.9 1.4,1.2c0.8,0.267 1.367,0.6 1.7,1c0.4,0.3 0.7,1.4 0.7,1.4c-0,0 -2.4,-1.1 -2.8,-1.6c-0.5,-0.6 -1,-2 -1,-2"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M246.6,252c0,0 -0.3,-0.4 -1,-0.7c-0.6,-0.267 -1.033,-0.3 -1.3,-0.1l0,0.2l0.8,1.3l0.5,-0.1c0,0 -1.3,-0.8 -1,-1c0.6,-0.6 2,0.3 2,0.3l0,0.1Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M253,248.9l13.6,-7l6.4,9l-11.7,3l-6.2,0.6l-3,-2.2l0.9,-3.4Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M271.2,252.7l16.8,14.6l-1.8,1.3l-4,-1.1l-8.2,-8.1l-3,-3.1l0.2,-3.6Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M292.8,264.4l-9.7,-7.3l-12.1,-9.1l0.3,4.3l13.9,12.8l4.6,2.2l2.3,-0.7l1.2,-1.2l-0.5,-1Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M271.1,254.1c0,0 4.9,5.5 8.6,8.3c3.7,2.8 7.2,5.8 8,5.4c0.8,-0.4 0.4,-0.9 0.4,-0.9l-17,-13.9l0,1.1Z"
      style="fill: #494949; fill-rule: nonzero"
    />
    <path
      d="M283,268.1l-1.6,1.3l-2,-0.8l-10.4,-10.6l0.5,-2l1.5,0.3l12,11.8Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M292.8,264.4c0,0 -1.3,3 -4,2.3c-2.7,-0.7 -17.6,-14.8 -17.6,-14.8l0,1.5c0,0 15,13.8 18,14.3c2.9,0.6 5.3,-2 5,-2.2l-1.4,-1l0,-0.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M269.5,256.3c0,0 4.8,6.2 7.3,8.4c2.6,2.3 4.8,4.1 5.8,3.9c1,-0.2 -0.6,-1.4 -0.6,-1.4l-7.3,-7.1l-3.7,-3.8c0,0 -1.5,-0.6 -1.5,0"
      style="fill: #494949; fill-rule: nonzero"
    />
    <path
      d="M270.7,256.3c0,0 12.2,12.4 13.1,12.7c2,0.6 5,-1.5 5,-1.5l-1,-0.6l-0.2,0.4c0,0 -0.5,1.2 -3.2,0.7c-4.863,-3.534 -9.324,-7.591 -13.3,-12.1l-0.4,0.4Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M275.3,268.2l-4.5,-5.1l-1,-1.7l-0.2,-2.2l8.8,9l-1.2,0.8l-1.1,-0.4l-0.8,-0.4Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M283.3,268.4c0,0 -1,1.6 -2.5,1.3c-0.905,-0.187 -1.718,-0.682 -2.3,-1.4l-8.5,-8.3l-0.2,-1.3c0,0 9.3,9.9 11,10.3c1.2,0.3 2,-1.2 2,-1.2l0.5,0.6Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M278.6,268.1c0,0 -0.4,1.2 -1.7,1c-1.3,-0.2 -1.6,-0.6 -1.6,-0.6l-5.2,-6.2l-0.1,-1.6c0,0 5.4,7.4 6.6,7.9c1.3,0.4 1.6,-0.9 1.6,-0.9l0.4,0.4Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M273,251.9c0,0 5,4.3 5.5,4.5c0.5,0.2 2.2,0.3 2.3,0.6c0.1,0.3 -1.2,0 -1.3,0.2c0,0.3 2.6,2.4 3,2.5c0.4,0 2.5,0 2.5,0.3c0,0.3 -1.5,0 -1.5,0.3c0,0.3 2.2,2.2 2.7,2.2c0.4,0.1 3,0.1 3,0.4c0,0.3 -2.1,0 -2,0.4c0,0.4 3.6,2.7 3.5,3c-0.1,0.3 -4.4,-2.8 -4.5,-2.7l-0.5,1.4c-0.3,0.1 0,-1.4 -0.2,-2c-0.2,-0.6 -2.7,-2.5 -3,-2.3c-0.3,0.2 0,1.4 -0.2,1.4c-0.2,0 0,-1.4 -0.2,-1.9c-0.2,-0.5 -2.6,-2.4 -2.9,-2.4c-0.3,0 -0.1,1 -0.3,1.2c-0.2,0.2 -0.2,-1.2 -0.5,-1.6c-0.3,-0.4 -5.6,-5.2 -5.4,-5.5"
      style="fill: #6e6e6e; fill-rule: nonzero"
    />
    <path
      d="M264.4,265.9c0,0 0,1.9 -0.8,2.2c-0.8,0.3 -2.5,-3.5 -2.5,-3.5l-0.4,-3.6l2.5,2.4l1.2,2.5Zm6.7,-1l0,-1l-0.2,-1.2l-0.2,-2l-0.4,-1.2l-0.4,-0.9l-0.6,0l-1.3,1l-0.4,1.3l0.7,2.4l0.6,2.1l1,0.4l1.2,-0.9Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M269.4,268.3c0.3,-0.2 -0.3,-2.8 -0.3,-2.8l-1.5,-3.8l-0.5,-1.4l-1.2,-0.5l-0.8,1l0.1,1.5l1.9,3.5c0.5,0.8 1.8,2.6 2.3,2.4l0,0.1Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M268,260c0.5,0.4 1,1.4 1.1,2.1c0,0 1,2.9 0.9,3.1c-0.1,0.2 -0.8,0.3 -0.8,0.3c0,0 1.4,1.5 1.8,1.3c0.4,-0.2 0.3,-1.6 0.1,-1.9c-0.2,-0.3 -0.5,0 -0.7,-0.4c-0.2,-0.3 -0.7,-2.2 -0.7,-3.3l0,-2.2c0.2,-0.3 1.2,2.3 1.2,3.7l0.5,0.6l-0.5,-2.6l-0.5,-1.8l0.2,-1.2l0,-0.8l0.7,0.4c0.267,0.067 0.467,-0.467 0.6,-1.6c0.2,-1.7 -0.1,-4.8 -0.1,-4.8l-5.4,7.1l1.6,2Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M268,259.4c0,0 -0.2,2 0.5,4c0.7,1.9 0.9,2 1,2.2c0.2,0.3 0.2,2.4 0,2.6c0,0 -1.5,-3.5 -2,-5.2c-0.5,-1.7 -0.5,-2.4 -0.8,-2.6l-0.6,-0.1l1.9,-0.9Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M267.5,269.6c0.1,0 0,-0.8 0,-0.8l-0.2,-1.8l-1.9,-4l-2,-1.8l-1.1,-1.7l-0.2,3.2c0,0 1.5,3.2 2.5,4.2c1,1 2.6,2.8 2.9,2.7"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M259.7,260.9c0,0 0.4,0.8 0.4,1.4l0,1l1.4,2.8c0.7,1.3 1.4,2.5 2,2.3c0.5,-0.3 0.7,-1.2 0.8,-1.3c0,-0.1 -0.7,1 -1,0.8c-0.3,-0.2 -2,-5.2 -1.9,-5.3l-0.8,-0.6l-0.9,-1.1Zm5.7,4.3l-1.4,-2.5c-0.533,-0.867 -0.9,-1.333 -1.1,-1.4c-0.2,0 -0.4,-1.5 -0.4,-1.5c0,0 0.5,1 1.3,1.4c0.667,0.4 1.167,0.567 1.5,0.5l0.2,1.6l-0.1,2l0,-0.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M262,262.6c0,0 0.3,1.1 1,2.2l1.9,2.3c0,0 -1.3,-1.2 -2,-2.2c-0.7,-1 -1.1,-2.3 -1.1,-2.3l0.2,0Z"
      style="fill: #3b3b3b; fill-rule: nonzero"
    />
    <path
      d="M265.6,261.3c0,0 0.4,-1 0.7,-1l0.9,-0.2c0,0 -0.5,-0.1 -1,-0.6l-1,-1l0.3,1.5l0.1,1.3Zm-0.3,0.3l2,4.4c0.3,1.2 0.3,2.8 0.3,2.8l-0.6,-2.1c-0.3,-1 -1.7,-3.7 -1.8,-4c-0.1,-0.3 0,-1 0,-1l0.1,-0.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M267.4,259.5l0.4,-4.8l-0.4,-1.8l-2.2,-4.8c0,0 -0.1,0.7 -0.7,0.7c-0.928,-0.258 -1.761,-0.779 -2.4,-1.5c-0.435,1.255 -0.505,2.607 -0.2,3.9l4.3,7.9l1.2,0.4Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M259,262.7c0,0 0.7,0.8 1,0.7c0.3,-0.1 0.3,-1.6 -0.2,-2.5c-0.5,-0.9 -5.6,-7.7 -6.4,-8.1c-0.7,-0.4 5.6,9.9 5.6,9.9"
      style="fill: #4f4f4f; fill-rule: nonzero"
    />
    <path
      d="M262.5,259.9c0.1,0.3 0.5,2.5 -0.4,2.7c-1.2,0.2 -6.9,-7.5 -7.7,-8.6c0,0 -3.6,-2.2 -3.6,-2.8c0,-0.6 3.8,0.8 3.8,0.8l7.5,7.2l0.4,0.7Z"
      style="fill: #4f4f4f; fill-rule: nonzero"
    />
    <path
      d="M259,262.7c0,0 -0.6,-1.1 -0.7,-2c-0.067,-0.667 -0.167,-1.133 -0.3,-1.4l-4.6,-6.6l-1.8,-1.1l0.2,1.9c0,0 1.3,2.4 3.2,4.6l4,4.6Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M265.3,261.6c0.5,-0.3 0.3,-2.2 0,-2.8c-0.1,-0.6 -3.5,-7.6 -3.5,-7.6l-1,0.4l-1.9,-1.5l-1,-1.1l0.3,2.5l0,1.3l2.6,4.6l4.5,4.2Zm3.8,-4.2l0.8,-1l-0.5,-3.5l-2.2,-7.6c-0,0 -0.5,0.2 -1,-0.2l-1.2,-1l0.5,4.5l2.3,6.4l0.2,1.9l1.1,0.5Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M262.1,259.2c0,0 -2.2,-2.4 -3,-3.6l-1.3,-2.4c0,0 -0.6,0.3 -1.4,0c-0.7,-0.4 -1.8,-1.5 -1.8,-1.5c0,0 -0.6,1.2 2.6,4.5c3.7,3.7 5,3 5,3l-0.1,0Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M267.5,260c1,-0.4 1,-4.3 0,-7c-0.9,-2.6 -2.3,-5 -2.3,-5c0,0 1.8,4.4 2.2,6c0.4,1.8 0,3 -0.3,3c-0.3,-0.1 -0.3,-1 -1,-2.7c-0.8,-1.7 -1.3,-2.1 -1.3,-2.1c0,0 2.6,7 1.9,6.9c-0.7,-0.2 -4.3,-8 -4.5,-8.2c-0.1,-0.2 -0.2,0.3 -0.2,0.3c0,0 3.2,9.8 5.5,8.8"
      style="fill: #4f4f4f; fill-rule: nonzero"
    />
    <path
      d="M269.6,241l1.6,3.4l0.5,3.5l0.1,3c0,0 0.1,6 -0.6,6c-0.7,0.2 -1.1,-0.5 -1.1,-0.7l-1.4,-6.6l-1.4,-6.8l0.5,-0.4l0.2,-1l1,-0.1l0.6,-0.3Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M265.3,261.6c0.6,0 0,-1.6 0,-1.6c0,0 -0.5,0.7 -1,0.2c-0.5,-0.5 -1,-2.5 -1,-2.5l-0.4,-1.2c0,0 -0.5,1.3 -1,1.3c-0.7,0 -3.7,-5.1 -3.7,-5.1l-0.4,0.5c0,0 4.3,8.9 7.5,8.4"
      style="fill: #4f4f4f; fill-rule: nonzero"
    />
    <path
      d="M263.3,257.7c0,0 0.5,-1.2 0.3,-2.4c-0.471,-1.388 -1.074,-2.727 -1.8,-4l-1,-0.1l-1.9,-1c1.095,2.7 2.577,5.227 4.4,7.5m2.5,-1.8c0,0 -0.4,-2.7 -1.7,-5.2c-0.49,-1.228 -1.164,-2.375 -2,-3.4l0,2.8c0,0 1.2,0.5 2,2l1.7,3.8Zm3.4,-4.6c0,-0 -0.2,-3 -0.7,-4.7l-1,-4l0.3,-0.2l0.5,-0c0.7,0.1 1,1.7 1,1.7l-0.2,-2.5l-0.2,-0.4l-1.1,-0c0,-0 0.2,0.7 -0.1,1c-0.3,0.3 -0.5,-0.1 -0.6,-0.2l-0.1,0.3l0.2,1.6l0,1.4c0,-0 0.4,1.7 1,2.8l1,3.2Zm2.6,-0.4c0,-0 0.5,-4.2 -0.4,-7c-0.348,-1.25 -0.962,-2.41 -1.8,-3.4l-0.5,0.6c0,-0 1.5,2.3 2,4.4c0.4,2.3 0.7,5.4 0.7,5.4m-4.3,2.2c0,-0 -0.4,-3.4 -1,-5.5l-0.8,-3l-0.9,-0.7c0,-0 0.5,2.2 0.5,2.9l-0.1,1c0,-0 0.4,1.2 1,2.2c0.6,1 1.3,3 1.3,3l0,0.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M269.8,258.3c0.8,0 0,-4.8 -0.3,-6l-2.3,-7c0,0 2.4,8.2 2.2,8.6c-0.3,0.6 -1.2,-2.5 -1.4,-2.4c-0.2,0 1.8,5.5 1,5.6c-0.6,0 -1,-1.2 -1,-1.2l0,1.2c0,0 0.5,1.2 1.8,1.2"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M270.8,255.9c0.6,0 -0.2,-4.5 -0.6,-6.6l-1.5,-6c0,0 1.1,2.8 1.8,6c0.7,3.2 1,7.3 0.5,7.4c-0.7,0 -1,-0.6 -1,-0.6l0,-0.7c0,0 0.2,0.5 0.8,0.5"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M263,261.2c0,0.3 0,1.9 -0.8,1.8c-0.8,-0.1 -2.3,-1.5 -2.6,-2.5c0,0 1.8,2 2.4,2c0.6,0 0.6,-2 0.5,-2.6c0,-0.5 0.5,1.3 0.5,1.3"
      style="fill: #232323; fill-rule: nonzero"
    />
    <path
      d="M267.3,239.6c0,0 1,0.7 2,0.2c0.793,-0.545 1.277,-1.439 1.3,-2.4c0.067,-0.6 -0.1,-1.233 -0.5,-1.9c-0.6,-0.7 0.8,0.6 0.8,1.9c0,1.3 0,3.4 -2,3.9c-2,0.5 -1.1,-0.1 -1.1,-0.1l-0.5,-1.6Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M265.7,235.8c0,0 1.3,2 1.8,4c0.467,1.733 0.467,2.6 0,2.6c-0.267,0 -0.4,-0.233 -0.4,-0.7l-1.4,-5.9Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M243.3,238.3l8.4,12.3l10.7,-12l-6.7,-6.8l-12.4,6.5Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M254,230.8l-0.5,2l1,3.2l1.8,1.8l2,1.4l0.5,-1.5l0.5,-1.8l0.5,-0.2l1.3,0.5l0.9,-1.3l1.4,-2.4l-0.3,-1l-0.4,-0.7l-2.1,-3.7l-0.7,1.4l-0.7,0.4l-1.2,-0.7l-1.5,2l-1.9,-0.9l-0.6,1.5Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M258.4,239.2c0,-0 0.3,-0.3 0.5,-1.2c0.1,-1 0.2,-4 -0.1,-5.2c-0.3,-1.2 -1,-3.5 -1.2,-3.3c-0.2,0.1 1.2,2.5 1,5.5c-0.2,2.9 0,3.7 -0.7,4c-0.7,0.3 0.5,0.2 0.5,0.2"
      style="fill: #393939; fill-rule: nonzero"
    />
    <path
      d="M258.8,234.3c0,0 1.4,2 2.1,1.2c0.7,-0.7 0.3,-3.2 0,-4.2l-1,-2.5l0.4,-0.4l0.7,2.7c0.3,1.1 1,4.2 0.1,4.8c-0.9,0.6 -2.2,-1.2 -2.2,-1.2l0,-0.4l-0.1,0Z"
      style="fill: #393939; fill-rule: nonzero"
    />
    <path
      d="M254.3,235.6c0,0 0.5,-0.7 1.1,-0.7c0.667,0.067 0.933,0.133 0.8,0.2l0.6,1.6l0.9,1.7l0.8,0.9l-0.4,0.5l-0.7,0l-2,-1l-0.6,-0.8l-0.5,-2.4Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M257.6,253c-0.6,0.4 -2.1,-0.3 -3,-1.1l-5.4,-5.4l-0.6,-2.5l1.8,0.4l3,-1.3l0.6,-1l3.7,-2l2,-1l4.5,-0.2l1,-2.1c0,0 1.6,2.6 1.8,3.6c0.2,1 0.2,4.3 -0.2,4.5c-0.4,0.2 -1.8,-1 -2,-1c-0.3,0 1,4.6 0,4.8c-1.1,0.1 -3,-1.8 -3,-1.8c0,0 0.8,4.2 0,4.2c-1,0 -3.2,-1 -4.1,-2c0,0 1,3.4 0,4l-0.1,-0.1Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M256.8,247.7l0.9,1.4c0.2,0.3 0,2.3 -0.2,2.6c-0.3,0.8 -1.3,-0.9 -1.8,-2.3l-1.8,-3c0,-0.4 2.9,1.3 2.9,1.3m8.7,-10.3c0,-0 1.5,6.5 0.8,6.7c-0.8,0.2 -3,-2 -3.2,-2.4l-3.3,-5.1l-0.6,-0.7l0.2,-0.3l1.3,0.5l4.8,1.3Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M254.3,249.8c-0.3,0.3 -1,-0.8 -1.3,-1l-2.4,-2.7c-1.133,-1.067 -1.733,-1.733 -1.8,-2c0,-0.3 -0.7,-1 -0.7,-1l0.6,-0.6l0.7,-0.1c0,0 4.3,3.4 4.6,4c0.3,0.5 0.5,3.3 0.3,3.5l0,-0.1Zm6.5,0.1c-0.2,0.2 -3,-1.9 -4.3,-3.6c-1.3,-1.7 -2.4,-3.2 -2.7,-4l-0.5,-1.5l0.8,0.2c0,-0 7,8.6 6.7,8.9m1,-3c-0.2,0.2 -1.4,-0.7 -2.2,-1.7c-0.7,-1 -0.3,-2.3 -0.3,-2.3c0,-0 2.6,3.8 2.5,4m1.6,-0.4c-0.4,0.2 -2,-1.8 -3.4,-4c-1,-1.6 -1.3,-1.9 -1.5,-2l-1,-0.3l-0.2,-0.2l0.7,-0.2l0.6,-0.7l0.8,-1l3.4,6.8c0,-0 0.8,1.5 0.6,1.6"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M254.6,251.9c0,0.3 0,0.5 -1,0.4c-0.8,0 -5.7,-2.7 -7.8,-6.2l-2.5,-4l1,-1.1l7.6,8.7l2.7,2.2Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M254.6,251.9c0,0.4 -0.267,0.533 -0.8,0.4c-0.6,-0.1 -2.5,-0.8 -5.5,-4.2c-3,-3.4 -4.3,-5.9 -4.3,-6l-0.1,-1.4l0.9,-0.4l5.2,8l4.6,3.6Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M259.7,248.5c0,0 -1.6,-1.2 -2.6,-2.4c-1,-1.2 -3,-4 -3,-4.6c0,-0.6 1,-0.5 1,-0.5l-0.1,-1.5l0.2,-0.4l1.5,0.6l1.9,2.3l0.7,1c0,0 1.2,2.8 1,3c-0.3,0.4 -2,-1.5 -2.2,-1.3c-0.2,0.2 2,3.5 1.6,3.8m-3,-0.8c0,0 0.6,0.8 0.3,1.3c-0.3,0.5 -0.4,0.9 -1.2,-0.3c-0.8,-1.2 -1.7,-2.5 -1.8,-2.4c0,0.1 0.1,1.8 -0.3,1.8c-0.4,0 -1.6,-1.4 -2.4,-2.6l-2,-3c0,0 0.2,-0.5 0.1,-1.8l-0.1,-2c0,0 0,0.4 0.2,0.7l0.4,0.6l2.8,3.3l0.8,-0.5l1.7,3.3l1.5,1.6Zm-10.8,-5c0,0 2.2,4 4.3,6.1c1.252,1.308 2.747,2.361 4.4,3.1l-6.6,-7.9l-2,-1.2l-0.1,-0.1Zm17,2.4c-0.1,0 -1.5,-1.4 -2.4,-2.7c-0.778,-1.203 -1.258,-2.574 -1.4,-4l0.2,-2.8c-0,0 2.3,2.4 2.8,3.5c0.4,1 1.3,2.6 1.1,2.8c-0.2,0.2 -1.7,-1 -1.9,-0.8c-0.2,0.3 1.8,3.8 1.6,4m2.6,-2.5c-0.3,0.1 -1.5,-1.2 -1.8,-2c-0.3,-1 -0.4,-2.6 -0.4,-2.6l-1,-2.4l0.1,-2.6l1,-0.2l1.5,2.1c-0,0 0.6,1.3 0.6,3c-0,1.9 0.3,4.5 -0,4.7m-18,6.5c-2,-2.5 -3.3,-5 -3.3,-5l-0.7,-2.2l0.4,0.3c-0,0 0.6,2.6 3.7,5.7c3.2,3.1 3.9,3.4 3.9,3.4c-0,0 0.6,1.7 0.3,2.3c-0,0 -2.3,-2 -4.3,-4.5"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M250.9,252.7c0,-0 -2.7,-2.4 -4.9,-5c-2.1,-2.8 -3.5,-5.4 -3.5,-5.4l1,-0.9c0,-0 1.8,4.2 3,5.9l4.4,5.4Zm3.7,-0.8l-4.6,-4.9c-0.97,-1.063 -1.81,-2.238 -2.5,-3.5l1.3,0.5c0,0 0.5,1.4 1.7,2.8l4.1,5.1Zm-0.6,-5.6c0,-0 -1.7,-2 -2.5,-3.4l-1.7,-3c0,-0 2.3,2.7 3,2.8l0.7,-0c-0.2,-0.1 -0.3,1 0,1.8c0.1,0.8 0.5,1.8 0.5,1.8m0.7,-8.4c0,-0 0.3,1.4 0.1,2.3c-0.2,0.9 -0.7,0.8 -0.7,0.8l1.5,1.8c0.5,0.6 1.8,1.5 1.8,1.5l-1.5,-2.2c-0.4,-0.7 -1,-1.6 -0.7,-2.3c0.2,-0.7 1.6,0.5 2,0.8l2,2.3c0,-0 -0.5,-2 -1.4,-2.7l-3,-2.3l-0.1,-0Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M261.6,242.3l-1.4,-3.5l-1.3,-4l0,2.2c0,1 -0.4,2.4 -0.8,2.6c-0.4,0.2 -0.5,0.2 -1.3,0c-0.7,-0.2 0.6,0.4 0.6,0.4c0,0 0.8,0 1,-0.4c0.4,-0.4 0.5,-1.2 0.9,-1.1c0.3,0.1 0.7,1.3 1,1.9l1.3,1.9Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M259,234.7c0,-0 1.6,1.9 2.3,1c0.7,-0.9 0.3,-3.1 0.3,-3.1c0,-0 1,0.3 1.3,-0c0.3,-0.3 0.2,-1 0.2,-1c0,-0 1.8,2.5 2.6,4.2c0.9,1.6 1.3,4.6 1.3,4.6c0,-0 -1.5,-2.4 -2.2,-4.6c-0.7,-2.2 -1.7,-3 -1.9,-2.8c-0.2,0.2 -0.4,1.6 -0.2,2.4l1.2,2.7c0.5,1.1 1,2.8 1,2.8l-1.4,-2c-0.533,-0.667 -1,-1.1 -1.4,-1.3c-0.3,-0.3 -0.8,-1 -1.3,-1.1c-0.5,-0.1 -1.5,-0.7 -1.5,-0.3l-0.2,-0.8l-0.1,-0.7Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M253.4,242.6l1.6,2.8l1.8,2.3c0,0 -1.6,-1.4 -2.2,-2.3c-0.6,-1 -1.2,-2.8 -1.2,-2.8"
      style="fill: #171717; fill-rule: nonzero"
    />
    <path
      d="M264.1,243c-0.2,0.2 -1,-0.1 -1,0.2c-0.1,0.3 0.4,1.3 1,1.9c0.467,0.533 0.767,0.7 0.9,0.5l-0.2,-1.1l0,-1.5c-0.1,-0.2 -0.7,0 -0.7,0"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M244.7,231.5l-1,0.6l-1,2.3l0.3,4.3l1.7,2.4c0.6,1 2.8,3.4 3.3,3.2c0.5,-0.2 1.2,-1.8 1.2,-2.7l0.2,-2.6c-0,0 0.5,1 1.4,1.9c0.9,1 1.7,1.9 2,1.8c0.5,0 1.7,-2.5 1.8,-2.9c-0,-0.3 -3.2,-8 -3.2,-8l-1.4,-0.7l-5.3,0.4Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M251.8,238l0.9,2.9c0.3,1 0,1.8 0.2,1.8c0.1,0 1.8,-2.2 1.8,-3.2c0,-1 0,-2 -0.4,-5c-0.5,-3.1 0.1,-4 0.1,-4l-1,-0.8l-1.5,3.3l-0.1,5Zm-5.5,-1.8l0.5,4c0.2,1 0.8,2.6 1.1,2.5c0.3,-0 1.3,-2.6 1.4,-3.5c0,-0 -0.7,-1.3 -0.7,-4.4c0,-3.1 -0.3,-3.5 -0.3,-3.5l-2,4.9Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M242,230c0,0 -2.5,3.6 -2.4,5.6c0,2 0.3,1.6 1,3.4c0.5,1.8 0.8,4.4 0.8,4.6c0.133,0.2 0.3,0.1 0.5,-0.3l0.1,-13.3Z"
      style="fill: #393939; fill-rule: nonzero"
    />
    <path
      d="M242,230.5c0,0 -2.2,3.3 -2,5.2c0.1,1.9 0.4,1.8 1,3.5c0.6,1.7 0.7,4.4 0.7,4.4c0,0 0.7,-0.2 1.5,-0.8l1.5,-1.7l-0.8,-1.7l-0.6,-1.5l-0.6,-1l0.2,-3.1l0.6,-2.4l0,-0.8l-1.5,-0.1Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M253.8,236.3l-1.6,-0.5c-0.4,-0.3 -0.6,-1 -0.6,-1l0.3,-0.6l1.9,2.1Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M242.4,230.8c0,0 -1.5,3.4 -1.4,5.8c0.253,1.852 0.828,3.646 1.7,5.3l0,-7.7l0.7,-2.3l0,-1.2l-1,0.1Z"
      style="fill: #9f9f9f; fill-rule: nonzero"
    />
    <path
      d="M246.3,231.6l0,1.4c-0.1,0.5 -1,1 -1.3,1.6l-0.8,2.3c0,0 0.3,-1 0.9,-1.5c0.5,-0.5 0.7,-1 0.8,-0.6c0.1,0.3 0.3,1.6 0.2,1.9c-0.2,0.133 -0.467,0.667 -0.8,1.6c-0.206,0.617 -0.206,1.283 0,1.9l0.4,-1.8c0.2,-0.467 0.367,-0.7 0.5,-0.7l1,1.8l0,-1.5c0.2,-0.7 1,-1.6 1.1,-1.6c0.3,-0 0.6,-0.2 -0.2,-0.6c-0.3,-0.2 -0.1,-3.4 0,-3.6c0.3,-0.1 1.5,-0.1 1.4,-0.6l-1.3,-1.7l-2,1.7l0.1,-0Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M253.6,238.5l-1.2,-0.2l-0.4,-0.5l0,-0.5l1,0.5l0.6,0.7Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M243.6,238.9l-0.5,1.2l-0.3,1.2l-0.3,-2.6l-0.3,-1.9l-0.5,0.5c0,0 0,-1.2 0.2,-1.8c0.333,-0.733 0.4,-1.267 0.2,-1.6c-0.267,0 -0.533,0.2 -0.8,0.6l-0.6,1l0.5,-1.5c0.3,-0.4 1.4,-1.7 1.7,-2.3l0.2,-1l0.8,-0.1c0,0 0.9,0.7 0.9,1.3c0,0.3 -0.9,0.6 -0.9,0.7c0,0.1 -0.7,0 -0.8,2.6c-0.2,2.7 0.5,2.5 0.5,3.7m7.4,-7c0,0 0.2,1.5 0,2c-0.133,0.4 -0.4,0.833 -0.8,1.3c-0.4,0.6 -0.3,2 -0.3,2l0.4,-1l0.5,-0.9c0.2,0 0.433,0.433 0.7,1.3l0.6,2c0,0 -0.2,-1 0,-1c0.2,0 0.4,0 0.8,0.3l0.7,0.6c0,0 0,-0.4 -0.5,-1c-0.5,-0.6 -0.8,-0.4 -1,-1.1c-0.133,-0.8 -0.167,-1.367 -0.1,-1.7c0.067,-0.2 0.3,-0.033 0.7,0.5l1.2,1.1l-0.5,-0.8l0,-2.3c0,-0.867 0.067,-1.467 0.2,-1.8c0.3,-0.2 0.4,-1.2 0.2,-1.4c0,-0.2 -2.8,2 -2.8,2l0,-0.1Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M259.7,228.9c0,0 0,1.6 0.3,2.6l0.9,3c0,0 -0.9,-1.5 -1.3,-2.8c-0.4,-1.4 -0.7,-2.8 -1,-3c-0.4,0 -0.8,0.7 -0.8,1.3c0.065,1.171 0.336,2.322 0.8,3.4c0.5,0.7 -0.7,-1 -1,-1.9l-0.6,-1.7c0,0 -0.3,0.7 -0.2,1.6c0.2,0.9 0.9,2.1 0.9,2.1l-1.3,-1.3c0,0 0,1.2 0.3,1.7l1,1.3l-1,-0.9l-0.4,-0.5c0,0 0.1,1.7 0.5,2.6l1.2,2.3c0,0 -1,-0.7 -1.6,-2.2c-0.605,-2.111 -0.875,-4.305 -0.8,-6.5l1,-1.5c0.4,-0.7 1,-3.8 1,-3.8c0,0 0.6,2.9 1.1,3.5l1,0.7Zm-6.9,-0.9l0.6,1.1l0.5,0.8c0,0 -0.9,1 -1.8,1.7c-0.9,0.7 -2.2,1.5 -2.5,1.1c-0.267,-0.467 -0.367,-0.733 -0.3,-0.8l1.9,-1.5c0.551,-0.466 0.994,-1.046 1.3,-1.7l0.3,-0.7Zm-8.7,2.9c0,0 0.1,1.8 0.9,1.7c0.8,0 3,-2.3 3.1,-2.4c0.2,0 0.3,-0.6 0.3,-0.8l0,-0.6c0,0 -2.5,2.4 -3.3,2.5c-0.382,0.073 -0.773,-0.084 -1,-0.4m0,-2.4l-0.2,1.6l0.2,0.7c0.1,0.1 -1.7,0.6 -2,0c-0.3,-0.6 -0.1,-1.2 -0.1,-1.2l1.2,-0.1c0.4,-0.1 1,-1 1,-1l-0.1,0Zm16.3,-2.5c0,0 0.7,1.8 1.2,2.6l1.1,2.2l-1.5,-1.6l-1,-0.8l0.2,-0.9l0,-1.5Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M241.7,229.6l1,0l0.7,-0.1l0.6,-1c-0,0 -0.3,1.1 -0,2c0.267,0.667 0.533,0.967 0.8,0.9c0.699,-0.111 1.337,-0.465 1.8,-1l1.7,-1.4c-0,0 -0.2,1 0.2,2c0.333,1 0.933,1.167 1.8,0.5c0.8,-0.7 1.6,-1.8 2,-2.3l0.6,-0.8l0.9,-0.7l0.8,-4.4l-0.5,-0.6l-1,0.6l-1.4,-0.6l-0.4,-0.5l-0.8,1.3l-0.8,0.5l-0.4,0l-1,0.3l-0.4,-0.9l-0.2,-0.6l-0.5,-0.2l-2,2l-1,-0.1l-1.1,1.7l-0.8,1l-0.8,2l0.2,0.4Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M251.1,225.2c0,-0 0.2,1 -0.4,2.9c-0.6,1.9 -1.3,3 -1.3,3c0,-0 2,-1.1 2.9,-3.2c1,-2.2 0.7,-4.6 0.7,-4.6l-1.9,1.9Zm2.4,-2c0,-0 0.2,0.3 0,2l-0.6,3.2l0.5,0.9c0.2,0.5 0.9,1.4 1.4,1.3c0.533,-0.133 1.1,-0.733 1.7,-1.8l1,-2.3c0.267,-0.133 0.4,-0.067 0.4,0.2c0,0.267 0.2,1 0.7,1.4c0.5,0.4 1,1 1.4,0.8c0.333,-0.267 0.5,-0.6 0.5,-1l-1,-3.2l-1.3,-3.2l-0.8,-1.2l-2.3,0.2l-1.6,2.7Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M257.4,220.3c0,0 0.6,1.3 0.7,2.8c0.1,1.5 -0.3,3 -0.3,3l0,-3c-0.1,-1.2 -0.6,-1.7 -0.6,-2l0.2,-0.8Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M260.5,226l0,2c-0.2,0.5 -1,-0.5 -1.6,-2.5c-0.5,-2 -0.4,-2.4 -0.8,-3.4l-0.7,-1.8l1.1,-0.2l2,5.9Zm-5.6,3.8c0,0 2.2,-1.3 2.5,-5c0,-1.7 -1,-4.5 -1,-4.5c0,0 0,3 -0.8,5l-1.5,3.1l0.8,-0.5l0.6,-0.9l0,1.3l-0.6,1.5Zm-1.9,-6.5c0,0 0,0.8 -1,1.5c-0.9,0.8 -2.5,1.6 -2.5,1.6c0,0 1.2,-1.1 1.6,-2.1c0.4,-1 0.1,-1.6 0.1,-1.6c0,0 -0.1,0.5 -0.6,1c-0.5,0.5 -1.3,0.4 -1.3,0.4c0,0 0,-0.5 0.5,-1l0.2,-0.6c0.2,-0.8 0.9,-1.9 0.9,-1.9c0,0 0.5,1.2 1,1.7l1.1,1Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M259.8,218.9c0,0 0.5,1.3 0.7,3.2c0.2,1.8 0,4 0,4l-1.4,-2.5l-0.5,-2.3l-0.9,-0.8l-0.8,-0.1c0,0 0.7,-0.3 0.7,-0.9l0,-0.8c0.7,0.272 1.463,0.341 2.2,0.2m-4.9,7.8c0,0 1.2,-1.6 1.5,-3.7c0.3,-2 0,-2.7 0,-2.7c0,0 -0.5,-0.1 -1,-0.5c-0.5,-0.4 -1,-1.4 -1,-1.4c0,0 0.2,1 0,2.4c-0.2,1.4 -1.4,2.5 -1.4,2.5c0,0 0.6,0.2 1.2,-0.1c1.2,-0.7 1,-2 1,-2c0,0 0.3,0.2 0.3,1.8c0,1.6 -0.6,3.7 -0.6,3.7"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M241,229.5c-0.3,0 0.7,-1.6 1.4,-2.7l1.7,-2.7c0,0 0.2,0.2 0.6,0.2c0.817,-0.138 1.542,-0.609 2,-1.3l0.7,-2c0,-0.3 0,1.4 0.8,2.3c0.8,1 0.7,0.9 1,0.8c0,0 0,1.2 -0.3,2.2l-0.6,2.7c0,0 0.1,-2 -0.2,-2.6c-0.3,-0.6 -0.5,0 -0.8,0.8c-0.3,0.7 -0.9,1.2 -0.9,1.2l0.8,-1.8c0.3,-1 0.1,-1 0,-1l-0.5,0.3c-0.4,0.4 -0.633,0.567 -0.7,0.5c-0.1,-0.1 0.4,-0.3 0.6,-0.8c0,-0.5 0.5,-1.2 0.7,-1.4l0.4,-0.8c0,-0.267 -0.067,-0.467 -0.2,-0.6c-0.133,-0.133 -0.5,0.2 -1.1,1c-0.8,0.7 -1,0.7 -1,1l-0.7,2l-0.9,2.3l-0.4,0.4l0.6,-2c0.4,-1 1,-2.5 0.8,-2.7c-0.133,-0.2 -0.3,-0.2 -0.5,0c-0.1,0.2 -1,1.1 -1.7,2.2c-0.7,1.1 -0.7,2.5 -0.9,2.6l-0.7,-0.1Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M260.5,217.7c0,0.1 0.1,1 -0.7,1.2c-0.658,0.197 -1.365,0.161 -2,-0.1l0,-1.2l2.7,0.1Z"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M244.8,220.3l-0.6,1.7c-0.5,1 -1.2,1.7 -1.1,1.8c0.1,0.1 0.5,0.6 1.2,0.5c0.7,-0.1 0.8,-3.8 0.8,-3.8l0,-0.2l-0.3,0Z"
      style="fill: #6e6e6e; fill-rule: nonzero"
    />
    <path
      d="M254.8,218.2c0,-0 -0.4,5 -1.8,5c-1.4,-0 -2,-2.5 -2,-2.5c0,-0 -0.2,3.5 -2,3.5c-0.9,-0 -1.7,-2.7 -1.6,-3.2c0,-0 -0.3,1.8 -1.2,2.5c-1.7,1.4 -2.8,0.7 -2.8,0.5c-0.1,-0.2 1.4,-1.7 1.6,-3.7c0,0.133 0.233,-0.033 0.7,-0.5c0.4,-0.667 0.733,-1.033 1,-1.1c0.5,-0 2.6,-0.9 2.6,-0.9l1,-1.3c0,-0 0.2,0.4 1,-0.1c0.463,-0.359 0.811,-0.846 1,-1.4l2.2,1.8l0.2,1.4l0.1,-0Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M249.1,213.3l2.2,3l0.5,-0.4c0.267,0.4 0.367,0.733 0.3,1c-0.3,0.7 -1,1.8 -0.5,3c-0.067,-0.067 0,-0.567 0.2,-1.5c0.267,-0.8 0.5,-1.133 0.7,-1c0.2,0 0.5,4.6 0.8,4.6c0.3,0 0.7,-2.1 0.7,-3.6c0,-1.5 0.3,-0.3 0.5,0c0.1,0.3 1.4,2.4 2.5,2c1,-0.2 1,-2.2 0.9,-2.6l-0.8,-3l-4.9,-3l-0.4,1.2c-0.3,0.8 -2.7,0.3 -2.7,0.3"
      style="fill: #6e6e6e; fill-rule: nonzero"
    />
    <path
      d="M256,212.8c0,0 0.3,0.3 0.8,1.5c0.5,1.2 0.5,5.1 0,5.1c-0.7,0 -2,-0.7 -2.2,-1.3c-0.2,-0.5 0.1,-2.4 -0.3,-3c-0.458,-0.67 -0.797,-1.414 -1,-2.2l0.1,-1.5l1.1,-0.4l1.6,1.8l-0.1,0Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M255.7,211.6l2,3.1l2,2.6l0.8,0.4c-0.63,0.708 -1.681,0.876 -2.5,0.4c-0.7,-0.4 -0.3,-1.6 -1.2,-3.6c-0.601,-1.202 -1.495,-2.234 -2.6,-3l0.6,-0.5l1,0.6l-0.1,0Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M254.6,210c0,0 1.8,1.1 2.5,2.5l1.8,3.4c0.8,1.3 1.7,1.7 1.6,1.8c-0.067,0.133 -0.4,0.133 -1,0l-1,-1.3l-2,-3.4c-0.541,-0.607 -1.184,-1.114 -1.9,-1.5l1.3,1.7c0.483,0.756 0.791,1.61 0.9,2.5l-1,-1.6c-0.6,-1.2 -2.1,-2.7 -2.2,-2.5l1.2,2.4l1,2.6l-1.4,-2.3c-0.8,-1.3 -1,-1.1 -1.3,-1.5l-1.1,-1.4c0,0 0.7,0.2 1.5,-0.3c0.7,-0.5 1,-1.2 1,-1.2l0.1,0.1Z"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M249.8,213.3c0,0 1.2,0.3 1.9,0.2l0.9,0c0,0 0.4,0.5 0.4,1.1c0,0.6 -0.5,1.7 -0.6,1.8c-0.2,0 -0.2,-1 -0.5,-1.4l-2,-1.7l-0.1,0Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M250.5,216.5c0,0 0.4,1.3 0,3c-0.2,1.9 -1.3,3.7 -1.5,3.7c-0.3,0 -0.2,-2 -0.3,-3l0,-0.4l-0.5,1.2c0,-0.1 0.4,-1.9 0.3,-2l0,-0.7l1.3,-1.6l0.7,-0.2Z"
      style="fill: #6e6e6e; fill-rule: nonzero"
    />
    <path
      d="M248.2,217.8c-0.4,0.5 -1,0.3 -1.4,0.5c-0.5,0.1 -0.7,0.9 -0.7,0.9c-0,0 0.4,-0.3 0.6,-0.2c0.2,0.1 0.4,0 -0,1c-0.4,0.8 -1.8,2.3 -1.7,2.4c-0,0 1.6,-1.3 2,-2c0.6,-0.8 0.5,-1.2 0.6,-1.5c0.1,-0.3 0.7,-0.6 0.9,-0.6c0.133,-0.133 0.3,0.067 0.5,0.6l0.4,2l0.7,-2l0.1,-2.3l-0.5,-0.1l-1.2,-0.7c-0,0 0.2,1.4 -0.3,2"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M254.6,208.6c0,0 0.5,1.3 -0.5,2.1c-0.267,0.267 -0.633,0.433 -1.1,0.5c-0.6,0 -1.4,-0.5 -1.4,-0.5l-3.1,-1.3l-1.7,-0.5l-0.8,-0.2l0.1,-0.9l2.5,0.1l2.4,1l1,0.3l1,0.1l0.6,0l0.6,-0.1l0.3,-0.3l0.1,-0.3Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M254.6,208.6c0.1,0.2 -0.2,1 -0.4,1c-0.2,0.2 -0.733,0.233 -1.6,0.1c-1,-0.2 -1.9,-0.8 -3,-1c-0.933,-0.4 -1.767,-0.6 -2.5,-0.6c-1.1,0 -0.5,-0.4 -0.5,-0.4c0,0 1.9,-0.2 3.5,0.4c1.6,0.6 2.3,1 3.1,1c1.2,0 1.4,-0.5 1.4,-0.5"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M246.1,207.7l0.7,-0l0.5,-0.2l-0.1,0.5l-1,-0l-0.1,-0.3Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M252.2,211.5c-0,0 1.1,1 0.8,2l-2,-1l-3.5,-1.4l-1.8,-0.6l-0.3,-0.3l0.6,-0.6l-0,-0.6l2.3,0.3l2.4,0.7l1.5,1.5Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M249.9,213c0,0 2,2.5 1.5,3.4l-4.5,-3l-1.7,2.7l-3.7,-1.8c0,0 3,-2.3 3.4,-2.8l0.3,-0.6l1.7,0.4l2.7,0.8l0.3,0.9Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M248.8,209.3c0,0 1.6,0.4 2.7,1c1,0.4 2.4,0.6 2.4,0.6c0,0 -0.6,0.6 -1.7,0.6c-0.467,-0.133 -1,-0.467 -1.6,-1c-0.9,-0.8 -2,-0.8 -2,-0.8l0.2,-0.4Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M246,208.4l1.9,0.6c0.7,0.3 0.7,0.2 1,0.2l0.1,-0.2c0,0 0.2,0.7 -0.4,0.7c-0.6,0 -0.7,-0.2 -1.4,-0.5c-0.7,-0.3 -1.2,0 -1.2,0l0,-0.8Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M252.3,212.9c0,0 0.9,0.5 0.7,0.6c-0.133,0.133 -0.567,0.233 -1.3,0.3c-0.6,0 -1.1,-0.067 -1.5,-0.2c-0.6,-0.2 -0.8,-1.1 -2,-1.6l-2.3,-0.8l-1,-0.2l0.8,-0.3l2.6,0.5l2.2,0.7l1.3,0.6l0.5,0.4Zm-4.3,1.5l0.5,2l-0.3,1.3l-0.7,0.4l-0.6,-0.2l-0.2,-0.4c0,0 0.3,-0.5 0,-0.9c-0.3,-0.4 -1.6,-1 -1.6,-1c0,0 0.5,-1 1,-1.2c0.7,-0.2 0.4,-1 0.4,-1l1.5,1Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M245.4,210.2c0,-0 0.4,0.4 1.3,0.5l1.7,0.3c0.2,0.1 0.8,-0.2 0.9,-0.2l-0.5,0.3l2,0.7c0.9,0.4 1.6,1 1.6,1l-1.6,-0.7l-2.4,-0.7c-1.6,-0.3 -3.1,-0.2 -3.5,-0.3c-0.4,-0.1 0.2,-0.1 0.3,-0.3c0.2,-0.267 0.267,-0.467 0.2,-0.6"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M251.2,215.8c-0,0 0.5,0.6 -0,0.8c-0.5,0.2 -2,0.1 -2.6,-0.6l-0.4,-1c-0.3,-0.3 -1.3,-1 -2,-1.3c-0.5,-0.4 0.3,-0.5 0.3,-0.5l2.9,1.3c0.8,0.4 1.8,1.3 1.8,1.3"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M251.3,215.9c0,0 -1,-1.4 -4,-2.6l0.9,-0.2l-1.5,0l-0.7,-0.3c-1.6,-0.4 -1.7,-0.4 -1.8,-0.6c-0.067,-0.133 -0.2,-0.033 -0.4,0.3l-0.6,0.8c0.647,-0.202 1.336,-0.237 2,-0.1c0.8,0.2 1.067,0.5 0.8,0.9c0,0.3 -1.1,1.6 -1,1.6c0.1,0 0.7,-1.2 1.5,-1c0.733,0.267 1.067,0.467 1,0.6l-0.1,-0.7c-0.2,-0.2 -1,-1 -0.8,-1c0.2,0 1.2,0.3 2.6,1c1.4,0.7 1.6,0.9 2,1.3l0.1,-0Z"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M246.5,213.6c0,0 2.2,0.7 2.1,3c0,2.4 -1.8,2 -2,1.1c-0.2,-0.9 0.3,0.4 0.9,0.3c0.667,-0.133 0.933,-0.7 0.8,-1.7c0,-0.8 -0.267,-1.4 -0.8,-1.8l-1,-0.9Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M236.8,208c0,0 0.3,0 -0.4,1.8c-0.391,1.223 -1.039,2.348 -1.9,3.3c-1.8,2 -2.6,2 -2.4,2.8c0.2,0.9 0.9,0.7 1,0.7c0.2,0 3.5,-4.8 3.5,-4.8l0.7,-2.8l-0.2,-0.8l-0.2,-0.3l-0.1,0.1Z"
      style="fill: #414141; fill-rule: nonzero"
    />
    <path
      d="M244.9,204.5c0,0 1,1.4 0.6,4c-0.3,2.7 -3.8,5 -3.8,5l-5,3.6l-2.2,-0.2l-0.6,0l-0.7,-0.4c-0.2,0 -0.4,-1 -0.4,-1l0.6,-0.8l1.9,-1.8l1.1,-1.7c0,0 0.6,-1 0.6,-1.9l-0.1,-1.4l0.4,0.7l0.2,1.4l-0.2,1.6l1.4,-1l1.7,-0.7c0,0 0.5,-0.1 0.9,-1c0.3,-1 0.6,-2.5 0.6,-3.2l0,-1.4l0.2,0c0,0.1 0.5,1 0.5,1.4l0.3,2.2l0.9,-0.8l0.7,-1.2l0.4,-1.4Z"
      style="fill: #a6a6a6; fill-rule: nonzero"
    />
    <path
      d="M245.5,217.8c0,0 0.3,0.2 0.2,1.2c-0.1,1 -1,1.5 -1.3,1.5l0,-1.3l-1.1,-1l-1.2,-0.3l0.2,-0.2c0.1,-0.2 1.4,-0.7 1.4,-0.7l1.8,0.8Z"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M244.6,217.8c0,0 0.3,0.3 0.9,0.2c0.6,-0.1 0.8,-1 0.5,-1.4c-0.3,-0.4 -0.2,0.8 -0.5,1c-0.4,0 -0.8,-1 -1.3,-1c-0.5,-0.2 -1.3,0.2 -1.5,0.5c-0.2,0.3 0.8,0 0.8,0l0.6,0.2l0.4,0.1l0.1,0.4Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M237.2,214.1c-0,0 0.7,0.2 1.4,0.1c0.7,-0.1 2.5,-0.8 2.5,-0.8l1.4,-1c0.6,-0.7 2.5,-1.8 2.7,-4.2c0.2,-2.3 -0.3,-3.7 -0.3,-3.7c-0,0 2.8,3 0.3,6.5c-1.6,2.3 -3,3 -3,3c-0,0 2.8,-0.8 3,-0.1c0.2,0.6 -0.1,1.6 -0.2,1.8c-0,0 1.5,0.3 1.8,1.1c0.1,0.5 -1.8,-0.5 -3.2,-0.2c-0.771,0.192 -1.467,0.61 -2,1.2c-0.533,0.59 -0.3,-0.4 -1.5,-0.4c-1.3,0 -1.9,0.6 -2.6,0.5c-0.7,-0.1 -3,-0.5 -3.4,-1.1l1.5,-1.7c0.7,-1.3 1.6,-1 1.6,-1"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M243,207.8c0,0 1.1,-1 1.5,-1.9l0.4,-1.4c0,0 0.1,0.8 -0.5,1.8l-1.4,1.5Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M242.7,205.4c-0,0 1,3.4 -0,4.9c-1,1.4 -5.1,3.2 -5.1,3.2c-0,0 3.1,-1.7 4,-3.6c1,-2 1,-3.6 1,-3.6l0.1,-0.9Z"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M238.6,214.2c0,-0 1.3,-0 2,-0.5c0.8,-0.4 1.9,-1.4 1.9,-1.4c0,-0 -1,0.9 -1.3,0.9c-0.333,-0.133 -0.467,-0.4 -0.4,-0.8c0.067,-0.4 -0.2,0.7 -0.8,1.1l-1.4,0.7Zm3,-4.3c0,0 1.2,-1.2 1.2,-3.6c0,-2.4 -1,-2 -1,-2c0,0 0.8,0.6 0.6,2.4c-0.1,1.9 -0.7,3.2 -0.7,3.2l-0.1,0Zm1.4,0.2c0,0 1.3,-0.3 1.7,-1c0.5,-0.8 0.5,-2.2 0.5,-2.2c0,0 -0.2,1.3 -0.5,1.8c-0.4,0.5 -1.7,1.4 -1.7,1.4m-0.7,7.6c0,0 0.6,-1.2 1.4,-1c0.9,0.4 0.9,1 0.9,1c0,0 -0.3,-0.4 -1,-0.5l-1.3,0.5Zm-2.4,-2.2l3,-0.8l2.3,-0.8c0,0 -0.9,1 -2.2,1.9c-1.533,0.667 -2.367,0.933 -2.5,0.8c-0.2,-0.2 2.5,-1.1 2.7,-1.6c0,0 -2.4,0.7 -3.3,0.5"
      style="fill: #202020; fill-rule: nonzero"
    />
    <path
      d="M237,212.7c0.342,0.235 0.608,0.564 0.765,0.948c0.439,1.078 -0.086,2.327 -1.163,2.767c-0.66,0.269 -1.414,0.188 -2.002,-0.215"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M236.9,212.9c0.147,0.163 0.264,0.35 0.347,0.553c0.394,0.965 -0.076,2.083 -1.041,2.477c-0.485,0.198 -1.03,0.187 -1.506,-0.03"
      style="fill: #7c7c7c; fill-rule: nonzero"
    />
    <path
      d="M236,214c0.025,-0.002 0.049,-0.003 0.074,-0.003c0.439,-0 0.8,0.361 0.8,0.8c-0,0.438 -0.361,0.8 -0.8,0.8c-0.363,-0 -0.682,-0.247 -0.774,-0.597"
      style="fill-rule: nonzero"
    />
    <path
      d="M236.2,214.9c-0.024,0.119 -0.129,0.205 -0.25,0.205c-0.14,-0 -0.255,-0.115 -0.255,-0.255c0,-0.017 0.002,-0.034 0.005,-0.05c-0.001,-0.009 -0.002,-0.019 -0.002,-0.028c0,-0.11 0.09,-0.2 0.2,-0.2c0.036,0 0.071,0.01 0.102,0.028c0.031,0.018 0.2,0.1 0.2,0.3"
      style="fill: #d0d0d0; fill-rule: nonzero"
    />
    <path
      d="M237.5,211.3c0,0 1.2,-1.2 1.5,-2.8l0,-2.5l0.7,0.7l0.3,1.2l-0.4,2l1.3,-0.6c0.76,-1.552 1.104,-3.275 1,-5c-0.104,-1.725 0.3,0.7 -0.2,3c-0.5,2.3 -0.9,2.6 -2.6,3.6c-1.292,0.793 -2.333,1.938 -3,3.3l-1.9,2.5c0,0 0.9,-1.2 1.3,-2.2c0.8,-1.4 1.267,-2.133 1.4,-2.2l0.6,-1Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M236.9,212.3c0,0 0.5,-1.6 0.5,-2.5c0,-0.9 -0.6,-1.9 -0.6,-1.9c0,0 0.8,0 0.9,1.8c0,2 -0.3,2 -0.8,2.6"
      style="fill: #525252; fill-rule: nonzero"
    />
    <path
      d="M239.3,210.3c0,0 0.6,-1.5 0.6,-2.4c0,-1 -0.8,-1.9 -0.8,-1.9c0,0 1,0.2 1,2c0,1.7 -0.2,1.7 -0.8,2.3"
      style="fill: #2e2e2e; fill-rule: nonzero"
    />
    <path
      d="M233.7,216.8c-0,0 -0.5,-0.6 -0.4,-1c0.1,-0.4 -0,-0.6 1.1,-1.8c0.811,-0.707 1.488,-1.554 2,-2.5c0.3,-0.6 1.2,-2.3 0.5,-3.6c-0,0 0.5,2 -0.6,3.4c-0.738,1.134 -1.649,2.147 -2.7,3c-1,0.7 -1,1 -1,1.4c-0,0.4 0.1,0.667 0.3,0.8l0.8,0.3Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <path
      d="M244.4,220.5c0,0 0.2,0 0.4,-0.3c0.133,-0.267 0.033,-0.667 -0.3,-1.2c-0.332,-0.448 -0.782,-0.794 -1.3,-1l-1.6,-0.2c0,0 0.3,0.6 1,1c0.4,0.2 1,0 1.4,0.3c0.3,0.4 0.4,1.4 0.4,1.4"
      style="fill: #424242; fill-rule: nonzero"
    />
    <path
      d="M244.4,220.5c0,0 1.2,-0.4 1.3,-1.6l-0.1,-1c0,0 0.2,0.4 0.7,0.6l0.4,-0.2c0,0 -0.7,2.3 -2.3,2.2"
      style="fill: #424242; fill-rule: nonzero"
    />
    <path
      d="M235.8,220.3l0.7,0.6l0.7,0.7l3,-0.8l1,-0.9l-0.9,-1.3l-2.1,0l-2.4,1.7Z"
      style="fill: #797979; fill-rule: nonzero"
    />
    <path
      d="M243,219.3l-0.5,-0.8c0,0 -0.2,-0.3 -0.6,-0.5c-0.4,-0.2 -2.2,-0.2 -2.2,-0.2l-1.3,0.2c0,0 -0.4,0.4 -1,0.2l-2.2,-0.7l-1.4,-0.7c0,0 -1.1,-0.4 -1.4,-0.3c-0.2,0 -1,1 -1,1c0,0 -0.3,0.6 0.1,0.6c0.3,0 -0.5,0.2 -0.5,0.2c0,0 -2.3,1.2 -2.6,3.4c-0.3,2.2 3.7,5.5 5.2,3.8c0,0 -2.2,-1.6 -1.8,-3c0.4,-1.333 1.467,-2.1 3.2,-2.3c1.7,0 1.8,-0.3 2.6,-0.8c0.7,-0.6 2.1,-0.9 3.2,0.2c1,1.1 -4,2.1 -4,2.1l0.6,0.8c0,0 6.1,-2.1 5.6,-3.2Z"
      style="
        fill: #a9a9a9;
        fill-rule: nonzero;
        stroke: #515151;
        stroke-width: 0.3px;
      "
    />
    <path
      d="M231.5,224.5c0,0 -2.5,-0.6 -2.3,-2.9c0.225,-1.488 1.271,-2.728 2.7,-3.2c0.4,-0.1 0.3,-1.3 0.7,-1.4c0.4,-0.1 1.2,0 1.6,0.3c0.3,0.4 1.1,0.7 1.1,0.7c0,0 -4.4,2 -4.5,4.5c0,1.7 0.7,2 0.7,2"
      style="fill: #ededed; fill-rule: nonzero"
    />
    <path
      d="M243,219c0,0 -0.3,0.2 -0.4,0c-0.4,-0.8 -1.5,-1 -2.4,-1c-1.1,0 -1.9,0.4 -2.7,0.4l-1.4,-0.2c-1,0 -2.8,-1.4 -3.3,-1.3c-0.4,0.267 -0.567,0.6 -0.5,1c0,0.2 -0.8,0.3 -1,0c-0.2,-0.3 0.7,-1.4 1.5,-1.4c2.1,0 3.7,1.4 4.7,1.4c1,0 1.3,-0.5 2.7,-0.5c1.4,0 2.8,0.6 2.8,1.6"
      style="fill: #dcdcdc; fill-rule: nonzero"
    />
    <path
      d="M236.2,220.7l1.7,-0.6l1.8,-0.6l-1.6,1l-1.7,0.4l-0.2,-0.2Z"
      style="fill: #393939; fill-rule: nonzero"
    />
    <path
      d="M232.6,225.8c-0.133,0.2 -0.933,-0.1 -2.4,-0.9c-2.2,-1.2 -1.8,-2.5 -1.8,-2.5c0,0 -0.3,-1.5 1.2,-3c1.4,-1.6 1.6,-1.1 1.7,-1l0,0.1l-1.3,1l-0.7,1.1l-0.5,1l0,1l0.7,1.2l2,1.3l1.1,0.7Z"
      style="fill: #a9a9a9; fill-rule: nonzero"
    />
    <path
      d="M231.9,217.2l-0.1,-0.2l0.1,0.2Zm0,-0l0,-0.2l0,0.2Zm0,-0l0,-0.2l-0.2,0.1l0.2,0.1Zm0,-0l-0.2,0.1l0.2,-0.1Zm0,-0l-0.2,-0l0,0.1l0.2,-0.1Zm0,-0l-0.2,-0l0.2,-0Zm0,-0l-0.2,-0.1l0.2,0.1Zm0,-0l-0.2,-0l0.2,-0Zm0,-0l-0.2,-0l0.2,-0Zm0,-0l-0.2,-0l-0.4,0.5l-0.2,0.5c0,0.2 0.1,0.367 0.3,0.5l1.2,-0l0,-0.3l-0.2,-0.1l-0.8,-0l0,-0.3l0.3,-0.4l-0,-0.4Zm-0,0l-0,-0.2l-0.1,-0.2c-0.009,-0.001 -0.019,-0.002 -0.028,-0.002c-0.11,0 -0.2,0.09 -0.2,0.2c0,0.036 0.01,0.071 0.028,0.102l0.3,0.1Z"
      style="fill: #545454; fill-rule: nonzero"
    />
    <path
      d="M236.1,219.3l-3,0.9c-0.3,0.2 0.9,0 1.8,0l1.8,0c1.2,-0.5 3.6,-1.4 3.8,-0.4c0.2,1 -3.3,1.7 -3.3,1.7l0,0.3l2.8,-0.7l1.4,-0.7l0.5,-0.8l-1.4,-1l-2,0l-1,0.3l-1.4,0.4Z"
      style="fill: #a9a9a9; fill-rule: nonzero"
    />
    <path
      d="M231.8,223.6c0.2,0.6 0.7,1.5 1.2,1.8c0,0.267 -0.433,0.333 -1.3,0.2c-1,-0.3 -2.4,-0.7 -3.3,-3.3l0,0.5l0.5,1l1,1l1.4,1l1,0.2l0.9,-0.2l0.4,-0.3l-0.9,-0.8l-1,-1.8l0,0.7l0.1,0Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M241.7,250.1l-0,1l-0.6,0l0.1,-1.3l0.5,0.3Zm-3.8,-27.5l-1,-1.1l-0.6,0l1,1.4l0.6,-0.3Z"
      style="fill: #ababab; fill-rule: nonzero"
    />
    <path
      d="M241.6,252.4l-1.3,-0.8l-2,-0.5l0,0.3l0.2,0l1.7,0.5l1.3,0.7l0.1,-0.2Zm0,-2.5l-2.2,0c-0.8,0.267 -1.2,0.467 -1.2,0.6l0.1,0.2c0.6,-0.457 1.35,-0.671 2.1,-0.6l1.1,0l0.1,-0.2Zm-0.3,-2.1l-2,1l-1.4,1l0.2,0.2l0.4,-0.3l0.9,-0.6l2,-1l-0.1,-0.3Zm-1.4,-2.2l-0.2,1l-0.5,0.6l-1.3,1.4l-0.7,0.7l0.1,0.2l1.2,-1.2l0.9,-1l0.5,-0.6c0.267,-0.6 0.367,-0.933 0.3,-1l-0.3,0l0,-0.1Zm-1.7,-1c0.152,0.596 0.117,1.225 -0.1,1.8l-0.8,1.7l-0.4,0.8l-0.1,0.3l0.2,0c0,0 1,-1.7 1.3,-2.7l0.2,-1.2l0,-0.7l-0.3,-0Zm-1.7,-0.2l0,1l-0.1,1.3l-0.5,1.5l-0.3,0.8l0.2,-0l0.8,-2.2c0.2,-0.467 0.267,-0.967 0.2,-1.5l0,-0.9l-0.3,-0Zm-1.3,-0l0,1l-0.1,1.5l-0.4,2l0.2,-0l0.1,-0.6l0.3,-1.3c0.2,-0.9 0.2,-2.6 0.2,-2.6l-0.3,-0Zm-1.3,0.3l0,2.2c-0.3,0.8 -0.4,2 -0.4,2l0.3,-0l0.3,-1.9l0,-2.4l-0.2,0.1Zm-1.1,-0l0,0.2l-0.3,1.8l-0.4,1.5l-0.2,0.8l0.2,0.1l0.7,-2.3l0.2,-1.9l0,-0.1l-0.2,-0l0,-0.1Zm-1.3,0.1l0,0.5c0,0.533 -0.1,1.1 -0.3,1.7c-0.267,0.533 -0.6,0.933 -1,1.2l-0.7,0.5l-0.1,-0l0.1,0.2c0,-0 1.4,-0.8 2,-1.8c0.279,-0.733 0.382,-1.52 0.3,-2.3l-0.3,0Zm-0.7,-0.2l0,0.1l-0.8,1.5l-1,1l-0.5,0.2l-0.2,0.1l0.1,0.3c0,0 1.2,-0.7 1.8,-1.4c0.5,-0.7 0.8,-1.8 0.8,-1.8l-0.2,0Zm-1.2,-0.6l0,0.1l-0.4,0.5c0,0.2 -0.1,0.367 -0.3,0.5l-0.8,0.5l-0.5,0.3l0.1,0.2l0.5,-0.3l0.8,-0.5l0.6,-0.7l0.2,-0.5l-0.2,-0.1Zm-0.6,-0.8l-0.2,0.3l-1.1,1.1l-0.3,0.2l0,0.2l0.6,-0.3l1.2,-1.3l-0.2,-0.2Zm-0.2,-0.5l-0.2,0.2l-0.7,0.4l-0.7,0.3l0,0.3c0.2,0 0.367,-0.067 0.5,-0.2l1.2,-0.8l-0.1,-0.2Zm-0.3,-0.5l-1.4,0.7l0,0.2l0.5,-0.1l1,-0.6l-0.1,-0.2Zm-0.2,-1.1l-0.5,0.4l-0.7,0.3l0,0.2c0.4,0 0.733,-0.133 1,-0.4l0.4,-0.3l-0.2,-0.2Zm0,-1.8l-0.4,0.4l-0.6,0.8l-0.1,0.1l0,0.3l0.2,-0.1l0.1,-0.2c0,-0.2 0.2,-0.433 0.6,-0.7l0.3,-0.2l0.1,-0.2l-0.2,-0.2Zm8.6,-10.2l1.3,-0l0,-0.2l0,0.2l0,-0.1l0,0.1l0,-0.1l0,0.1l0,-0.1l-0.1,0.1l0,-0.1l0,0.1l0,-0.1l-0.1,-0l0.1,-0l-0.1,-0l0,-0.1l0.1,-0l-1.2,-0l0,0.2Zm0,-0.8l0.6,-0.1l0.8,-0.5l0.3,-0.3l0.3,-0l0,-0.3l-0.5,0.2l-0.8,0.5l-0.7,0.3l0,0.2Zm0,-1.2l0.5,-0.2l1,-0.6l0.7,-0.3l0,-0.3l-0.5,0.2l-1,0.6l-0.8,0.4l0,0.2l0.1,0Zm-0.5,-1l1.2,-1l1.3,-0.9l-0.1,-0.2l-1.3,1l-1.2,0.8l0.1,0.3Zm-0.8,-1.3l2.6,-1.9l-0.2,-0.2l-2.6,1.9l0.2,0.2Zm-1.2,-1.3l2.7,-1.8l-0.1,-0.2l-2.7,1.8l0.1,0.2Zm-0.8,-0.7l2.1,-1.5l0.6,-0.4l0,-0.2l-0.7,0.3l-2.2,1.6l0.2,0.2Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M235.6,220.3l2,2c0.867,1.067 1.333,2.167 1.4,3.3l0,0.4c-0.273,1.496 -0.967,2.884 -2,4c-1.5,1.9 -3.8,3.5 -5.6,5.1c-0.9,0.731 -1.707,1.57 -2.4,2.5c-0.609,0.81 -0.958,1.787 -1,2.8l0,0.1c0,1.067 0.333,1.967 1,2.7c0.597,0.834 1.493,1.407 2.5,1.6l0.6,0c1.4,0 3,-0.5 4.5,-0.5c1.2,-0.067 2.367,0.433 3.5,1.5c1,1.1 1.3,2.9 1.3,4.6l-0.3,3.3l-0.3,1.5l0.2,0c0,0 0.7,-2.3 0.7,-4.8c0,-1.7 -0.4,-3.6 -1.4,-4.8c-0.971,-0.992 -2.313,-1.535 -3.7,-1.5c-1.6,0 -3.1,0.4 -4.5,0.4l-0.6,0c-0.944,-0.077 -1.798,-0.597 -2.3,-1.4c-0.537,-0.765 -0.849,-1.666 -0.9,-2.6l0,-0.1c0,-1.267 0.533,-2.433 1.6,-3.5c1.4,-1.6 3.6,-3.2 5.5,-5c2,-1.6 3.6,-3.5 3.9,-6l0,-0.3c0,-1.4 -1,-2.8 -1.9,-3.9l-1.8,-1.7l0,0.3Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M233.7,222.8l-0.3,-0.3l-0.3,0.1l0.5,0.4l0.1,-0.2Zm0.8,0.7l-0.2,-0.2l-0.2,0l0.2,0.3l0.2,-0.1Z"
      style="fill: #979797; fill-rule: nonzero"
    />
    <path
      d="M235.6,224.8l-0.2,-0.3l-0.1,0.2l0.3,0.1Zm0.8,1.3l-0,-0.3l-0.3,0l0.3,0.3Zm0.5,1.1l-0,-0.3l-0.1,0l0.1,0.3Zm-0,1.2l-0,-0.4l-0,0.4Zm-0,0.7l-0,-0.3l-0,0.3Zm-9.7,11.9l0.1,-0.6c0.1,-0.3 -0.2,0.1 -0.2,0.1l-0,0.4l0.1,0l-0,0.1Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M227.1,241.7l0,0.4l0.1,-0l-0.1,-0.4Z"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M227.2,243.1l-0,-0.3l-0.2,0l-0,0.5l0.2,-0.2Z"
      style="fill: #5d5d5d; fill-rule: nonzero"
    />
    <path
      d="M227.3,243.9l0,-0.3l-0.2,0l0,0.3l0.2,0Zm0.2,1.1l-0.1,-0.3l0.1,0.3Zm0.3,1.2l-0.2,-0.4l0,0.4l0.2,0Z"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M228.5,247.8l-0.1,-0.3l-0.2,0l0.3,0.3Zm1.2,1.1l-0.4,-0.3c-0.2,-0.2 -0.1,0.2 -0.1,0.2l0.3,0.2l0.2,-0.1Zm7.8,0.6l-0.3,-0.2l0.2,0.3l-0,-0.1l0.1,0Z"
      style="fill: #979797; fill-rule: nonzero"
    />
    <path
      d="M238.2,250l-0.3,-0.2l-0,0.2l0.3,0Z"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M238.3,250.3l-0.2,0.2l0.3,0.2l-0.1,-0.4Zm-0,1.1l-0,-0.4l-0,0.4Z"
      style="fill: #979797; fill-rule: nonzero"
    />
    <path
      d="M238,252.6l0,-0.3l-0.2,0.3l0.2,0Zm-12,-41.7c0,0 0.5,-0.1 0.1,0.4l0.3,-0.4l-0.2,-0.1l-0.2,0.1Z"
      style="fill: #0f0f0f; fill-rule: nonzero"
    />
    <path
      d="M235.7,220l0.3,0.3l-0.4,-0.1l0.1,-0.2Z"
      style="fill: #a9a9a9; fill-rule: nonzero"
    />
    <path
      d="M236,220.3l-0.6,0l0.2,-0.1l0.4,0.1Z"
      style="fill: #515151; fill-rule: nonzero"
    />
    <path
      d="M240.7,255.3c-0,0 0.4,0 0.5,-0.3c0.2,-0.2 -0,0.3 -0,0.3l-0.3,0.1l-0.2,-0.1Z"
      style="fill: #6b6b6b; fill-rule: nonzero"
    />
    <defs>
      <radialGradient
        id="_Radial1"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.78573,1.17983,-1.15213,2.79992,234.885,267.814)"
      >
        <stop offset="0" style="stop-color: #0f0f0f; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #929292; stop-opacity: 1" />
      </radialGradient>
      <radialGradient
        id="_Radial2"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-0.275661,-2.98743,2.7721,-0.263225,214.228,257.819)"
      >
        <stop offset="0" style="stop-color: #0f0f0f; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #929292; stop-opacity: 1" />
      </radialGradient>
      <radialGradient
        id="_Radial3"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.00364,1.19767,-2.32347,2.00377,290.392,274.461)"
      >
        <stop offset="0" style="stop-color: #0f0f0f; stop-opacity: 1" />
        <stop offset="1" style="stop-color: #929292; stop-opacity: 1" />
      </radialGradient>
    </defs>
  </svg>
</template>
